(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2416,587],{

/***/ 98005:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[channelPath]/affiliate",
      function () {
        return __webpack_require__(160);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 14826:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Auth_AuthModal; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/sunday-component/node_modules/antd/es/form/index.js + 210 modules
var es_form = __webpack_require__(9117);
// EXTERNAL MODULE: ./src/constants/region.ts
var region = __webpack_require__(7951);
// EXTERNAL MODULE: ./src/utils/appForm.ts
var appForm = __webpack_require__(66885);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/constants/otp.ts
var otp = __webpack_require__(3378);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./src/utils/validationRules.tsx + 1 modules
var validationRules = __webpack_require__(95416);
// EXTERNAL MODULE: ./src/constants/appForm.ts
var constants_appForm = __webpack_require__(43250);
// EXTERNAL MODULE: ./src/api/user.ts
var user = __webpack_require__(50101);
// EXTERNAL MODULE: ./src/api/auth.ts
var auth = __webpack_require__(36707);
// EXTERNAL MODULE: ./src/utils/url.ts
var url = __webpack_require__(65934);
// EXTERNAL MODULE: ./src/constants/params.ts
var params = __webpack_require__(62090);
// EXTERNAL MODULE: ./node_modules/antd/lib/grid/hooks/useBreakpoint.js
var useBreakpoint = __webpack_require__(60872);
// EXTERNAL MODULE: ./src/utils/logger.ts + 1 modules
var logger = __webpack_require__(14744);
// EXTERNAL MODULE: ./src/utils/errors.ts
var errors = __webpack_require__(63197);
// EXTERNAL MODULE: ./src/components/Common/Form/TextBoxForm.tsx
var TextBoxForm = __webpack_require__(71085);
// EXTERNAL MODULE: ./src/constants/error.ts
var constants_error = __webpack_require__(74092);
// EXTERNAL MODULE: ./src/constants/auth.ts
var constants_auth = __webpack_require__(28216);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./src/utils/format.ts
var format = __webpack_require__(6767);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/sunday-component/lib/index.js
var lib = __webpack_require__(58960);
// EXTERNAL MODULE: ./node_modules/antd/es/modal/index.js + 7 modules
var modal = __webpack_require__(35865);
// EXTERNAL MODULE: ./node_modules/antd/es/image/index.js + 23 modules
var es_image = __webpack_require__(96422);
// EXTERNAL MODULE: ./src/styles/globals.ts
var globals = __webpack_require__(60082);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/CheckOutlined.js + 1 modules
var CheckOutlined = __webpack_require__(63606);
// EXTERNAL MODULE: ./node_modules/styled-breakpoints/index.js
var styled_breakpoints = __webpack_require__(94698);
// EXTERNAL MODULE: ./src/components/Common/LinkTitle.tsx
var LinkTitle = __webpack_require__(37262);
// EXTERNAL MODULE: ./src/components/Common/Button.tsx
var Button = __webpack_require__(55267);
;// CONCATENATED MODULE: ./src/components/appForm/Otp/OtpLoginV2.style.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #1c7c4e;\n  font-weight: bold;\n  font-size: 17px;\n  line-height: 18px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: 10px;\n  color: #1c7c4e;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-height: 48px;\n  width: 100%;\n  padding: 0px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-height: 48px;\n  width: 100%;\n  padding: 0px;\n  ",
        " {\n    max-width: ",
        ";\n    margin: 0 auto;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 122px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 444px;\n  .ant-modal-content {\n    border-radius: 16px;\n  }\n  .ant-modal-header {\n    border-radius: 16px 16px 0px 0px;\n  }\n  .ant-modal-close {\n    margin-top: 8px;\n  }\n  .ant-modal-body {\n    padding: 0px;\n  }\n  .ant-modal-close {\n    color: red;\n  }\n  ",
        " {\n    top: 0;\n    margin: 0px;\n    padding: 0px;\n    .ant-modal,\n    .ant-modal-content {\n      height: 100vh;\n      width: 100vw;\n      margin: 0;\n      top: 0;\n    }\n    .ant-modal-footer {\n      display: flex;\n      padding: 16px;\n      position: fixed;\n      bottom: 0;\n      width: 100%;\n      background: white;\n    }\n    .ant-modal-content {\n      border-radius: 0px;\n    }\n    .ant-modal-body {\n      overflow: auto;\n      padding: 0px;\n      width: 100vw;\n      height: calc(100vh - 141px);\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 24px 16px 24px 16px;\n  ",
        " {\n    max-width: ",
        ";\n    margin: auto;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  background-image: url("/static/pages/registerOtp/register-otp-banner-bg.svg");\n  background-repeat: no-repeat;\n  background-size: cover;\n  height: 200px;\n  border-radius: 0% 0% 100% 100% / 0% 0% 20% 20%;\n  overflow: hidden;\n  position: relative;\n  padding: 0 16px;\n  ',
        " {\n    height: 155px;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: auto;\n  margin-top: 36px;\n  ",
        " {\n    margin-top: 0px;\n    max-width: ",
        ";\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 175px;\n  position: absolute;\n  ",
        " {\n    height: 130px;\n    bottom: -8px;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: auto;\n  width: fit-content;\n  height: 100%;\n  align-content: center;\n  ",
        " {\n    padding: 24px 16px;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  margin-top: 6px;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  text-align: center;\n  color: ",
        ";\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  display: flex;\n  items: center;\n  width: 24px;\n  height: 100%;\n  right: 0;\n  top: 0;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  gap: 4px;\n  color: ",
        ";\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 24px;\n  margin-bottom: 24px;\n  max-height: fit-content;\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 4px;\n  cursor: pointer;\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  margin-top: 4px;\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0px;\n  .sunday-component-form-item-control {\n    row-gap: 8px;\n  }\n  .sunday-component-form-item-control-input-content > div > div > div > input {\n    width: 100% !important;\n    font-size: 27px;\n    weight: 700;\n    caret-color: ",
        ";\n  }\n  .sunday-component-form-item-control-input-content\n    > div\n    > div\n    > div\n    > input:focus {\n    border-color: ",
        ";\n  }\n  .sunday-component-form-item-control-input-content\n    > div\n    > div\n    > div\n    > input::selection {\n    color: inherit;\n    background: none;\n  }\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}








var maxContentWidth = "343px";
var OtpLoginV2_style_CheckOutlined = (0,styled_components_browser_esm/* default */.ZP)(CheckOutlined/* default */.Z).withConfig({
    componentId: "sc-1a3fa97f-0"
})(_templateObject());
var Verified = (0,styled_components_browser_esm/* default */.ZP)(lib.Title).attrs({
    level: 9
}).withConfig({
    componentId: "sc-1a3fa97f-1"
})(_templateObject1());
var SendOtpButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-1a3fa97f-2"
})(_templateObject2());
var SubmitOtpButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-1a3fa97f-3"
})(_templateObject3(), (0,styled_breakpoints.down)("lg"), maxContentWidth);
var FormItem = (0,styled_components_browser_esm/* default */.ZP)(lib.FormItem).withConfig({
    componentId: "sc-1a3fa97f-4"
})(_templateObject4());
var Space = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1a3fa97f-5"
})(_templateObject5());
var Modal = (0,styled_components_browser_esm/* default */.ZP)(modal/* default */.Z).withConfig({
    componentId: "sc-1a3fa97f-6"
})(_templateObject6(), (0,styled_breakpoints.down)("lg"));
var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1a3fa97f-7"
})(_templateObject7(), (0,styled_breakpoints.down)("lg"), maxContentWidth);
var OtpBannerBg = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1a3fa97f-8"
})(_templateObject8(), (0,styled_breakpoints.down)("lg"));
var OtpBanner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1a3fa97f-9"
})(_templateObject9(), (0,styled_breakpoints.down)("lg"), maxContentWidth);
var OtpBannerImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1a3fa97f-10"
})(_templateObject10(), (0,styled_breakpoints.down)("lg"));
var OtpBannerContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1a3fa97f-11"
})(_templateObject11(), (0,styled_breakpoints.down)("lg"));
var BannerTitle = (0,styled_components_browser_esm/* default */.ZP)(lib.Headline).attrs({
    level: 6
}).withConfig({
    componentId: "sc-1a3fa97f-12"
})(_templateObject12(), globals/* color.white */.$.white);
var BannerSubtitle = (0,styled_components_browser_esm/* default */.ZP)(lib.Body).attrs({
    level: 6
}).withConfig({
    componentId: "sc-1a3fa97f-13"
})(_templateObject13(), globals/* color.white */.$.white);
var ModalTitle = (0,styled_components_browser_esm/* default */.ZP)(lib.Title).attrs({
    level: 5
}).withConfig({
    componentId: "sc-1a3fa97f-14"
})(_templateObject14(), globals/* color.charcoal10 */.$.charcoal10);
var ModalCloseIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1a3fa97f-15"
})(_templateObject15());
var CloseIcon = (0,styled_components_browser_esm/* default */.ZP)(es_image/* default */.Z).withConfig({
    componentId: "sc-1a3fa97f-16"
})(_templateObject16());
var SubtitleBody = (0,styled_components_browser_esm/* default */.ZP)(lib.Body).attrs({
    level: 7
}).withConfig({
    componentId: "sc-1a3fa97f-17"
})(_templateObject17(), globals/* color.charcoal09 */.$.charcoal09);
var SubtitleBold = (0,styled_components_browser_esm/* default */.ZP)(lib.Title).attrs({
    level: 7
}).withConfig({
    componentId: "sc-1a3fa97f-18"
})(_templateObject18());
var InputRow = (0,styled_components_browser_esm/* default */.ZP)(row/* default */.Z).withConfig({
    componentId: "sc-1a3fa97f-19"
})(_templateObject19());
var ButtonTitle = (0,styled_components_browser_esm/* default */.ZP)(lib.Title).withConfig({
    componentId: "sc-1a3fa97f-20"
})(_templateObject20());
var EditButton = (0,styled_components_browser_esm/* default */.ZP)(LinkTitle/* default */.Z).attrs({
    level: 7
}).withConfig({
    componentId: "sc-1a3fa97f-21"
})(_templateObject21());
var ResendButton = (0,styled_components_browser_esm/* default */.ZP)(LinkTitle/* default */.Z).attrs({
    level: 7
}).withConfig({
    componentId: "sc-1a3fa97f-22"
})(_templateObject22());
var ResendWait = (0,styled_components_browser_esm/* default */.ZP)(lib.Title).attrs({
    level: 7
}).withConfig({
    componentId: "sc-1a3fa97f-23"
})(_templateObject23(), globals/* color.charcoal09 */.$.charcoal09);
var OtpField = (0,styled_components_browser_esm/* default */.ZP)(lib.OtpInput).withConfig({
    componentId: "sc-1a3fa97f-24"
})(_templateObject24(), globals/* color.errorRed01 */.$.errorRed01);
var OtpFieldContainer = (0,styled_components_browser_esm/* default */.ZP)(lib.FormItem).withConfig({
    componentId: "sc-1a3fa97f-25"
})(_templateObject25(), globals/* color.carrotOrange */.$.carrotOrange, globals/* color.carrotOrange */.$.carrotOrange);

;// CONCATENATED MODULE: ./src/components/appForm/Otp/OtpLoginModalV2.tsx









var OtpLoginModal = function(param) {
    var disable = param.disable, _loading = param.loading, loading = _loading === void 0 ? false : _loading, otpRef = param.otpRef, otpVerified = param.otpVerified, delay = param.delay, onClickSend = param.onClickSend, onClickSubmit = param.onClickSubmit, target = param.target, form = param.form, isLoading = param.isLoading, otpField = param.otpField, buttonLabels = param.buttonLabels, modalTitle = param.modalTitle, _desktopBreakpoint = param.desktopBreakpoint, desktopBreakpoint = _desktopBreakpoint === void 0 ? false : _desktopBreakpoint;
    var t = (0,useTranslation/* useTranslation */.$)([
        "otp-form",
        "layout"
    ]).t;
    var ref = (0,react.useState)(false), isVisible = ref[0], setIsVisible = ref[1];
    var ref1 = (0,react.useState)(0), count = ref1[0], setCount = ref1[1];
    var isCounting = count !== 0;
    var ref2 = (0,react.useState)(true), disableButton = ref2[0], setDisableButton = ref2[1];
    var inputOtpRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (isCounting) {
            if (count === 0) {
                setCount(0);
            }
            var timer = setInterval(function() {
                setCount(count - 1);
                clearInterval(timer);
            }, 1000);
        }
    }, [
        count,
        isCounting
    ]);
    var sendOtp = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        form.resetFields([
                            otpField
                        ]);
                        return [
                            4,
                            onClickSend(false)
                        ];
                    case 1:
                        _state.sent();
                        setIsVisible(true);
                        return [
                            2
                        ];
                }
            });
        });
        return function sendOtp() {
            return _ref.apply(this, arguments);
        };
    }();
    var resendOtp = function() {
        onClickSend(true);
        setCount(delay);
    };
    var onCancel = function() {
        setIsVisible(false);
    };
    var onEdit = function() {
        setIsVisible(false);
    };
    var verifyOtp = function() {
        onClickSubmit();
    };
    var validateOtp = function(_, value, submitError) {
        if (value && value.length < 6) {
            setDisableButton(true);
            return submitError(/*#__PURE__*/ (0,jsx_runtime.jsx)(TextBoxForm/* TextBoxErrorText */.J9, {
                children: t("otpErrorInvalid")
            }));
        }
        setDisableButton(false);
        return submitError();
    };
    var timerForm = function() {
        var minutes = Math.floor(count / 60) < 10 ? "0".concat(Math.floor(count / 60)) : "".concat(Math.floor(count / 60));
        var seconds = count % 60 < 10 ? "0".concat(count % 60) : "".concat(count % 60);
        return "".concat(minutes, ":").concat(seconds);
    };
    (0,react.useEffect)(function() {
        if (otpVerified) {
            setIsVisible(false);
        }
    }, [
        otpVerified
    ]);
    (0,react.useEffect)(function() {
        var ref;
        (ref = inputOtpRef.current) === null || ref === void 0 ? void 0 : ref.focusInput(0);
    }, [
        isVisible
    ]);
    var _submitButtonLabel, _submitButtonLabel1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SendOtpButton, {
                disabled: disable,
                loading: loading,
                onClick: sendOtp,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonTitle, {
                    level: desktopBreakpoint ? 7 : 8,
                    children: (_submitButtonLabel = buttonLabels.submitButtonLabel) !== null && _submitButtonLabel !== void 0 ? _submitButtonLabel : t("login")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
                visible: isVisible,
                centered: desktopBreakpoint,
                closable: true,
                onCancel: onCancel,
                closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon, {
                    preview: false,
                    src: "/static/pages/planPage/x-icon.svg",
                    alt: "close-icon"
                }),
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalTitle, {
                    children: modalTitle !== null && modalTitle !== void 0 ? modalTitle : t("title")
                }),
                footer: /*#__PURE__*/ (0,jsx_runtime.jsx)(SubmitOtpButton, {
                    onClick: verifyOtp,
                    disabled: disableButton,
                    loading: isLoading,
                    children: (_submitButtonLabel1 = buttonLabels.submitButtonLabel) !== null && _submitButtonLabel1 !== void 0 ? _submitButtonLabel1 : t("submitButton")
                }),
                width: "100vw",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(SubtitleBody, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                        children: t("subtitle")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                                    gutter: 8,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SubtitleBold, {
                                                children: [
                                                    t("subtitleBoldText"),
                                                    " ",
                                                    (0,format/* formatMobileNumber */.IC)(target)
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                            children: !isCounting && /*#__PURE__*/ (0,jsx_runtime.jsx)(EditButton, {
                                                onClick: onEdit,
                                                children: t("editButton")
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SubtitleBody, {
                                            children: [
                                                t("reference"),
                                                ": ",
                                                otpRef
                                            ]
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InputRow, {
                            justify: "space-between",
                            align: "top",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                span: 24,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OtpFieldContainer, {
                                    name: otpField,
                                    rules: [
                                        {
                                            required: true,
                                            message: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextBoxForm/* TextBoxErrorText */.J9, {
                                                children: t("otpErrorRequired")
                                            })
                                        },
                                        {
                                            validator: validateOtp
                                        }, 
                                    ],
                                    validateFirst: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OtpField, {
                                        numInputs: 6,
                                        isInputNum: true,
                                        ref: inputOtpRef
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SubtitleBody, {
                            children: t("resendBody")
                        }),
                        !isCounting ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ResendButton, {
                            onClick: resendOtp,
                            children: t("resendButton")
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(ResendWait, {
                            children: [
                                t("waitResend"),
                                timerForm()
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/appForm/Otp/OtpLoginHelpersV2.tsx












var useLoginOtp = function(param) {
    var active = param.active, method = param.method, form = param.form, code = param.code, field = param.field, lang = param.lang, i18nField = param.i18nField, otpField = param.otpField, errorText = param.errorText, _onFinishVerifying = param.onFinishVerifying, onFinishVerifying = _onFinishVerifying === void 0 ? function() {} : _onFinishVerifying, buttonLabels = param.buttonLabels, modalTitle = param.modalTitle, _desktopBreakpoint = param.desktopBreakpoint, desktopBreakpoint = _desktopBreakpoint === void 0 ? false : _desktopBreakpoint;
    var t = (0,useTranslation/* useTranslation */.$)("layout").t;
    var ref = (0,react.useState)(false), isOtpVerified = ref[0], setIsOtpVerified = ref[1];
    var ref1 = (0,react.useState)(true), isRequestOtpDisable = ref1[0], setIsRequestOtpDisable = ref1[1];
    var ref2 = (0,react.useState)(false), otpLoading = ref2[0], setOtpLoading = ref2[1];
    var ref3 = (0,react.useState)(""), otpRef = ref3[0], setOtpRef = ref3[1];
    var ref4 = (0,react.useState)(0), attempt = ref4[0], setAttempt = ref4[1];
    var ref5 = (0,react.useState)(30), delay = ref5[0], setDelay = ref5[1];
    var ref6 = (0,react.useState)(false), isLoading = ref6[0], setIsLoading = ref6[1];
    var maxShortDelayAttempt = 5;
    var shortDelay = 30;
    var longDelay = 300;
    var onRequestOtp = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(isResend) {
            var mobileNo, res, newOtp, error, isUnknownError;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setOtpLoading(true);
                        if (!(!otpRef || isResend)) return [
                            3,
                            4
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        mobileNo = form.getFieldValue(field);
                        return [
                            4,
                            (0,auth/* sendAuthOtp */.bG)(mobileNo, lang)
                        ];
                    case 2:
                        res = _state.sent();
                        newOtp = res.referenceNumber;
                        setOtpRef(newOtp);
                        setAttempt(attempt + 1);
                        setDelay(attempt < maxShortDelayAttempt ? shortDelay : longDelay);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        isUnknownError = (0,errors/* checkUnknownError */.t)(error);
                        if (isUnknownError) {
                            (0,logger/* logError */.H)("[".concat([
                                code,
                                field,
                                method
                            ], "] send otp fail"), {
                                lang: lang
                            }, error);
                        }
                        setIsRequestOtpDisable(true);
                        form.setFields([
                            {
                                name: otpField,
                                errors: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextBoxForm/* TextBoxErrorText */.J9, {
                                        children: errorText != null ? errorText : t("modal.mobileNo.otpError.notSuccess")
                                    })
                                ]
                            }
                        ]);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        setOtpLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function onRequestOtp(isResend) {
            return _ref.apply(this, arguments);
        };
    }();
    var onSubmitOtp = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var otpNo, mobileNo, payload, res, error, isUnknownError, errorMessage;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsLoading(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        otpNo = form.getFieldValue(otpField);
                        mobileNo = form.getFieldValue(field);
                        payload = {
                            otpNo: otpNo,
                            referenceNo: otpRef,
                            mobileNo: mobileNo,
                            grantType: constants_auth/* GRANT_TYPE.OTP */.k.OTP
                        };
                        return [
                            4,
                            (0,auth/* verifyAuth */.RA)(payload)
                        ];
                    case 2:
                        res = _state.sent();
                        if (!res || res.success === false) {
                            form.setFields([
                                {
                                    name: otpField,
                                    errors: [
                                        t("".concat(i18nField, ".otpError.invalid"))
                                    ]
                                }
                            ]);
                            (0,logger/* logError */.H)("[".concat([
                                field,
                                method
                            ], "]submit otp fail"), {
                                lang: lang,
                                referenceNo: otpRef
                            });
                        } else {
                            setIsOtpVerified(true);
                            onFinishVerifying(!res.isAlreadyRegistered);
                        }
                        setIsLoading(false);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        isUnknownError = (0,errors/* checkUnknownError */.t)(error);
                        if (isUnknownError) {
                            (0,logger/* logError */.H)("[".concat([
                                field,
                                method
                            ], "] submit otp fail"), {
                                lang: lang,
                                referenceNo: otpRef
                            }, error);
                        }
                        errorMessage = t("".concat(i18nField, ".otpError.notSuccess"));
                        switch(error.code){
                            case constants_error/* ERROR_CODE.AUTHENTICATION_ERROR */.B.AUTHENTICATION_ERROR:
                                errorMessage = t("".concat(i18nField, ".otpError.invalid"));
                                break;
                            case constants_error/* BUSINESS_ERROR_CODE.EXPIRED */.b.EXPIRED:
                                errorMessage = t("".concat(i18nField, ".otpError.expired"));
                                break;
                            case constants_error/* BUSINESS_ERROR_CODE.OTP_EXCEED_RETRY_ATTEMP */.b.OTP_EXCEED_RETRY_ATTEMP:
                                errorMessage = t("".concat(i18nField, ".otpError.exceedRetryAttemp"));
                                break;
                            case constants_error/* ERROR_CODE.TECHNICAL_ERROR */.B.TECHNICAL_ERROR:
                                errorMessage = t("".concat(i18nField, ".otpError.unavailable"));
                        }
                        form.setFields([
                            {
                                name: otpField,
                                errors: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextBoxForm/* TextBoxErrorText */.J9, {
                                        children: errorMessage
                                    })
                                ]
                            }
                        ]);
                        setIsLoading(false);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmitOtp() {
            return _ref.apply(this, arguments);
        };
    }();
    var OtpFormSuffix = active && /*#__PURE__*/ (0,jsx_runtime.jsx)(OtpLoginModal, {
        otpField: otpField,
        disable: isRequestOtpDisable,
        loading: otpLoading,
        otpRef: otpRef,
        delay: delay,
        onClickSend: onRequestOtp,
        onClickSubmit: onSubmitOtp,
        otpVerified: isOtpVerified,
        target: form.getFieldValue(field),
        form: form,
        isLoading: isLoading,
        method: method,
        buttonLabels: buttonLabels,
        modalTitle: modalTitle,
        desktopBreakpoint: desktopBreakpoint
    });
    return {
        OtpFormSuffix: OtpFormSuffix,
        setIsRequestOtpDisable: setIsRequestOtpDisable,
        isOtpVerified: isOtpVerified,
        setOtpRef: setOtpRef,
        setIsOtpVerified: setIsOtpVerified
    };
};

// EXTERNAL MODULE: ./src/components/Auth/AuthModal.style.tsx
var AuthModal_style = __webpack_require__(78993);
// EXTERNAL MODULE: ./src/components/appForm/ConsentModal.tsx
var ConsentModal = __webpack_require__(7949);
;// CONCATENATED MODULE: ./src/components/Auth/AuthModal.tsx




























var AuthModal = function(param) {
    var _visible = param.visible, visible = _visible === void 0 ? false : _visible, _onClose = param.onClose, onClose = _onClose === void 0 ? function() {} : _onClose;
    var t = (0,useTranslation/* useTranslation */.$)([
        "layout",
        "error-dialog"
    ]).t;
    var ref = (0,router.useRouter)(), locale = ref.locale, asPath = ref.asPath, reload = ref.reload, push = ref.push, query = ref.query;
    var ref1 = (0,_sliced_to_array/* default */.Z)(es_form/* default.useForm */.Z.useForm(), 1), form = ref1[0];
    var ref2 = (0,react.useState)(false), isLoading = ref2[0], setIsLoading = ref2[1];
    var ref3 = (0,react.useState)(false), isConsentVisible = ref3[0], setIsConsentVisible = ref3[1];
    var ref4 = (0,react.useState)(false), isCancelConsentVisible = ref4[0], setIsCancelConsentVisible = ref4[1];
    var ref5 = (0,react.useState)(false), isWelcomeModalVisible = ref5[0], setIsWelcomeModalVisible = ref5[1];
    var ref6 = (0,react.useState)(false), isErrorModalVisible = ref6[0], setIsErrorModalVisible = ref6[1];
    var xl = (0,useBreakpoint/* default */.Z)().xl;
    var redirectLink = asPath;
    var currentPage = "".concat("https://retail.easysunday.com").concat(asPath);
    var mobileNoField = "mobileNo";
    var consentCode = constants_appForm/* CONSENT_CODE.SUNDAY_TC */.xM.SUNDAY_TC;
    var closeAllModals = function() {
        onClose(false);
        setIsConsentVisible(false);
        setIsCancelConsentVisible(false);
        setIsErrorModalVisible(false);
    };
    var onFinishVerified = function(isRegister) {
        if (isRegister) {
            setIsConsentVisible(true);
        } else {
            reload();
        }
    };
    var ref7 = useLoginOtp({
        active: true,
        method: otp/* OTP_METHOD.SMS */.Q.SMS,
        form: form,
        code: "basic-insured-person",
        field: mobileNoField,
        lang: locale,
        otpField: "mobileOtp",
        i18nField: "modal.mobileNo",
        errorText: undefined,
        urlLink: redirectLink,
        buttonLabels: {
            submitButtonLabel: t("modal.submitButton"),
            verifyButtonLabel: t("modal.submitButton")
        },
        modalTitle: t("modal.title"),
        desktopBreakpoint: xl,
        onFinishVerifying: onFinishVerified
    }), OtpFormSuffixMobile = ref7.OtpFormSuffix, setIsRequestOtpDisable = ref7.setIsRequestOtpDisable, setOtpRefMobile = ref7.setOtpRef, setOtpVerifiedMobile = ref7.setIsOtpVerified;
    var onCancelConsent = function() {
        setIsCancelConsentVisible(true);
    };
    var onAgreeConsent = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var updateConsentsPayload, error, ref, response, issueTitle, message;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsLoading(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        updateConsentsPayload = {
                            consents: (0,_define_property/* default */.Z)({}, consentCode, true)
                        };
                        return [
                            4,
                            (0,user/* updateUser */.N)(updateConsentsPayload)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            (0,user/* createUser */.r)()
                        ];
                    case 3:
                        _state.sent();
                        closeAllModals();
                        setIsWelcomeModalVisible(true);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        response = error.response;
                        issueTitle = "Unknown Error Occurred with status code ".concat(response.status);
                        if (error.code && error.type) {
                            issueTitle = "[".concat(error === null || error === void 0 ? void 0 : error.code, "] ").concat(error === null || error === void 0 ? void 0 : error.type);
                        }
                        message = error.message || (response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.message);
                        setIsErrorModalVisible(true);
                        (0,logger/* logError */.H)(message, response.data, response, issueTitle);
                        return [
                            3,
                            5
                        ];
                    case 5:
                        setIsLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function onAgreeConsent() {
            return _ref.apply(this, arguments);
        };
    }();
    var validateMobileNumber = function(_, value, submitError) {
        if (!region/* MOBILE_NO_PATTERN.test */.DW.test(value)) {
            return submitError(/*#__PURE__*/ (0,jsx_runtime.jsx)(TextBoxForm/* TextBoxErrorText */.J9, {
                children: t("modal.mobileNo.error.pattern")
            }));
        }
        setOtpRefMobile("");
        return submitError();
    };
    var handleOnChangeMobile = function() {
        setOtpVerifiedMobile(false);
    };
    var onFieldsChange = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                if ((0,lodash.isEmpty)(form.getFieldError(mobileNoField))) {
                    setIsRequestOtpDisable(false);
                } else {
                    setIsRequestOtpDisable(true);
                }
                return [
                    2
                ];
            });
        });
        return function onFieldsChange() {
            return _ref.apply(this, arguments);
        };
    }();
    var onCancel = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,auth/* logout */.kS)()
                        ];
                    case 1:
                        _state.sent();
                        reload();
                        return [
                            2
                        ];
                }
            });
        });
        return function onCancel() {
            return _ref.apply(this, arguments);
        };
    }();
    var onGetStart = function() {
        push({
            pathname: "/user/sign-up/personal-profile",
            query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,url/* filterParams */.Lt)(query, params/* GLOBAL_PARAMS */.g_)), {
                r: currentPage
            })
        });
    };
    var onCloseErrorModal = function() {
        closeAllModals();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal_style/* LoginModal */._A, {
                centered: xl,
                visible: visible,
                onCancel: function() {
                    return onClose(false);
                },
                footer: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal_style/* Form */.l0, {
                    "data-testid": "login-otp-form",
                    form: form,
                    onFieldsChange: onFieldsChange,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal_style/* FormItem */.xJ, {
                        children: OtpFormSuffixMobile
                    })
                }),
                closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal_style/* CloseIcon */.Tw, {
                    preview: false,
                    src: "/static/pages/planPage/x-icon.svg",
                    alt: "close-icon"
                }),
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal_style/* ModalTitle */.r6, {
                    children: t("modal.title")
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AuthModal_style/* LoginModalBody */.Fj, {
                    children: [
                        t("modal.subtitle"),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal_style/* Form */.l0, {
                            "data-testid": "login-form",
                            form: form,
                            onFieldsChange: onFieldsChange,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal_style/* FormItem */.xJ, {
                                className: mobileNoField,
                                name: mobileNoField,
                                validateFirst: true,
                                rules: (0,_to_consumable_array/* default */.Z)((0,validationRules/* transformToAntValidations */.p_)([
                                    {
                                        rule: "required"
                                    }
                                ], t, t("modal.mobileNo.label").toLowerCase(), false, TextBoxForm/* TextBoxErrorText */.J9)).concat([
                                    {
                                        validator: validateMobileNumber
                                    }, 
                                ]),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextBoxForm/* default */.ZP, {
                                    type: "number",
                                    onChange: handleOnChangeMobile,
                                    onKeyPress: appForm/* handleOnKeyPressNumberEvent */.$S,
                                    onPaste: appForm/* handleOnPasteNumberEvent */.sP,
                                    placeholder: t("modal.mobileNo.placeholder"),
                                    label: t("modal.mobileNo.label")
                                }, mobileNoField)
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsentModal/* default */.Z, {
                code: consentCode,
                visible: isConsentVisible,
                lang: locale,
                title: t("modal.consent.title"),
                onCloseModal: onCancelConsent,
                footer: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal_style/* SubmitButton */.Mm, {
                    onClick: onAgreeConsent,
                    loading: isLoading,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal_style/* ButtonTitle */.gQ, {
                        children: t("modal.consent.submitButton")
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal_style/* CancelModal */.h4, {
                visible: isCancelConsentVisible,
                onCancel: onCancel,
                centered: true,
                closable: false,
                maskClosable: false,
                footer: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal_style/* SubmitButton */.Mm, {
                        onClick: function() {
                            return setIsCancelConsentVisible(false);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal_style/* ButtonTitle */.gQ, {
                            children: t("modal.cancelConsent.submitButton")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal_style/* SubmitButton */.Mm, {
                        onClick: onCancel,
                        type: "outlined",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal_style/* ButtonTitle */.gQ, {
                            children: t("modal.cancelConsent.cancelButton")
                        })
                    }), 
                ],
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal_style/* ModalTitle */.r6, {
                    children: t("modal.cancelConsent.title")
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal_style/* CancelModalBody */.kU, {
                    children: t("modal.cancelConsent.subtitle")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AuthModal_style/* WelcomeModal */.Pe, {
                visible: isWelcomeModalVisible,
                centered: true,
                closable: false,
                maskClosable: false,
                footer: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal_style/* SubmitButton */.Mm, {
                        onClick: onGetStart,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal_style/* ButtonTitle */.gQ, {
                            children: t("modal.welcome.button")
                        })
                    }), 
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal_style/* WelcomeBanner */.cv, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal_style/* WelcomeBannerImage */.z7, {
                            preview: false,
                            src: "/static/pages/registerOtp/register-welcome.svg",
                            alt: "welcome-image"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(AuthModal_style/* WelcomeModalBody */.t_, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal_style/* ModalTitle */.r6, {
                                children: t("modal.welcome.title")
                            }),
                            t("modal.welcome.subtitle")
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal_style/* ErrorModal */.Cv, {
                title: t("error-dialog:title"),
                description: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal_style/* ErrorModalBody */.D, {
                    children: t("error-dialog:description")
                }),
                errorButtons: [
                    {
                        text: t("error-dialog:closeButton"),
                        onClick: function() {
                            return onCloseErrorModal();
                        }
                    }, 
                ],
                isVisible: isErrorModalVisible,
                width: "303px"
            })
        ]
    });
};
/* harmony default export */ var Auth_AuthModal = (AuthModal);


/***/ }),

/***/ 94665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20414);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var src_api_auth__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36707);
/* harmony import */ var src_constants_layout__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(435);
/* harmony import */ var src_constants_logicalGroupChannelCode__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85760);










// allow user or guest to access this page
// if user is authorized, header will display user header with user data to child component.
// if user not authorized, header will display guest header and able to log in/sign up.
var withUserOrGuest = function(WrappedComponent) {
    return function(props) {
        var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
        var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), user = ref[0], setUser = ref[1];
        var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isLoadSuccess = ref1[0], setIsLoadSuccess = ref1[1];
        var isRetail = src_constants_logicalGroupChannelCode__WEBPACK_IMPORTED_MODULE_3__/* .LOGICAL_GROUP_CHANNEL_CODE */ .V === src_constants_logicalGroupChannelCode__WEBPACK_IMPORTED_MODULE_3__/* .RETAIL_LOGICAL_GROUP_CHANNEL_CODE */ .b;
        (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
            var fetchGetProfile = function() {
                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
                    var result, err;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    (0,src_api_auth__WEBPACK_IMPORTED_MODULE_6__/* .getUserProfile */ .et)()
                                ];
                            case 1:
                                result = _state.sent();
                                setUser(result);
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                setUser(null);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                setIsLoadSuccess(true);
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function fetchGetProfile() {
                    return _ref.apply(this, arguments);
                };
            }();
            // fetch user data once only, prevent unnecessary fetch from other state.
            if (!isLoadSuccess) {
                fetchGetProfile();
            }
        }, [
            isLoadSuccess,
            router
        ]);
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: isLoadSuccess && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrappedComponent, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props), {
                user: user,
                headerType: isRetail ? src_constants_layout__WEBPACK_IMPORTED_MODULE_9__/* .HEADER_TYPE.PROFILE */ .N.PROFILE : src_constants_layout__WEBPACK_IMPORTED_MODULE_9__/* .HEADER_TYPE.PARTNER */ .N.PARTNER
            }))
        });
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (withUserOrGuest);


/***/ }),

/***/ 5626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l": function() { return /* binding */ Carousel; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/antd/lib/grid/hooks/useBreakpoint.js
var useBreakpoint = __webpack_require__(60872);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/antd/es/carousel/index.js + 9 modules
var carousel = __webpack_require__(61980);
// EXTERNAL MODULE: ./src/styles/globals.ts
var globals = __webpack_require__(60082);
// EXTERNAL MODULE: ./node_modules/styled-breakpoints/index.js
var styled_breakpoints = __webpack_require__(94698);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
;// CONCATENATED MODULE: ./src/components/Carousel/Carousel.style.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: ",
        "px;\n  height: ",
        "px;\n  width: ",
        "px;\n  border: 1px solid ",
        ";\n  border-radius: 50%;\n  background-color: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  :hover {\n    cursor: pointer;\n  }\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: ",
        "px;\n  height: ",
        "px;\n  width: ",
        "px;\n  border: 1px solid ",
        ";\n  border-radius: 50%;\n  background-color: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  :hover {\n    cursor: pointer;\n  }\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        "px;\n  > .slick-dots {\n    margin: 0px 4px;\n  }\n  > .slick-dots li {\n    width: 8px;\n    margin: 0px 4px;\n  }\n  > .slick-dots li.slick-active {\n    width: 32px;\n    margin: 0px 4px;\n  }\n  > .slick-dots li button {\n    margin-top: ",
        "px;\n    opacity: 1;\n    border-radius: 5px;\n    width: 8px;\n    height: 8px;\n    background: ",
        ";\n  }\n  > .slick-dots li.slick-active button {\n    border-radius: 5px;\n    width: 32px;\n    height: 8px;\n    background: ",
        ";\n  }\n  > .slick-dots li button::before {\n    display: none;\n  }\n  > .slick-dots li.slick-active button::before {\n    display: none;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 359px;\n  > .slick-dots {\n    margin: 0px 4px;\n  }\n  > .slick-dots li {\n    width: 8px;\n    margin: 0px 4px;\n  }\n  > .slick-dots li.slick-active {\n    width: 32px;\n    margin: 0px 4px;\n  }\n  > .slick-dots li button {\n    margin-top: ",
        "px;\n    opacity: 1;\n    border-radius: 5px;\n    width: 8px;\n    height: 8px;\n    background: ",
        ";\n  }\n  > .slick-dots li.slick-active button {\n    border-radius: 5px;\n    width: 32px;\n    height: 8px;\n    background: ",
        ";\n  }\n  > .slick-dots li button::before {\n    display: none;\n  }\n  > .slick-dots li.slick-active button::before {\n    display: none;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var LeftArrowIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e72b1398-0"
})(_templateObject(), function(props) {
    return props.margin;
}, function(props) {
    return props.size;
}, function(props) {
    return props.size;
}, globals/* color.charcoal03 */.$.charcoal03, globals/* color.white */.$.white, (0,styled_breakpoints.down)("md"));
var RightArrowIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e72b1398-1"
})(_templateObject1(), function(props) {
    return props.margin;
}, function(props) {
    return props.size;
}, function(props) {
    return props.size;
}, globals/* color.charcoal03 */.$.charcoal03, globals/* color.white */.$.white, (0,styled_breakpoints.down)("md"));
var DesktopCarousel = (0,styled_components_browser_esm/* default */.ZP)(carousel/* default */.Z).withConfig({
    componentId: "sc-e72b1398-2"
})(_templateObject2(), function(props) {
    return props.width;
}, function(props) {
    return props.slickDotMarginTop;
}, function(props) {
    return props.inactiveDotColor;
}, function(props) {
    return props.activeDotColor;
});
var MobileCarousel = (0,styled_components_browser_esm/* default */.ZP)(carousel/* default */.Z).withConfig({
    componentId: "sc-e72b1398-3"
})(_templateObject3(), function(props) {
    return props.slickDotMarginTop;
}, function(props) {
    return props.inactiveDotColor;
}, function(props) {
    return props.activeDotColor;
});

;// CONCATENATED MODULE: ./src/components/Carousel/Carousel.tsx
/* eslint-disable @next/next/no-img-element */ 




var Carousel = function(param) {
    var children = param.children, itemsLength = param.itemsLength, activeDotColor = param.activeDotColor, inactiveDotColor = param.inactiveDotColor, mobileSlidesPerRow = param.mobileSlidesPerRow, desktopItemWidth = param.desktopItemWidth, arrowSize = param.arrowSize, arrowIconSize = param.arrowIconSize, arrowMargin = param.arrowMargin, containerWidthOffset = param.containerWidthOffset, slickDotMarginTop = param.slickDotMarginTop, centerMode = param.centerMode;
    var sliderRef = (0,react.useRef)(null);
    var containerRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(0), carouselWidth = ref[0], setCarouselWidth = ref[1];
    var lg = (0,useBreakpoint/* default */.Z)().lg;
    var ref1 = (0,react.useState)(3), maxSliderNumber = ref1[0], setMaxSliderNumber = ref1[1];
    var ref2 = (0,react.useState)(0), fillSliderNumber = ref2[0], setFillSliderNumber = ref2[1];
    var onPrevSlide = function() {
        var ref;
        sliderRef === null || sliderRef === void 0 ? void 0 : (ref = sliderRef.current) === null || ref === void 0 ? void 0 : ref.prev();
    };
    var onNextSlide = function() {
        var ref;
        sliderRef === null || sliderRef === void 0 ? void 0 : (ref = sliderRef.current) === null || ref === void 0 ? void 0 : ref.next();
    };
    (0,react.useEffect)(function() {
        var calculateMaxSliderItems = function() {
            if (lg) {
                var ref;
                var containerWidth = (containerRef === null || containerRef === void 0 ? void 0 : (ref = containerRef.current) === null || ref === void 0 ? void 0 : ref.offsetWidth) - containerWidthOffset;
                var sliderNumber = Math.floor(containerWidth / desktopItemWidth) || 1;
                var componentMaxSliderItemNumber = sliderNumber > 3 ? 3 : sliderNumber;
                var maxSliderRenderNumber = Math.min(componentMaxSliderItemNumber > 3 ? 3 : componentMaxSliderItemNumber, itemsLength || 0);
                var fillSliderRenderNumber = itemsLength <= maxSliderRenderNumber || !itemsLength || itemsLength % maxSliderRenderNumber === 0 ? 0 : maxSliderRenderNumber - (itemsLength || 0) % maxSliderRenderNumber;
                setCarouselWidth(containerWidth);
                setMaxSliderNumber(maxSliderRenderNumber);
                setFillSliderNumber(centerMode ? 0 : fillSliderRenderNumber);
            } else {
                setMaxSliderNumber(1);
                setFillSliderNumber(0);
            }
        };
        calculateMaxSliderItems();
        if (window) {
            window.addEventListener("resize", calculateMaxSliderItems);
        }
        return function() {
            if (window) {
                window.removeEventListener("resize", calculateMaxSliderItems);
            }
        };
    }, [
        itemsLength,
        lg,
        desktopItemWidth,
        containerWidthOffset,
        centerMode
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
        justify: lg && itemsLength > maxSliderNumber ? "space-between" : "center",
        align: "middle",
        ref: containerRef,
        children: [
            itemsLength > maxSliderNumber && /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftArrowIcon, {
                onClick: onPrevSlide,
                size: arrowSize,
                margin: arrowMargin,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "/static/arrow-left-icon.svg",
                    alt: "arrow-left-icon",
                    width: arrowIconSize,
                    height: arrowIconSize
                })
            }),
            lg ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(DesktopCarousel, {
                ref: sliderRef,
                slidesToShow: maxSliderNumber,
                activeDotColor: activeDotColor,
                inactiveDotColor: inactiveDotColor,
                slidesToScroll: maxSliderNumber,
                slickDotMarginTop: slickDotMarginTop,
                centerMode: centerMode,
                width: carouselWidth,
                children: [
                    children,
                    Array.from({
                        length: fillSliderNumber
                    }).map(function() {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileCarousel, {
                ref: sliderRef,
                slidesPerRow: mobileSlidesPerRow,
                activeDotColor: activeDotColor,
                inactiveDotColor: inactiveDotColor,
                slickDotMarginTop: slickDotMarginTop,
                children: children
            }),
            itemsLength > maxSliderNumber && /*#__PURE__*/ (0,jsx_runtime.jsx)(RightArrowIcon, {
                onClick: onNextSlide,
                size: arrowSize,
                margin: arrowMargin,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "/static/arrow-right-icon.svg",
                    alt: "arrow-right-icon",
                    width: arrowIconSize,
                    height: arrowIconSize
                })
            })
        ]
    });
};


/***/ }),

/***/ 8051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ Collapse; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var src_styles_globals__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60082);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87379);
/* harmony import */ var sunday_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58960);
/* harmony import */ var sunday_component__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(sunday_component__WEBPACK_IMPORTED_MODULE_2__);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .sunday-component-collapse-header {\n    margin: 0;\n    border-top: 1px solid ",
        ";\n    border-bottom: 0;\n    padding-top: 24px !important;\n  }\n  .sunday-component-collapse-header.sunday-component-collapse-header-collapsible-only {\n    flex-direction: row-reverse;\n    justify-content: space-between;\n  }\n  .sunday-component-collapse-extra {\n    display: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var StyledCollapse = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(sunday_component__WEBPACK_IMPORTED_MODULE_2__.Collapse).withConfig({
    componentId: "sc-e038fc58-0"
})(_templateObject(), src_styles_globals__WEBPACK_IMPORTED_MODULE_4__/* .color.coolGreyCG3 */ .$.coolGreyCG3);
var Collapse = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledCollapse, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props));
};


/***/ }),

/***/ 55267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87379);
/* harmony import */ var sunday_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58960);
/* harmony import */ var sunday_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(sunday_component__WEBPACK_IMPORTED_MODULE_1__);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  &.sunday-component-btn-primary {\n    border-radius: var(--ui-form-button-primary-enabled-border-radius);\n    border-color: var(--ui-form-button-primary-enabled-background-color);\n    background-color: var(--ui-form-button-primary-enabled-background-color);\n    * {\n      color: var(--ui-form-button-primary-enabled-text-color);\n    }\n\n    &:focus {\n      border-radius: var(--ui-form-button-primary-focused-border-radius);\n      border-color: var(--ui-form-button-primary-focused-background-color);\n      background-color: var(--ui-form-button-primary-focused-background-color);\n      * {\n        color: var(--ui-form-button-primary-focused-text-color);\n      }\n    }\n\n    &:hover {\n      border-radius: var(--ui-form-button-primary-hover-border-radius);\n      border-color: var(--ui-form-button-primary-hover-background-color);\n      background-color: var(--ui-form-button-primary-hover-background-color);\n      * {\n        color: var(--ui-form-button-primary-hover-text-color);\n      }\n    }\n\n    &:disabled {\n      border-radius: var(--ui-form-button-primary-disabled-border-radius);\n      border-color: var(--ui-form-button-primary-disabled-background-color);\n      background-color: var(--ui-form-button-primary-disabled-background-color);\n      * {\n        color: var(--ui-form-button-primary-disabled-text-color);\n      }\n    }\n  }\n\n  &.sunday-component-btn-default {\n    border-radius: var(--ui-form-button-secondary-enabled-border-radius);\n    background-color: var(--ui-form-button-secondary-enabled-background-color);\n    border-color: var(--ui-form-button-secondary-enabled-border-color);\n    * {\n      color: var(--ui-form-button-secondary-enabled-text-color);\n    }\n\n    &:hover {\n      border-radius: var(--ui-form-button-secondary-hover-border-radius);\n      background-color: var(--ui-form-button-secondary-hover-background-color);\n      border-color: var(--ui-form-button-secondary-hover-border-color);\n      * {\n        color: var(--ui-form-button-secondary-hover-text-color);\n      }\n    }\n    &:focus {\n      border-radius: var(--ui-form-button-secondary-focused-border-radius);\n      background-color: var(\n        --ui-form-button-secondary-focused-background-color\n      );\n      border-color: var(--ui-form-button-secondary-focused-border-color);\n      * {\n        color: var(--ui-form-button-secondary-focused-text-color);\n      }\n    }\n    &:disabled {\n      border-radius: var(--ui-form-button-secondary-disabled-border-radius);\n      background-color: var(\n        --ui-form-button-secondary-disabled-background-color\n      );\n      border-color: var(--ui-form-button-secondary-disabled-border-color);\n      * {\n        color: var(--ui-form-button-secondary-disabled-text-color);\n      }\n    }\n  }\n\n  &.sunday-component-btn-text {\n    padding: 0px;\n    height: fit-content;\n    width: fit-content;\n    * {\n      color: var(--ui-form-button-text-enabled-text-color);\n    }\n\n    &:hover {\n      * {\n        color: var(--ui-form-button-text-hover-text-color);\n        text-decoration: var(--ui-form-button-text-hover-text-decoration);\n        text-decoration-color: var(--ui-form-button-text-hover-text-color);\n      }\n    }\n    &:focus {\n      * {\n        color: var(--ui-form-button-text-focused-text-color);\n        text-decoration: var(--ui-form-button-text-focused-text-decoration);\n        text-decoration-color: var(--ui-form-button-text-focused-text-color);\n      }\n    }\n    &:disabled {\n      * {\n        color: var(--ui-form-button-text-disabled-text-color);\n        text-decoration: none;\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Button = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(sunday_component__WEBPACK_IMPORTED_MODULE_1__.Button).withConfig({
    componentId: "sc-9d032c65-0"
})(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 34582:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ConfirmDialog_ConfirmDialog; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./node_modules/antd/lib/grid/hooks/useBreakpoint.js
var useBreakpoint = __webpack_require__(60872);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/styles/globals.ts
var globals = __webpack_require__(60082);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/sunday-component/lib/index.js
var lib = __webpack_require__(58960);
// EXTERNAL MODULE: ./node_modules/antd/es/modal/index.js + 7 modules
var modal = __webpack_require__(35865);
// EXTERNAL MODULE: ./src/components/Common/Button.tsx
var Button = __webpack_require__(55267);
;// CONCATENATED MODULE: ./src/components/Common/ConfirmDialog/ConfirmDialog.style.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 4px;\n  text-align: center;\n  color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 8px;\n  text-align: center;\n  color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 16px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .ant-modal-content {\n    border-radius: 12px;\n  }\n  .ant-modal-header {\n    border-radius: 12px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}





var Title = (0,styled_components_browser_esm/* default */.ZP)(lib.Title).attrs({
    level: 5
}).withConfig({
    componentId: "sc-8b4c2d52-0"
})(_templateObject(), globals/* color.charcoal10 */.$.charcoal10);
var Body = (0,styled_components_browser_esm/* default */.ZP)(lib.Body).attrs({
    level: 7
}).withConfig({
    componentId: "sc-8b4c2d52-1"
})(_templateObject1(), globals/* color.charcoal10 */.$.charcoal10);
var ConfirmDialog_style_Button = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).attrs({
    fullWidth: true
}).withConfig({
    componentId: "sc-8b4c2d52-2"
})(_templateObject2());
var Modal = (0,styled_components_browser_esm/* default */.ZP)(modal/* default */.Z).withConfig({
    componentId: "sc-8b4c2d52-3"
})(_templateObject3());

;// CONCATENATED MODULE: ./src/components/Common/ConfirmDialog/ConfirmDialog.tsx






var styles = {
    buttonGroup: {
        marginTop: "16px"
    },
    button: {
        margin: "4px 0px"
    }
};
var ConfirmDialog = function(param) {
    var title = param.title, description = param.description, _isVisible = param.isVisible, isVisible = _isVisible === void 0 ? true : _isVisible, onConfirm = param.onConfirm, onReject = param.onReject, confirmButtonProps = param.confirmButtonProps, rejectButtonProps = param.rejectButtonProps, _confirmText = param.confirmText, confirmText = _confirmText === void 0 ? "Confirm" : _confirmText, _rejectText = param.rejectText, rejectText = _rejectText === void 0 ? "No" : _rejectText, _primaryButtonOnRight = param.primaryButtonOnRight, primaryButtonOnRight = _primaryButtonOnRight === void 0 ? false : _primaryButtonOnRight, _fullWidthButton = param.fullWidthButton, fullWidthButton = _fullWidthButton === void 0 ? false : _fullWidthButton, _centered = param.centered, centered = _centered === void 0 ? false : _centered;
    var sm = (0,useBreakpoint/* default */.Z)().sm;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal, {
        destroyOnClose: true,
        centered: centered,
        width: sm ? "303px" : "auto",
        visible: isVisible,
        footer: null,
        closable: false,
        "data-testid": "confirm-dialog-modal",
        "data-gtm-input-code": "confirm-dialog-modal",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Body, {
                children: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                justify: "center",
                gutter: 8,
                style: styles.buttonGroup,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                        span: fullWidthButton ? 24 : 12,
                        order: primaryButtonOnRight ? 1 : 0,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmDialog_style_Button, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            type: "primary",
                            "data-testid": "confirm-dialog-confirm-button",
                            "data-gtm-input-code": "confirm-dialog-confirm-button",
                            onClick: onConfirm,
                            style: styles.button
                        }, confirmButtonProps), {
                            children: confirmText
                        }))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                        span: fullWidthButton ? 24 : 12,
                        order: primaryButtonOnRight ? 0 : 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmDialog_style_Button, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            type: "outlined",
                            "data-testid": "confirm-dialog-reject-button",
                            "data-gtm-input-code": "confirm-dialog-reject-button",
                            onClick: onReject,
                            style: styles.button
                        }, rejectButtonProps), {
                            children: rejectText
                        }))
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ConfirmDialog_ConfirmDialog = (ConfirmDialog);


/***/ }),

/***/ 77208:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87379);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27049);
/* harmony import */ var src_styles_globals__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60082);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-top: 1px solid ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Divider = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-99dc03f9-0"
})(_templateObject(), src_styles_globals__WEBPACK_IMPORTED_MODULE_3__/* .color.charcoal03 */ .$.charcoal03);
/* harmony default export */ __webpack_exports__["Z"] = (Divider);


/***/ }),

/***/ 85856:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71230);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15746);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96422);
/* harmony import */ var _CheckBoxForm__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96250);



var styles = {
    alertIcon: {
        height: "24px",
        width: "24px",
        marginRight: "10px"
    },
    errorMessage: {
        margin: "8px 0px 0px"
    }
};
var ErrorMessageWithIcon = function(param) {
    var errorMessage = param.errorMessage;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(antd__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        wrap: false,
        style: styles.errorMessage,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                flex: "24px",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    src: "/static/pages/applicationPage/consent-alert-icon.svg",
                    preview: false,
                    style: styles.alertIcon
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                flex: "auto",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CheckBoxForm__WEBPACK_IMPORTED_MODULE_4__/* .CheckBoxErrorText */ .ms, {
                    level: 7,
                    children: errorMessage
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ErrorMessageWithIcon);


/***/ }),

/***/ 9638:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87379);
/* harmony import */ var sunday_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58960);
/* harmony import */ var sunday_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(sunday_component__WEBPACK_IMPORTED_MODULE_1__);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline;\n  color: var(--ui-form-button-text-enabled-text-color);\n  cursor: pointer;\n\n  &:hover {\n    color: var(--ui-form-button-text-hover-text-color);\n    text-decoration: var(--ui-form-button-text-hover-text-decoration);\n    text-decoration-color: var(--ui-form-button-text-hover-text-color);\n    font-weight: var(--ui-form-button-text-hover-text-decoration);\n  }\n  &:focus {\n    color: var(--ui-form-button-text-focused-text-color);\n    text-decoration: var(--ui-form-button-text-focused-text-decoration);\n    text-decoration-color: var(--ui-form-button-text-focused-text-color);\n    font-weight: var(--ui-form-button-text-hover-text-decoration);\n  }\n  &:disabled {\n    color: var(--ui-form-button-text-disabled-text-color);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var LinkBody = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(sunday_component__WEBPACK_IMPORTED_MODULE_1__.Body).withConfig({
    componentId: "sc-69ab8047-0"
})(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (LinkBody);


/***/ }),

/***/ 20587:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* binding */ withLayout; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/antd/es/layout/index.js
var layout = __webpack_require__(97183);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/sunday-component/lib/index.js
var lib = __webpack_require__(58960);
// EXTERNAL MODULE: ./src/constants/logicalGroupChannelCode.ts
var logicalGroupChannelCode = __webpack_require__(85760);
// EXTERNAL MODULE: ./src/constants/region.ts
var region = __webpack_require__(7951);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/styled-breakpoints/index.js
var styled_breakpoints = __webpack_require__(94698);
// EXTERNAL MODULE: ./src/constants/layout.ts
var constants_layout = __webpack_require__(435);
;// CONCATENATED MODULE: ./src/components/Common/Footer/Footer.tsx



var FooterLite = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3003).then(__webpack_require__.bind(__webpack_require__, 73003));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(73003)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var FooterNtl = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8401).then(__webpack_require__.bind(__webpack_require__, 38401));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(38401)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var Footer = function(param) {
    var content = param.content;
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (content === null || content === void 0 ? void 0 : (ref = content.footer) === null || ref === void 0 ? void 0 : ref.template) === "sunday-retail" && /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLite, {
                content: content
            }),
            (content === null || content === void 0 ? void 0 : (ref1 = content.footer) === null || ref1 === void 0 ? void 0 : ref1.template) === "ntl" && /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterNtl, {
                content: content
            })
        ]
    });
};
/* harmony default export */ var Footer_Footer = (Footer);

// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./src/styles/globals.ts
var globals = __webpack_require__(60082);
;// CONCATENATED MODULE: ./src/components/Common/Footer/FooterSimple/FooterSimple.style.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 1192px;\n  margin: auto;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 24px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: max-content;\n  ",
        " {\n    width: auto;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  :hover {\n    color: var(--ui-form-input-footer-link-hover-text-color);\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 210px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}




var FooterContainer = (0,styled_components_browser_esm/* default */.ZP)(lib.Container).withConfig({
    componentId: "sc-34df04f1-0"
})(_templateObject());
var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-34df04f1-1"
})(_templateObject1());
var TextContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-34df04f1-2"
})(_templateObject2(), (0,styled_breakpoints.down)("sm"));
var TextBody = (0,styled_components_browser_esm/* default */.ZP)(lib.Body).withConfig({
    componentId: "sc-34df04f1-3"
})(_templateObject3(), globals/* color.charcoal10 */.$.charcoal10);
var TextLinkBody = (0,styled_components_browser_esm/* default */.ZP)(lib.Body).withConfig({
    componentId: "sc-34df04f1-4"
})(_templateObject4());
var CopyRightContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-34df04f1-5"
})(_templateObject5());

;// CONCATENATED MODULE: ./src/components/Common/Footer/FooterSimple/FooterSimple.tsx




var FooterSimple = function(param) {
    var content = param.content;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var router = (0,next_router.useRouter)();
    var locale = router.locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                gutter: [
                    16,
                    16
                ],
                justify: "space-between",
                children: [
                    (content === null || content === void 0 ? void 0 : content.copyright) && /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextContainer, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyRightContainer, {
                                children: (content === null || content === void 0 ? void 0 : content.copyright) && /*#__PURE__*/ (0,jsx_runtime.jsx)(TextBody, {
                                    level: 7,
                                    children: content === null || content === void 0 ? void 0 : content.copyright
                                })
                            })
                        })
                    }),
                    (content === null || content === void 0 ? void 0 : (ref = content.broker_license) === null || ref === void 0 ? void 0 : ref.enabled) && /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextContainer, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: content === null || content === void 0 ? void 0 : (ref1 = content.broker_license) === null || ref1 === void 0 ? void 0 : ref1.link,
                                target: "blank",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextBody, {
                                    level: 7,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextLinkBody, {
                                        level: 7,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: content === null || content === void 0 ? void 0 : (ref2 = content.broker_license) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.body) === null || ref3 === void 0 ? void 0 : ref3[locale]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: content === null || content === void 0 ? void 0 : (ref4 = content.broker_license) === null || ref4 === void 0 ? void 0 : ref4.license_no
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    }),
                    (content === null || content === void 0 ? void 0 : (ref5 = content.onlineSellingLicense) === null || ref5 === void 0 ? void 0 : ref5.enabled) && /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextContainer, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: content === null || content === void 0 ? void 0 : (ref6 = content.onlineSellingLicense) === null || ref6 === void 0 ? void 0 : ref6.link,
                                target: "blank",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextBody, {
                                    level: 7,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextLinkBody, {
                                        level: 7,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: content === null || content === void 0 ? void 0 : (ref7 = content.onlineSellingLicense) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.body) === null || ref8 === void 0 ? void 0 : ref8[locale]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: content === null || content === void 0 ? void 0 : (ref9 = content.onlineSellingLicense) === null || ref9 === void 0 ? void 0 : ref9.licenseNo
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var FooterSimple_FooterSimple = (FooterSimple);

;// CONCATENATED MODULE: ./src/components/Common/Footer/RetailFooter.tsx





var SundayFooter = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.t.bind(__webpack_require__, 58960, 23)).then(function(mod) {
        return mod.Footer;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(58960)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var RetailFooter = function(param) {
    var content = param.content, footerType = param.footerType;
    switch(footerType){
        case constants_layout/* FOOTER_TYPE.MENU */.K.MENU:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SundayFooter, {
                company: "TH-SDB"
            });
        case constants_layout/* FOOTER_TYPE.LITE */.K.LITE:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SundayFooter, {
                company: "TH-SDB",
                type: "lite"
            });
        case constants_layout/* FOOTER_TYPE.SIMPLE */.K.SIMPLE:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterSimple_FooterSimple, {
                content: content
            });
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
};
/* harmony default export */ var Footer_RetailFooter = (RetailFooter);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
;// CONCATENATED MODULE: ./src/components/Common/Header/index.tsx
/* eslint-disable consistent-return */ 




var MenuHeader = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4456), __webpack_require__.e(1747), __webpack_require__.e(9782), __webpack_require__.e(7572), __webpack_require__.e(9953), __webpack_require__.e(7752), __webpack_require__.e(1549), __webpack_require__.e(3436), __webpack_require__.e(8792), __webpack_require__.e(7131), __webpack_require__.e(6031), __webpack_require__.e(282)]).then(__webpack_require__.bind(__webpack_require__, 10282));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(10282)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var PartnerHeader = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3991).then(__webpack_require__.bind(__webpack_require__, 43991));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(43991)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var ProfileHeader = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3662), __webpack_require__.e(4456), __webpack_require__.e(1747), __webpack_require__.e(9782), __webpack_require__.e(7572), __webpack_require__.e(9953), __webpack_require__.e(7752), __webpack_require__.e(1509), __webpack_require__.e(3917), __webpack_require__.e(768), __webpack_require__.e(8837), __webpack_require__.e(5865), __webpack_require__.e(3247), __webpack_require__.e(5518), __webpack_require__.e(1549), __webpack_require__.e(6519), __webpack_require__.e(3436), __webpack_require__.e(8792), __webpack_require__.e(1469), __webpack_require__.e(6422), __webpack_require__.e(2873), __webpack_require__.e(7131), __webpack_require__.e(6485), __webpack_require__.e(9474), __webpack_require__.e(6434), __webpack_require__.e(3570), __webpack_require__.e(7434)]).then(__webpack_require__.bind(__webpack_require__, 87434));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(87434)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var SimpleHeader = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4456), __webpack_require__.e(1747), __webpack_require__.e(9782), __webpack_require__.e(7572), __webpack_require__.e(9953), __webpack_require__.e(7752), __webpack_require__.e(1549), __webpack_require__.e(3436), __webpack_require__.e(8792), __webpack_require__.e(7131), __webpack_require__.e(6031), __webpack_require__.e(797)]).then(__webpack_require__.bind(__webpack_require__, 30797));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(30797)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var Header = function(_param) {
    var type = _param.type, others = (0,_object_without_properties/* default */.Z)(_param, [
        "type"
    ]);
    switch(type){
        case "menu":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuHeader, (0,_object_spread/* default */.Z)({}, others));
        case "profile":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileHeader, (0,_object_spread/* default */.Z)({}, others));
        case "simple":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleHeader, (0,_object_spread/* default */.Z)({}, others));
        case "partner":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerHeader, (0,_object_spread/* default */.Z)({}, others));
    }
};
/* harmony default export */ var Common_Header = (Header);

// EXTERNAL MODULE: ./node_modules/antd/lib/grid/hooks/useBreakpoint.js
var useBreakpoint = __webpack_require__(60872);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/components/Layout/LineBubble.tsx

function LineBubble_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  bottom: 16px;\n  right: 16px;\n  background-color: #06c755;\n  height: 48px;\n  border-radius: 56px;\n  padding: 0px 16px;\n  cursor: pointer;\n  z-index: 9999;\n  ",
        " {\n    bottom: 12px;\n    right: 12px;\n    width: 48px;\n    padding: 0px;\n  }\n"
    ]);
    LineBubble_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function LineBubble_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    LineBubble_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









var Container = (0,styled_components_browser_esm/* default */.ZP)(row/* default */.Z).withConfig({
    componentId: "sc-7d26ff0c-0"
})(LineBubble_templateObject(), (0,styled_breakpoints.down)("md"));
var Title = (0,styled_components_browser_esm/* default */.ZP)(lib.Title).withConfig({
    componentId: "sc-7d26ff0c-1"
})(LineBubble_templateObject1(), globals/* color.white */.$.white);
var LineBubble = function() {
    var text = {
        th: "คุยกับเราผ่าน LINE",
        en: "Chat via LINE "
    };
    var locale = (0,next_router.useRouter)().locale;
    var lg = (0,useBreakpoint/* default */.Z)().lg;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        href: "http://line.me/ti/p/@easysunday",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
            align: "middle",
            justify: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: "/static/line-bubble-icon.svg",
                    height: 40,
                    width: 40,
                    alt: "line"
                }),
                lg && /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                    level: 7,
                    children: text[locale]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Layout/withLayout.tsx


function withLayout_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: 100vh;\n  background: var(--ui-form-background_page-background-color);\n"
    ]);
    withLayout_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function withLayout_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: 66.67vh;\n  ",
        "\n  ",
        " {\n    min-height: fit-content;\n  }\n"
    ]);
    withLayout_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}















var withLayout_Content = layout/* default.Content */.Z.Content;
var withLayout_Container = (0,styled_components_browser_esm/* default */.ZP)(layout/* default */.Z).withConfig({
    componentId: "sc-c0164bec-0"
})(withLayout_templateObject());
var CustomContent = (0,styled_components_browser_esm/* default */.ZP)(withLayout_Content).withConfig({
    componentId: "sc-c0164bec-1"
})(withLayout_templateObject1(), function(param) {
    var contentBackgroundColor = param.contentBackgroundColor;
    return contentBackgroundColor && "background: ".concat(contentBackgroundColor, ";");
}, (0,styled_breakpoints.down)("md"));
var CookieConsent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1696).then(__webpack_require__.bind(__webpack_require__, 31696));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(31696)
            ];
        }
    },
    ssr: false,
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var SundayIndoFooter = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.t.bind(__webpack_require__, 58960, 23)).then(function(mod) {
        return mod.IndoFooter;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(58960)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var withLayout = function(WrappedComponent) {
    return function(props) {
        var ref, ref1;
        var channelConfig = props.channelConfig, _headerType = props.headerType, headerType = _headerType === void 0 ? constants_layout/* HEADER_TYPE.MENU */.N.MENU : _headerType, _footerType = props.footerType, footerType = _footerType === void 0 ? constants_layout/* FOOTER_TYPE.MENU */.K.MENU : _footerType, user = props.user, contentBackgroundColor = props.contentBackgroundColor, channelPathProps = props.channelPath, _isShowFooter = props.isShowFooter, isShowFooter = _isShowFooter === void 0 ? true : _isShowFooter;
        var content = channelConfig.content;
        var router = (0,next_router.useRouter)();
        var locale = router.locale;
        var channelPath = typeof router.query.channelPath === "object" ? (ref = router.query.channelPath) === null || ref === void 0 ? void 0 : ref[0] : router.query.channelPath || channelPathProps;
        var isUseSundayLayout = logicalGroupChannelCode/* LOGICAL_GROUP_CHANNEL_CODE */.V === logicalGroupChannelCode/* RETAIL_LOGICAL_GROUP_CHANNEL_CODE */.b || !content;
        // default header menu type for unknown channel, 404, 500 page
        var isUseDefaultHeaderType = !channelPath;
        var onChangeLanguage = function(language) {
            if (language !== router.locale) {
                router.replace(router.asPath, router.asPath, {
                    locale: language
                });
            }
        };
        var availableLanguages = content === null || content === void 0 ? void 0 : content.supportedLangs.map(function(lang) {
            return lang.code;
        });
        var ref2 = (0,react.useState)(false), footer = ref2[0], setFooter = ref2[1];
        (0,react.useEffect)(function() {
            setTimeout(function() {
                setFooter(isShowFooter);
            }, 800);
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
        // Dev-note: to prevent /default/404, /default/500 pre-render error on build time
        if (locale === "default") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomContent, {
                contentBackgroundColor: contentBackgroundColor,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WrappedComponent, (0,_object_spread/* default */.Z)({}, props))
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(withLayout_Container, {
                children: [
                    (content === null || content === void 0 ? void 0 : (ref1 = content.askUsChatbot) === null || ref1 === void 0 ? void 0 : ref1.enabled) && /*#__PURE__*/ (0,jsx_runtime.jsx)(LineBubble, {}),
                    !isUseSundayLayout && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_Header, {
                                showSwitchLanguage: true,
                                type: "partner",
                                onChangeLanguage: onChangeLanguage,
                                language: locale,
                                theme: "white" // 'orange' | 'white' | 'yellow' | 'grey' | 'coolGreyAndWhite'
                                ,
                                content: content
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomContent, {
                                contentBackgroundColor: contentBackgroundColor,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WrappedComponent, (0,_object_spread/* default */.Z)({}, props))
                            }),
                            !!footer && /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_Footer, {
                                content: content
                            })
                        ]
                    }),
                    isUseSundayLayout && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            region/* REGION */.Xz === region/* REGION_OPTION.TH */.Em.TH && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    headerType === constants_layout/* HEADER_TYPE.PROFILE */.N.PROFILE && channelPath && /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_Header, {
                                        showSwitchLanguage: true,
                                        type: constants_layout/* HEADER_TYPE.PROFILE */.N.PROFILE,
                                        onChangeLanguage: onChangeLanguage,
                                        language: locale,
                                        content: content,
                                        isLogin: !!user,
                                        profile: user === null || user === void 0 ? void 0 : user.profile
                                    }),
                                    (headerType === constants_layout/* HEADER_TYPE.MENU */.N.MENU || isUseDefaultHeaderType) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_Header, {
                                        showSwitchLanguage: true,
                                        type: constants_layout/* HEADER_TYPE.MENU */.N.MENU,
                                        onChangeLanguage: onChangeLanguage,
                                        language: locale,
                                        content: content
                                    }),
                                    headerType === constants_layout/* HEADER_TYPE.SIMPLE */.N.SIMPLE && channelPath && /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_Header, {
                                        showSwitchLanguage: true,
                                        type: constants_layout/* HEADER_TYPE.SIMPLE */.N.SIMPLE,
                                        onChangeLanguage: onChangeLanguage,
                                        language: locale,
                                        content: content
                                    })
                                ]
                            }),
                            region/* REGION */.Xz === region/* REGION_OPTION.ID */.Em.ID && /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Header, {
                                showSwitchLanguage: true,
                                type: "indo",
                                onChangeLanguage: onChangeLanguage,
                                language: locale,
                                theme: "white" // 'orange' | 'white' | 'yellow' | 'grey' | 'coolGreyAndWhite'
                                ,
                                availableLanguages: availableLanguages
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomContent, {
                                contentBackgroundColor: contentBackgroundColor,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WrappedComponent, (0,_object_spread/* default */.Z)({}, props))
                            }),
                            region/* REGION */.Xz === region/* REGION_OPTION.TH */.Em.TH && footer && /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_RetailFooter, {
                                content: content,
                                footerType: footerType
                            }),
                            region/* REGION */.Xz === region/* REGION_OPTION.ID */.Em.ID && footer && /*#__PURE__*/ (0,jsx_runtime.jsx)(SundayIndoFooter, {
                                company: "ID-SDI"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CookieConsent, {})
                        ]
                    })
                ]
            })
        });
    };
};


/***/ }),

/***/ 54444:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ INPUT_CODE; },
/* harmony export */   "n": function() { return /* binding */ RULE_CODE; }
/* harmony export */ });
var INPUT_CODE = {
    EFFECTIVE_DATE: "effectiveDate",
    INSURED_DATE_OF_BIRTH: "insuredDateOfBirth",
    INSURED_GENDER: "insuredGender",
    LEAD_REQUEST: "leadRequest",
    FULL_NAME: "fullName",
    MOBILE_NUMBER: "mobileNumber"
};
var RULE_CODE = {
    REQUIRED: "required",
    TH_ID_CARD: "thIdCard",
    RANGE_FROM_NOW: "rangeFromNow",
    IN: "in",
    CHARACTER_LENGTH: "characterLength",
    BMI: "BMI",
    ONE_BENEFICIARY_PERSON: "oneBeneficiaryPerson",
    OTP: "otp",
    LICENSE_PLATE: "licensePlate",
    AGE_BY_YEAR_0: "ageByYear0",
    AGE_BY_DAY_0: "ageByDay0",
    BENEFICIARY_PERSON_COUNT: "beneficiaryPersonCount"
};


/***/ }),

/***/ 435:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ FOOTER_TYPE; },
/* harmony export */   "N": function() { return /* binding */ HEADER_TYPE; }
/* harmony export */ });
var HEADER_TYPE = {
    MENU: "menu",
    PARTNER: "partner",
    PROFILE: "profile",
    SIMPLE: "simple"
};
var FOOTER_TYPE = {
    MENU: "menu",
    SIMPLE: "simple",
    LITE: "lite"
};


/***/ }),

/***/ 85760:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ LOGICAL_GROUP_CHANNEL_CODE; },
/* harmony export */   "b": function() { return /* binding */ RETAIL_LOGICAL_GROUP_CHANNEL_CODE; }
/* harmony export */ });
/* eslint-disable import/prefer-default-export */ var LOGICAL_GROUP_CHANNEL_CODE = "RET" || 0;
var RETAIL_LOGICAL_GROUP_CHANNEL_CODE = "RET";


/***/ }),

/***/ 7951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DW": function() { return /* binding */ MOBILE_NO_PATTERN; },
/* harmony export */   "Em": function() { return /* binding */ REGION_OPTION; },
/* harmony export */   "Oe": function() { return /* binding */ NATIONALITY_FOR_CID; },
/* harmony export */   "Xz": function() { return /* binding */ REGION; },
/* harmony export */   "z0": function() { return /* binding */ CID_PATTERN; }
/* harmony export */ });
/* unused harmony export CONFIG_BY_REGION */
/* harmony import */ var src_utils_master_data__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26797);
/* harmony import */ var src_utils_regEx__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1982);
var ref, ref1, ref2;


var REGION = ("TH" || 0).toUpperCase();
var REGION_OPTION = {
    TH: "TH",
    ID: "ID"
};
var CONFIG_BY_REGION = {
    TH: {
        mobileNoPattern: src_utils_regEx__WEBPACK_IMPORTED_MODULE_0__/* .TH_MOBILE_NO_PATTERN */ .bx,
        nationalityForCid: src_utils_master_data__WEBPACK_IMPORTED_MODULE_1__.nationality.THAI.name.code,
        cidPattern: src_utils_regEx__WEBPACK_IMPORTED_MODULE_0__/* .TH_CID_PATTERN */ .lJ
    },
    ID: {
        mobileNoPattern: src_utils_regEx__WEBPACK_IMPORTED_MODULE_0__/* .ID_MOBILE_NO_PATTERN */ .OZ,
        nationalityForCid: src_utils_master_data__WEBPACK_IMPORTED_MODULE_1__.nationality.INDONESIA.name.code,
        cidPattern: src_utils_regEx__WEBPACK_IMPORTED_MODULE_0__/* .ID_CID_PATTERN */ .SY
    }
};
var MOBILE_NO_PATTERN = ((ref = CONFIG_BY_REGION[REGION]) === null || ref === void 0 ? void 0 : ref.mobileNoPattern) || src_utils_regEx__WEBPACK_IMPORTED_MODULE_0__/* .ACCEPT_ALL_PATTERN */ .cS;
var NATIONALITY_FOR_CID = (ref1 = CONFIG_BY_REGION[REGION]) === null || ref1 === void 0 ? void 0 : ref1.nationalityForCid;
var CID_PATTERN = ((ref2 = CONFIG_BY_REGION[REGION]) === null || ref2 === void 0 ? void 0 : ref2.cidPattern) || src_utils_regEx__WEBPACK_IMPORTED_MODULE_0__/* .ACCEPT_ALL_PATTERN */ .cS;


/***/ }),

/***/ 160:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ affiliate; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
;// CONCATENATED MODULE: ./src/components/AffiliatePage/style/AffiliatePage.style.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  column-gap: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  width: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0px 24px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var FlexHorizontalContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-947066c-0"
})(_templateObject(), function(props) {
    return props.columnGap;
});
var FlexVerticalContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-947066c-1"
})(_templateObject1(), function(props) {
    return props.rowGap;
});
var SectionContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-947066c-2"
})(_templateObject2());

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/antd/lib/grid/hooks/useBreakpoint.js
var useBreakpoint = __webpack_require__(60872);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/Carousel/Carousel.tsx + 1 modules
var Carousel = __webpack_require__(5626);
// EXTERNAL MODULE: ./src/styles/globals.ts
var globals = __webpack_require__(60082);
;// CONCATENATED MODULE: ./src/components/AffiliatePage/BannerSlider/BannerSlider.tsx


function BannerSlider_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 16px;\n  padding-bottom: 40px;\n  background-color: ",
        ";\n"
    ]);
    BannerSlider_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BannerSlider_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex !important;\n  justify-content: center;\n  align-items: center;\n  padding: 0 8px;\n"
    ]);
    BannerSlider_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-87cfd6ff-0"
})(BannerSlider_templateObject(), globals/* color.charcoal01 */.$.charcoal01);
var BannerContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-87cfd6ff-1"
})(BannerSlider_templateObject1());
var BannerSlider = function() {
    var lg = (0,useBreakpoint/* default */.Z)().lg;
    var bannerUrls = [
        "https://static.easysunday.com/retail/affiliate/content/register-banner-01.png",
        "https://static.easysunday.com/retail/affiliate/content/register-banner-02.png",
        "https://static.easysunday.com/retail/affiliate/content/register-banner-03.png",
        "https://static.easysunday.com/retail/affiliate/content/register-banner-04.png",
        "https://static.easysunday.com/retail/affiliate/content/register-banner-05.png", 
    ];
    // work around: carousel bug display last item first when show 2 items per slide on center mode
    var bannerUrlsDesktop = (0,_to_consumable_array/* default */.Z)(bannerUrls.slice(1)).concat([
        bannerUrls[0]
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        id: "banner-slider",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel/* Carousel */.l, {
            itemsLength: bannerUrls.length,
            activeDotColor: globals/* color.carrotOrange03 */.$.carrotOrange03,
            inactiveDotColor: globals/* color.charcoal03 */.$.charcoal03,
            mobileSlidesPerRow: 1,
            desktopItemWidth: 359,
            arrowSize: 40,
            arrowIconSize: 24,
            containerWidthOffset: 80,
            arrowMargin: -8,
            slickDotMarginTop: 32,
            centerMode: true,
            children: (lg ? bannerUrlsDesktop : bannerUrls).map(function(bannerUrl) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: bannerUrl,
                        alt: "aff-banner",
                        width: 343,
                        height: 343
                    })
                }, bannerUrl);
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/sunday-component/lib/index.js
var lib = __webpack_require__(58960);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/Trans.js + 1 modules
var Trans = __webpack_require__(59251);
;// CONCATENATED MODULE: ./src/components/AffiliatePage/AffiliateDescription.tsx

function AffiliateDescription_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    AffiliateDescription_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var Description = (0,styled_components_browser_esm/* default */.ZP)(lib.Body).attrs({
    level: 7
}).withConfig({
    componentId: "sc-b2eb77a4-0"
})(AffiliateDescription_templateObject(), globals/* color.charcoal09 */.$.charcoal09);
var AffiliateDescription = function() {
    var t = (0,useTranslation/* useTranslation */.$)("affiliate").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionContainer, {
        id: "start-register",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexVerticalContainer, {
            rowGap: "8px",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Headline, {
                    level: 4,
                    children: t("main.title")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* Trans */.c, {
                        children: t("main.subTitle")
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var AffiliatePage_AffiliateDescription = (AffiliateDescription);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./src/components/Common/Toast/Toast.tsx
var Toast = __webpack_require__(24899);
// EXTERNAL MODULE: ./src/components/Common/Divider.tsx
var Divider = __webpack_require__(77208);
// EXTERNAL MODULE: ./src/utils/logger.ts + 1 modules
var logger = __webpack_require__(14744);
// EXTERNAL MODULE: ./src/utils/axiosError.ts
var axiosError = __webpack_require__(61619);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ./src/api/affiliate.ts




var getAffiliateReport = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var res, error, errorUnwrap;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        axios_default().get("/api/affiliate-service/report")
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
                case 2:
                    error = _state.sent();
                    errorUnwrap = (0,axiosError/* axiosErrorUnwrap */.h)(error);
                    throw Object.assign(new Error(errorUnwrap.message), errorUnwrap);
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getAffiliateReport() {
        return _ref.apply(this, arguments);
    };
}();
var registerAffiliate = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(value) {
        var res, error, errorUnwrap;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        axios_default().post("/api/retail/affiliate", value)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
                case 2:
                    error = _state.sent();
                    errorUnwrap = (0,axiosError/* axiosErrorUnwrap */.h)(error);
                    throw Object.assign(new Error(errorUnwrap.message), errorUnwrap);
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function registerAffiliate(value) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./src/utils/format.ts
var format = __webpack_require__(6767);
// EXTERNAL MODULE: ./node_modules/styled-breakpoints/index.js
var styled_breakpoints = __webpack_require__(94698);
// EXTERNAL MODULE: ./node_modules/antd/es/card/index.js + 2 modules
var card = __webpack_require__(97751);
// EXTERNAL MODULE: ./src/components/Common/CustomizationInfoDialog.tsx + 1 modules
var CustomizationInfoDialog = __webpack_require__(49882);
;// CONCATENATED MODULE: ./src/components/AffiliatePage/AffiliateReport/AffiliateReport.style.tsx

function AffiliateReport_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n"
    ]);
    AffiliateReport_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AffiliateReport_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    AffiliateReport_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function AffiliateReport_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    AffiliateReport_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  column-gap: ",
        ";\n  align-items: end;\n  ",
        " {\n    flex-direction: column;\n    gap: 16px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  column-gap: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  ",
        " {\n    width: 100%;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-width: 194px;\n  ",
        " {\n    width: 100%;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 4px;\n  cursor: pointer;\n  width: fit-content;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 16px;\n  overflow: hidden;\n  .ant-card-body {\n    padding: 16px;\n  }\n  .ant-card-head-title {\n    padding: 16px 0;\n  }\n\n  .ant-card-head {\n    padding: 0 16px;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0px;\n  height: fit-content !important;\n  min-width: fit-content !important;\n  max-width: fit-content !important;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 4px;\n  padding: 16px;\n  background-color: ",
        ";\n  height: 100%;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .ant-modal-body > div {\n    padding: 24px;\n    text-align: center;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}






var ReportContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c15fd530-0"
})(AffiliateReport_style_templateObject());
var SubTitle = (0,styled_components_browser_esm/* default */.ZP)(lib.Title).attrs({
    level: 7
}).withConfig({
    componentId: "sc-c15fd530-1"
})(AffiliateReport_style_templateObject1());
var Body = (0,styled_components_browser_esm/* default */.ZP)(lib.Body).attrs({
    level: 7
}).withConfig({
    componentId: "sc-c15fd530-2"
})(AffiliateReport_style_templateObject2(), function(props) {
    return props.color || globals/* color.charcoal10 */.$.charcoal10;
});
var ReportLabel = (0,styled_components_browser_esm/* default */.ZP)(lib.Body).attrs({
    level: 8
}).withConfig({
    componentId: "sc-c15fd530-3"
})(_templateObject3(), globals/* color.carrotOrange03 */.$.carrotOrange03);
var ShareLinkContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c15fd530-4"
})(_templateObject4(), function(props) {
    return props.columnGap;
}, (0,styled_breakpoints.down)("sm"));
var AffiliateReport_style_FlexHorizontalContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c15fd530-5"
})(_templateObject5(), function(props) {
    return props.columnGap;
});
var AffiliateReport_style_FlexVerticalContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c15fd530-6"
})(_templateObject6(), function(props) {
    return props.rowGap;
}, (0,styled_breakpoints.down)("sm"));
var Button = (0,styled_components_browser_esm/* default */.ZP)(lib.Button).withConfig({
    componentId: "sc-c15fd530-7"
})(_templateObject7(), (0,styled_breakpoints.down)("sm"));
var Describe = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c15fd530-8"
})(_templateObject8());
var ReportCard = (0,styled_components_browser_esm/* default */.ZP)(card/* default */.Z).withConfig({
    componentId: "sc-c15fd530-9"
})(_templateObject9());
var ContactButton = (0,styled_components_browser_esm/* default */.ZP)(Button).withConfig({
    componentId: "sc-c15fd530-10"
})(_templateObject10());
var FillBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c15fd530-11"
})(_templateObject11(), globals/* color.charcoal01 */.$.charcoal01);
var DescriptionDialog = (0,styled_components_browser_esm/* default */.ZP)(CustomizationInfoDialog/* default */.Z).withConfig({
    componentId: "sc-c15fd530-12"
})(_templateObject12());
var CodeInfoContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c15fd530-13"
})(_templateObject13());

// EXTERNAL MODULE: ./src/components/Modal/ContactModal.tsx + 1 modules
var ContactModal = __webpack_require__(32);
;// CONCATENATED MODULE: ./src/components/AffiliatePage/ShareLinkTextBox/ShareLinkTextBox.styled.tsx

function ShareLinkTextBox_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 8px;\n  border: 1px solid ",
        ";\n  border-radius: 8px;\n  padding: 12px;\n  width: 100%;\n  cursor: pointer;\n  ",
        " {\n    width: 100%;\n  }\n"
    ]);
    ShareLinkTextBox_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ShareLinkTextBox_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 24px;\n  height: 24px;\n  cursor: pointer;\n"
    ]);
    ShareLinkTextBox_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ShareLinkTextBox_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    ShareLinkTextBox_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ShareLinkTextBox_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  width: calc(100% - 32px);\n  word-break: break-all;\n"
    ]);
    ShareLinkTextBox_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var LinkTextBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ab344cd7-0"
})(ShareLinkTextBox_styled_templateObject(), globals/* color.charcoal03 */.$.charcoal03, (0,styled_breakpoints.down)("sm"));
var StyledCopyIcon = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-ab344cd7-1"
})(ShareLinkTextBox_styled_templateObject1());
var ShareLinkTextBox_styled_SubTitle = (0,styled_components_browser_esm/* default */.ZP)(lib.Title).attrs({
    level: 7
}).withConfig({
    componentId: "sc-ab344cd7-2"
})(ShareLinkTextBox_styled_templateObject2());
var LinkText = (0,styled_components_browser_esm/* default */.ZP)(lib.Title).attrs({
    level: 7
}).withConfig({
    componentId: "sc-ab344cd7-3"
})(ShareLinkTextBox_styled_templateObject3(), globals/* color.carrotOrange */.$.carrotOrange);

;// CONCATENATED MODULE: ./src/components/AffiliatePage/ShareLinkTextBox/ShareLinkTextBox.tsx





var ShareLinkTextBox = function(param) {
    var onWriteClipboard = param.onWriteClipboard, shareLinkUrl = param.shareLinkUrl;
    var t = (0,useTranslation/* useTranslation */.$)([
        "affiliate",
        "common"
    ]).t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexVerticalContainer, {
        rowGap: "8px",
        style: {
            textAlign: "start"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Title, {
                level: 7,
                children: t("report.yourLink")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinkTextBox, {
                onClick: onWriteClipboard,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkText, {
                        children: shareLinkUrl
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCopyIcon, {
                        src: "/static/pages/userProfile/copy.svg",
                        alt: "Copy Logo"
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 7 modules
var esm = __webpack_require__(66934);
// EXTERNAL MODULE: ./src/api/auth.ts
var auth = __webpack_require__(36707);
// EXTERNAL MODULE: ./src/utils/maskData.ts
var maskData = __webpack_require__(65791);
// EXTERNAL MODULE: ./src/components/Common/Button.tsx
var Common_Button = __webpack_require__(55267);
;// CONCATENATED MODULE: ./src/components/AffiliatePage/PayoutSection/PayoutSection.style.tsx

function PayoutSection_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    PayoutSection_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PayoutSection_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    PayoutSection_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PayoutSection_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0px 0px 24px;\n"
    ]);
    PayoutSection_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function PayoutSection_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0px 0px 16px 0px;\n"
    ]);
    PayoutSection_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function PayoutSection_style_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 13px 28px;\n  height: 50px !important;\n"
    ]);
    PayoutSection_style_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function PayoutSection_style_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 24px;\n  margin: 8px 0px 8px;\n"
    ]);
    PayoutSection_style_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function PayoutSection_style_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  vertical-align: top;\n  margin: 0px 0px 0px 8px;\n"
    ]);
    PayoutSection_style_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}




var PayoutSection_style_Body = (0,styled_components_browser_esm/* default */.ZP)(lib.Body).withConfig({
    componentId: "sc-d9059555-0"
})(PayoutSection_style_templateObject(), globals/* color.charcoal10 */.$.charcoal10);
var Title = (0,styled_components_browser_esm/* default */.ZP)(lib.Title).withConfig({
    componentId: "sc-d9059555-1"
})(PayoutSection_style_templateObject1());
var PayoutSection_style_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d9059555-2"
})(PayoutSection_style_templateObject2());
var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d9059555-3"
})(PayoutSection_style_templateObject3());
var PayoutSection_style_Button = (0,styled_components_browser_esm/* default */.ZP)(Common_Button/* default */.Z).withConfig({
    componentId: "sc-d9059555-4"
})(PayoutSection_style_templateObject4());
var InfoSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d9059555-5"
})(PayoutSection_style_templateObject5());
var InfoTitleContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d9059555-6"
})(PayoutSection_style_templateObject6());

;// CONCATENATED MODULE: ./src/components/AffiliatePage/PayoutSection/CheckIcon/CheckIcon.tsx


var CheckIcon = function(param) {
    var correct = param.correct;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: correct ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            alt: "valid-check-icon",
            src: "/static/pages/affiliatePage/green-check.svg",
            width: 24,
            height: 24
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            alt: "not-valid-check-icon",
            src: "/static/pages/affiliatePage/grey-check.svg",
            width: 24,
            height: 24
        })
    });
};
/* harmony default export */ var CheckIcon_CheckIcon = (CheckIcon);

// EXTERNAL MODULE: ./node_modules/golden-master-data/dist/module/util/bank.js
var bank = __webpack_require__(86841);
// EXTERNAL MODULE: ./node_modules/golden-master-data/dist/module/th_sub_district.js
var th_sub_district = __webpack_require__(18893);
// EXTERNAL MODULE: ./node_modules/golden-master-data/dist/module/th_district.js
var th_district = __webpack_require__(60753);
// EXTERNAL MODULE: ./node_modules/golden-master-data/dist/module/th_province.js
var th_province = __webpack_require__(14989);
// EXTERNAL MODULE: ./src/components/Common/ConfirmDialog/ConfirmDialog.tsx + 1 modules
var ConfirmDialog = __webpack_require__(34582);
// EXTERNAL MODULE: ./node_modules/antd/es/modal/index.js + 7 modules
var modal = __webpack_require__(35865);
// EXTERNAL MODULE: ./node_modules/antd/es/divider/index.js
var divider = __webpack_require__(27049);
;// CONCATENATED MODULE: ./src/components/AffiliatePage/PayoutSection/PayoutModal/PayoutModal.style.tsx

function PayoutModal_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  top: 0;\n  margin: 0px;\n  padding: 0px;\n  max-width: 100vw;\n  .ant-modal-header {\n    text-align: center;\n    border-radius: 16px 16px 0px 0px;\n  }\n\n  .ant-modal-body {\n    padding: 0px;\n    overflow: auto;\n  }\n  .ant-modal-footer {\n    padding: 16px;\n  }\n  .ant-modal-content {\n    border-radius: 16px;\n  }\n  .ant-scrolling-effect {\n    width: 0px;\n  }\n  ",
        " {\n    .ant-modal,\n    .ant-modal-content {\n      height: 100vh;\n      max-width: 100vw;\n      margin: 0px;\n      top: 0;\n      padding: 0px;\n    }\n    .ant-modal-body {\n      border-radius: 0;\n      height: calc(100vh - 173px);\n      width: 100vw;\n    }\n    .ant-modal-footer {\n      padding: 16px 16px 32px 16px;\n      position: fixed;\n      bottom: 0;\n      width: 100%;\n      background: white;\n    }\n    .ant-modal-content {\n      overflow: auto;\n      border-radius: 0px;\n    }\n  }\n"
    ]);
    PayoutModal_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PayoutModal_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    PayoutModal_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PayoutModal_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: inherit;\n"
    ]);
    PayoutModal_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function PayoutModal_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 16px;\n"
    ]);
    PayoutModal_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function PayoutModal_style_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: auto;\n"
    ]);
    PayoutModal_style_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function PayoutModal_style_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    PayoutModal_style_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function PayoutModal_style_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 13px 16px;\n  height: 48px !important;\n"
    ]);
    PayoutModal_style_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function PayoutModal_style_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  margin: 16px 0px;\n"
    ]);
    PayoutModal_style_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}






var Modal = (0,styled_components_browser_esm/* default */.ZP)(modal/* default */.Z).withConfig({
    componentId: "sc-4282036-0"
})(PayoutModal_style_templateObject(), (0,styled_breakpoints.down)("xs"));
var PayoutModal_style_Title = (0,styled_components_browser_esm/* default */.ZP)(lib.Title).withConfig({
    componentId: "sc-4282036-1"
})(PayoutModal_style_templateObject1(), globals/* color.charcoal10 */.$.charcoal10);
var ButtonTitle = (0,styled_components_browser_esm/* default */.ZP)(lib.Title).withConfig({
    componentId: "sc-4282036-2"
})(PayoutModal_style_templateObject2());
var PayoutModal_style_Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4282036-3"
})(PayoutModal_style_templateObject3());
var BannerImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-4282036-4"
})(PayoutModal_style_templateObject4());
var ModalBody = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4282036-5"
})(PayoutModal_style_templateObject5());
var PayoutModal_style_Button = (0,styled_components_browser_esm/* default */.ZP)(Common_Button/* default */.Z).withConfig({
    componentId: "sc-4282036-6"
})(PayoutModal_style_templateObject6());
var PopupDivider = (0,styled_components_browser_esm/* default */.ZP)(divider/* default */.Z).withConfig({
    componentId: "sc-4282036-7"
})(PayoutModal_style_templateObject7(), globals/* color.charcoal03 */.$.charcoal03);

// EXTERNAL MODULE: ./src/components/Common/LinkTitle.tsx
var LinkTitle = __webpack_require__(37262);
;// CONCATENATED MODULE: ./src/components/AffiliatePage/PayoutSection/PayoutModal/InfoSection/InfoSection.style.tsx

function InfoSection_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    InfoSection_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function InfoSection_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n"
    ]);
    InfoSection_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function InfoSection_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: inherit;\n"
    ]);
    InfoSection_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function InfoSection_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    InfoSection_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function InfoSection_style_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    InfoSection_style_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function InfoSection_style_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0px 0px 16px 0px;\n"
    ]);
    InfoSection_style_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function InfoSection_style_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  margin: 0px 0px 8px; 0px;\n  width: 100%;\n"
    ]);
    InfoSection_style_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function InfoSection_style_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n"
    ]);
    InfoSection_style_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function InfoSection_style_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 24px;\n  vertical-align: top;\n"
    ]);
    InfoSection_style_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function InfoSection_style_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  vertical-align: top;\n  margin: 0px 0px 0px 8px;\n"
    ]);
    InfoSection_style_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function InfoSection_style_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  vertical-align: top;\n"
    ]);
    InfoSection_style_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function InfoSection_style_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 13px 28px;\n  height: 50px !important;\n  margin: 16px 0px 0px 0px;\n"
    ]);
    InfoSection_style_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function InfoSection_style_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 8px 0px 0px 0px;\n"
    ]);
    InfoSection_style_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function InfoSection_style_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0px 16px 0px 0px;\n"
    ]);
    InfoSection_style_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: auto;\n  flex: 1;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}






var InfoSection_style_Title = (0,styled_components_browser_esm/* default */.ZP)(lib.Title).withConfig({
    componentId: "sc-97d3bfdb-0"
})(InfoSection_style_templateObject(), globals/* color.charcoal10 */.$.charcoal10);
var EditTitle = (0,styled_components_browser_esm/* default */.ZP)(LinkTitle/* default */.Z).withConfig({
    componentId: "sc-97d3bfdb-1"
})(InfoSection_style_templateObject1());
var InfoSection_style_ButtonTitle = (0,styled_components_browser_esm/* default */.ZP)(lib.Title).withConfig({
    componentId: "sc-97d3bfdb-2"
})(InfoSection_style_templateObject2());
var InfoSection_style_Body = (0,styled_components_browser_esm/* default */.ZP)(lib.Body).withConfig({
    componentId: "sc-97d3bfdb-3"
})(InfoSection_style_templateObject3(), globals/* color.charcoal09 */.$.charcoal09);
var FieldBody = (0,styled_components_browser_esm/* default */.ZP)(lib.Body).withConfig({
    componentId: "sc-97d3bfdb-4"
})(InfoSection_style_templateObject4(), globals/* color.charcoal10 */.$.charcoal10);
var InfoHeaderContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-97d3bfdb-5"
})(InfoSection_style_templateObject5());
var InfoSection_style_InfoTitleContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-97d3bfdb-6"
})(InfoSection_style_templateObject6());
var FieldSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-97d3bfdb-7"
})(InfoSection_style_templateObject7());
var FieldImageContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-97d3bfdb-8"
})(InfoSection_style_templateObject8());
var FieldTitleContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-97d3bfdb-9"
})(InfoSection_style_templateObject9());
var FieldContentContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-97d3bfdb-10"
})(InfoSection_style_templateObject10());
var InfoSection_style_Button = (0,styled_components_browser_esm/* default */.ZP)(Common_Button/* default */.Z).withConfig({
    componentId: "sc-97d3bfdb-11"
})(InfoSection_style_templateObject11());
var FieldRowContainer = (0,styled_components_browser_esm/* default */.ZP)(row/* default */.Z).withConfig({
    componentId: "sc-97d3bfdb-12"
})(InfoSection_style_templateObject12());
var LeftContainer = (0,styled_components_browser_esm/* default */.ZP)(col/* default */.Z).withConfig({
    componentId: "sc-97d3bfdb-13"
})(InfoSection_style_templateObject13());
var RightContainer = (0,styled_components_browser_esm/* default */.ZP)(col/* default */.Z).withConfig({
    componentId: "sc-97d3bfdb-14"
})(_templateObject14());

;// CONCATENATED MODULE: ./src/components/AffiliatePage/PayoutSection/PayoutModal/InfoSection/InfoSection.tsx




var InfoSection_InfoSection = function(param) {
    var sectionKey = param.sectionKey, sectionI18nKey = param.sectionI18nKey, fields = param.fields, isValid = param.isValid, onEdit = param.onEdit;
    var t = (0,esm/* useTranslation */.$G)("affiliate").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        "data-testid": sectionKey,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoHeaderContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoSection_style_InfoTitleContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoSection_style_Title, {
                                "data-testid": "".concat(sectionKey, "-title"),
                                level: 7,
                                children: t("payout.".concat(sectionI18nKey, ".title"))
                            }),
                            isValid && /*#__PURE__*/ (0,jsx_runtime.jsx)(EditTitle, {
                                "data-testid": "".concat(sectionKey, "-edit-button"),
                                "data-gtm-input-code": "".concat(sectionKey, "-edit-button"),
                                level: 7,
                                onClick: onEdit,
                                children: t("payout.editInfoButton")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoSection_style_Body, {
                        level: 7,
                        children: t("payout.".concat(sectionI18nKey, ".description"))
                    })
                ]
            }),
            fields.map(function(item) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FieldRowContainer, {
                    "data-testid": "".concat(sectionKey, "-").concat(item.key, "-section"),
                    justify: "start",
                    align: "top",
                    wrap: true,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftContainer, {
                            flex: "192px",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FieldSection, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldImageContainer, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckIcon_CheckIcon, {
                                            correct: !!item.value
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldTitleContainer, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoSection_style_Title, {
                                            "data-testid": "".concat(sectionKey, "-").concat(item.key, "-section-title"),
                                            level: 7,
                                            children: t("payout.".concat(sectionI18nKey, ".").concat(item.i18nKey))
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RightContainer, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldBody, {
                                "data-testid": "".concat(sectionKey, "-").concat(item.key, "-section-value"),
                                level: 7,
                                children: item.value || "-"
                            })
                        })
                    ]
                });
            }),
            !isValid && /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoSection_style_Button, {
                "data-testid": "".concat(sectionKey, "-add-button"),
                "data-gtm-input-code": "".concat(sectionKey, "-add-button"),
                fullWidth: true,
                type: "outlined",
                onClick: onEdit,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoSection_style_ButtonTitle, {
                    level: 7,
                    children: t("payout.addInfoButton")
                })
            })
        ]
    });
};
/* harmony default export */ var PayoutModal_InfoSection_InfoSection = (InfoSection_InfoSection);

;// CONCATENATED MODULE: ./src/components/AffiliatePage/PayoutSection/PayoutModal/PayoutModal.tsx










var PayoutModal = function(param) {
    var bankAccountInfo = param.bankAccountInfo, personalInfo = param.personalInfo, addressInfo = param.addressInfo, isBankAccountValid = param.isBankAccountValid, isPersonalValid = param.isPersonalValid, isAddressValid = param.isAddressValid, visible = param.visible, setVisible = param.setVisible;
    var t = (0,esm/* useTranslation */.$G)("affiliate").t;
    var router = (0,next_router.useRouter)();
    var locale = router.locale;
    var xs = (0,useBreakpoint/* default */.Z)().xs;
    var authUrl = "https://auth.easysunday.com";
    var ref = (0,react.useState)(false), confirmDialogVisible = ref[0], setConfirmDialogVisible = ref[1];
    var ref1 = (0,react.useState)(""), editUrl = ref1[0], setEditUrl = ref1[1];
    var bankAccountSectionData = (0,react.useMemo)(function() {
        var ref, ref1;
        var ref2 = bankAccountInfo || {}, bankCode = ref2.bankCode, accountName = ref2.accountName, accountNumber = ref2.accountNumber;
        var region = "TH" || 0;
        var bankList = (0,bank/* getBankByBankCode */.V)(region.toLocaleUpperCase());
        var bankInfo = bankList === null || bankList === void 0 ? void 0 : bankList[bankCode];
        var bankName = bankInfo === null || bankInfo === void 0 ? void 0 : (ref = bankInfo.name) === null || ref === void 0 ? void 0 : (ref1 = ref.localize) === null || ref1 === void 0 ? void 0 : ref1[locale];
        var maskedAccountNumber = accountNumber ? (0,maskData/* maskBankAccountNumber */.cY)(accountNumber) : undefined;
        return [
            {
                key: "bank-name",
                i18nKey: "bankName",
                value: bankName
            },
            {
                key: "account-name",
                i18nKey: "accountName",
                value: accountName
            },
            {
                key: "account-number",
                i18nKey: "accountNumber",
                value: maskedAccountNumber
            }, 
        ];
    }, [
        bankAccountInfo,
        locale
    ]);
    var personalInfoSectionData = (0,react.useMemo)(function() {
        var identityNumber = (personalInfo || {}).identityNumber;
        var maskedIdentityNumber = identityNumber ? (0,maskData/* maskCitizenId */.ln)(identityNumber) : undefined;
        return [
            {
                key: "identity-number",
                i18nKey: "identityNumber",
                value: maskedIdentityNumber
            }, 
        ];
    }, [
        personalInfo
    ]);
    var addressInfoSectionData = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
        var ref9 = addressInfo || {}, addrNo = ref9.address, villageBldg = ref9.villageBldg, subDistrictCode = ref9.subDistrict, districtCode = ref9.district, provinceCode = ref9.province, zipCode = ref9.zipCode;
        var addressNo = "".concat(addrNo || "", " ").concat(villageBldg || "").trim();
        var subDistrict = (ref = th_sub_district.thSubDistrict[subDistrictCode]) === null || ref === void 0 ? void 0 : (ref1 = ref.name) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.localize) === null || ref2 === void 0 ? void 0 : ref2[locale];
        var district = (ref3 = th_district.thDistrict[districtCode]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.name) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.localize) === null || ref5 === void 0 ? void 0 : ref5[locale];
        var province = (ref6 = th_province.thProvince[provinceCode]) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.name) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.localize) === null || ref8 === void 0 ? void 0 : ref8[locale];
        return [
            {
                key: "address-number",
                i18nKey: "addressNumber",
                value: addressNo
            },
            {
                key: "sub-district",
                i18nKey: "subDistrict",
                value: subDistrict
            },
            {
                key: "district",
                i18nKey: "district",
                value: district
            },
            {
                key: "province",
                i18nKey: "province",
                value: province
            },
            {
                key: "zipcode",
                i18nKey: "zipcode",
                value: zipCode
            }, 
        ];
    }, [
        addressInfo,
        locale
    ]);
    var isAllSectionValid = (0,react.useMemo)(function() {
        return isBankAccountValid && isPersonalValid && isAddressValid;
    }, [
        isAddressValid,
        isBankAccountValid,
        isPersonalValid
    ]);
    var handleOpenConfirmDialog = function(url) {
        setEditUrl(url);
        setConfirmDialogVisible(true);
    };
    var handleConfirmEdit = function() {
        window.open(editUrl);
        setConfirmDialogVisible(false);
    };
    var handleRejectConfirmEdit = function() {
        setEditUrl("");
        setConfirmDialogVisible(false);
    };
    var handleOpenBankAccountEdit = function() {
        var url = "".concat(authUrl, "/").concat(locale, "/setting/payment#payout");
        if (isAllSectionValid) {
            handleOpenConfirmDialog(url);
        } else {
            window.open(url);
        }
    };
    var handleOpenPersonalEdit = function() {
        var url = "".concat(authUrl, "/").concat(locale, "/setting/profile-info");
        if (isAllSectionValid) {
            handleOpenConfirmDialog(url);
        } else {
            window.open(url);
        }
    };
    var handleOpenAddressEdit = function() {
        var url = "".concat(authUrl, "/").concat(locale, "/setting/profile-info");
        if (isAllSectionValid) {
            handleOpenConfirmDialog(url);
        } else {
            window.open(url);
        }
    };
    var handleCloseModal = function() {
        setVisible(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmDialog/* default */.Z, {
                title: t("payout.editNotice.title"),
                description: t("payout.editNotice.description"),
                confirmText: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonTitle, {
                    level: 7,
                    children: t("payout.editNotice.editInfoButton")
                }),
                rejectText: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonTitle, {
                    level: 7,
                    children: t("payout.editNotice.closeButton")
                }),
                onConfirm: handleConfirmEdit,
                onReject: handleRejectConfirmEdit,
                isVisible: confirmDialogVisible,
                fullWidthButton: true,
                centered: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
                "data-testid": "payout-affiliate-modal",
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(PayoutModal_style_Title, {
                    level: 5,
                    "data-testid": "payout-affiliate-modal-title",
                    children: t("payout.title")
                }),
                footer: /*#__PURE__*/ (0,jsx_runtime.jsx)(PayoutModal_style_Button, {
                    "data-testid": "payout-affiliate-close-modal-button",
                    "data-gtm-input-code": "payout-affiliate-close-modal-button",
                    fullWidth: true,
                    onClick: handleCloseModal,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonTitle, {
                        level: 7,
                        children: t("payout.closeButton")
                    })
                }),
                visible: visible,
                width: !xs ? 443 : "100vw",
                onCancel: function() {
                    return setVisible(false);
                },
                maskClosable: false,
                centered: !xs,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBody, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerImage, {
                            alt: "payout-affiliate",
                            src: "/static/pages/affiliatePage/payout-affiliate-banner.png"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(PayoutModal_style_Content, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PayoutModal_InfoSection_InfoSection, {
                                    sectionKey: "payout-bank-account-info-section",
                                    sectionI18nKey: "bankAccountInfoSection",
                                    isValid: isBankAccountValid,
                                    fields: bankAccountSectionData,
                                    onEdit: handleOpenBankAccountEdit
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupDivider, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PayoutModal_InfoSection_InfoSection, {
                                    sectionKey: "payout-personal-info-section",
                                    sectionI18nKey: "personalInfoSection",
                                    isValid: isPersonalValid,
                                    fields: personalInfoSectionData,
                                    onEdit: handleOpenPersonalEdit
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupDivider, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PayoutModal_InfoSection_InfoSection, {
                                    sectionKey: "payout-address-info-section",
                                    sectionI18nKey: "addressInfoSection",
                                    isValid: isAddressValid,
                                    fields: addressInfoSectionData,
                                    onEdit: handleOpenAddressEdit
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var PayoutModal_PayoutModal = (PayoutModal);

;// CONCATENATED MODULE: ./src/components/AffiliatePage/PayoutSection/PayoutSection.tsx












var PayoutSection = function(param) {
    var bankAccountInfo = param.bankAccountInfo, personalInfo = param.personalInfo, addressInfo = param.addressInfo;
    var t = (0,esm/* useTranslation */.$G)("affiliate").t;
    var lg = (0,useBreakpoint/* default */.Z)().lg;
    var ref = (0,react.useState)(bankAccountInfo), bankAccount = ref[0], setBankAccount = ref[1];
    var ref1 = (0,react.useState)(addressInfo), address = ref1[0], setAddress = ref1[1];
    var ref2 = (0,react.useState)(personalInfo), personal = ref2[0], setPersonal = ref2[1];
    var ref3 = (0,react.useState)(false), modalVisible = ref3[0], setModalVisible = ref3[1];
    var isBankAccountValid = (0,react.useMemo)(function() {
        var ref = bankAccount || {}, bankCode = ref.bankCode, accountName = ref.accountName, accountNumber = ref.accountNumber;
        return !!(bankCode && accountName && accountNumber);
    }, [
        bankAccount
    ]);
    var isAddressValid = (0,react.useMemo)(function() {
        var ref = address || {}, addrNo = ref.address, zipCode = ref.zipCode, province = ref.province, district = ref.district, subDistrict = ref.subDistrict;
        return !!(addrNo && zipCode && province && province && district && subDistrict);
    }, [
        address
    ]);
    var isPersonalValid = (0,react.useMemo)(function() {
        var identityNumber = (personal || {}).identityNumber;
        return !!identityNumber;
    }, [
        personal
    ]);
    var isAllSectionValid = (0,react.useMemo)(function() {
        return isBankAccountValid && isAddressValid && isPersonalValid;
    }, [
        isBankAccountValid,
        isAddressValid,
        isPersonalValid
    ]);
    var handleOpenModal = function() {
        setModalVisible(!modalVisible);
    };
    var handleSwitchTab = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var tabState, ref, ref1, user, ref2, ref3, ref4, ref5, userBankAccount, ref6, ref7, ref8, ref9, userAddress, identityNumber, userPersonal;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    tabState = document.visibilityState;
                    if (!(tabState === "visible")) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        (0,auth/* getUserProfile */.et)()
                    ];
                case 1:
                    user = _state.sent();
                    try {
                        ;
                        userBankAccount = (user === null || user === void 0 ? void 0 : (ref2 = user.profile) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.identities) === null || ref3 === void 0 ? void 0 : ref3.bankaccount) ? JSON.parse((user === null || user === void 0 ? void 0 : (ref4 = user.profile) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.identities) === null || ref5 === void 0 ? void 0 : ref5.bankaccount) || "") : undefined;
                        setBankAccount(userBankAccount);
                    } catch (error) {
                        (0,logger/* logError */.H)("[payout-affiliate-report] fail to parse bank account", {
                            suid: user.suid
                        }, error);
                    }
                    try {
                        ;
                        userAddress = (user === null || user === void 0 ? void 0 : (ref6 = user.profile) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.contacts) === null || ref7 === void 0 ? void 0 : ref7.homeaddress) ? JSON.parse((user === null || user === void 0 ? void 0 : (ref8 = user.profile) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.contacts) === null || ref9 === void 0 ? void 0 : ref9.homeaddress) || "") : undefined;
                        setAddress(userAddress);
                    } catch (error1) {
                        (0,logger/* logError */.H)("[payout-affiliate-report] fail to parse address", {
                            suid: user.suid
                        }, error1);
                    }
                    identityNumber = user === null || user === void 0 ? void 0 : (ref = user.profile) === null || ref === void 0 ? void 0 : (ref1 = ref.identities) === null || ref1 === void 0 ? void 0 : ref1.citizenid;
                    userPersonal = {
                        identityNumber: identityNumber
                    };
                    setPersonal(userPersonal);
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    }), []);
    (0,react.useEffect)(function() {
        document.addEventListener("visibilitychange", handleSwitchTab);
        return function() {
            document.removeEventListener("visibilitychange", handleSwitchTab);
        };
    }, [
        handleSwitchTab
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PayoutModal_PayoutModal, {
                visible: modalVisible,
                setVisible: setModalVisible,
                bankAccountInfo: bankAccount,
                personalInfo: personal,
                addressInfo: address,
                isBankAccountValid: isBankAccountValid,
                isPersonalValid: isPersonalValid,
                isAddressValid: isAddressValid
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PayoutSection_style_Container, {
                "data-testid": "payout-affiliate-section",
                children: [
                    !isAllSectionValid && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PayoutSection_style_Body, {
                                        "data-testid": "payout-affiliate-section-description",
                                        level: 7,
                                        children: t("payout.description")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoSection, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckIcon_CheckIcon, {
                                                correct: isBankAccountValid
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTitleContainer, {
                                                "data-testid": "payout-bank-account-title",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PayoutSection_style_Body, {
                                                    level: 7,
                                                    children: t("payout.bankAccountInfoSection.title")
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoSection, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckIcon_CheckIcon, {
                                                correct: isPersonalValid
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTitleContainer, {
                                                "data-testid": "payout-personal-title",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PayoutSection_style_Body, {
                                                    level: 7,
                                                    children: t("payout.personalInfoSection.title")
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoSection, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckIcon_CheckIcon, {
                                                correct: isAddressValid
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTitleContainer, {
                                                "data-testid": "payout-address-title",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PayoutSection_style_Body, {
                                                    level: 7,
                                                    children: t("payout.addressInfoSection.title")
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PayoutSection_style_Button, {
                                "data-testid": "payout-affiliate-add-info-button",
                                "data-gtm-input-code": "payout-affiliate-add-info-button",
                                fullWidth: !lg,
                                onClick: handleOpenModal,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                    level: 7,
                                    children: t("payout.addPayoutButton")
                                })
                            })
                        ]
                    }),
                    isAllSectionValid && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PayoutSection_style_Body, {
                                    "data-testid": "payout-affiliate-section-description",
                                    level: 7,
                                    children: t("payout.validPayoutDescription", {
                                        accountNumber: (bankAccount === null || bankAccount === void 0 ? void 0 : bankAccount.accountNumber) ? (0,maskData/* maskBankAccountNumber */.cY)(bankAccount === null || bankAccount === void 0 ? void 0 : bankAccount.accountNumber) : ""
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PayoutSection_style_Button, {
                                type: "outlined",
                                "data-testid": "payout-affiliate-edit-info-button",
                                "data-gtm-input-code": "payout-affiliate-edit-info-button",
                                fullWidth: !lg,
                                onClick: handleOpenModal,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                    level: 7,
                                    children: t("payout.editPayoutButton")
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var PayoutSection_PayoutSection = (PayoutSection);

// EXTERNAL MODULE: ./node_modules/react-share/es/FacebookShareButton.js
var FacebookShareButton = __webpack_require__(16573);
// EXTERNAL MODULE: ./node_modules/react-share/es/FacebookMessengerShareButton.js
var FacebookMessengerShareButton = __webpack_require__(89674);
// EXTERNAL MODULE: ./node_modules/react-share/es/LineShareButton.js
var LineShareButton = __webpack_require__(67074);
;// CONCATENATED MODULE: ./src/components/AffiliatePage/ShareLinkModal/ShareLinkModal.style.tsx

function ShareLinkModal_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 8px;\n  width: 100%;\n"
    ]);
    ShareLinkModal_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ShareLinkModal_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 8px 0px;\n"
    ]);
    ShareLinkModal_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ShareLinkModal_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  padding: 8px 0px;\n"
    ]);
    ShareLinkModal_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var ShareIconContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bae1e8ec-0"
})(ShareLinkModal_style_templateObject());
var ShareLinkTextBoxContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bae1e8ec-1"
})(ShareLinkModal_style_templateObject1());
var ShareSectionContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bae1e8ec-2"
})(ShareLinkModal_style_templateObject2());

;// CONCATENATED MODULE: ./src/components/AffiliatePage/ShareLinkModal/ShareLinkModal.tsx
/* eslint-disable import/no-extraneous-dependencies */ 










var ShareLinkModal = function(param) {
    var visible = param.visible, shareLinkUrl = param.shareLinkUrl, onClose = param.onClose, onWriteClipboard = param.onWriteClipboard;
    var t = (0,useTranslation/* useTranslation */.$)("affiliate").t;
    var ref;
    var userAgent = (ref = navigator === null || navigator === void 0 ? void 0 : navigator.userAgent) !== null && ref !== void 0 ? ref : "";
    var isMobileDevice = /Mobile/i.test(userAgent);
    var handleOnShareMobile = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(navigator === null || navigator === void 0 ? void 0 : navigator.share)) return [
                            3,
                            4
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            navigator.share({
                                title: t("report.shareLinkModal.shareTitle"),
                                url: shareLinkUrl
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        (0,logger/* logError */.H)(error);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleOnShareMobile() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomizationInfoDialog/* default */.Z, {
        isVisible: visible,
        title: t("report.shareLinkModal.title"),
        confirmText: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Title, {
            level: 7,
            children: t("report.shareLinkModal.close")
        }),
        onConfirm: onClose,
        width: 303,
        centered: true,
        body: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            style: {
                textAlign: "center"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Body, {
                    level: 7,
                    children: t("report.shareLinkModal.description")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareLinkTextBoxContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareLinkTextBox, {
                        shareLinkUrl: shareLinkUrl,
                        onWriteClipboard: onWriteClipboard
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ShareSectionContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ShareIconContainer, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FacebookShareButton/* default */.Z, {
                                    url: shareLinkUrl,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: "/static/pages/affiliatePage/icon-color-facebook_rounded.svg",
                                        width: 24,
                                        height: 24,
                                        alt: "Facebook Messenger Icon"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Body, {
                                    level: 7,
                                    children: "Facebook"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ShareIconContainer, {
                            children: [
                                !isMobileDevice && /*#__PURE__*/ (0,jsx_runtime.jsx)(FacebookMessengerShareButton/* default */.Z, {
                                    appId: "1015642576694445",
                                    url: shareLinkUrl,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: "/static/pages/affiliatePage/icon-color-messenger_rounded.svg",
                                        width: 24,
                                        height: 24,
                                        alt: "Facebook Messenger Icon"
                                    })
                                }),
                                isMobileDevice && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    onClickCapture: handleOnShareMobile,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: "/static/pages/affiliatePage/icon-color-messenger_rounded.svg",
                                        width: 24,
                                        height: 24,
                                        alt: "Facebook Messenger Icon"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Body, {
                                    level: 7,
                                    children: "Messenger"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ShareIconContainer, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LineShareButton/* default */.Z, {
                                    url: shareLinkUrl,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: "/static/pages/affiliatePage/icon-color-line_rounded.svg",
                                        width: 24,
                                        height: 24,
                                        alt: "Facebook Messenger Icon"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Body, {
                                    level: 7,
                                    children: "Line"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var ShareLinkModal_ShareLinkModal = (ShareLinkModal);

;// CONCATENATED MODULE: ./src/components/AffiliatePage/AffiliateReport/AffiliateReport.tsx




















var LabelTooltipDialog = function(param) {
    var label = param.label, title = param.title, description = param.description;
    var ref = (0,react.useState)(false), visible = ref[0], setVisible = ref[1];
    var t = (0,useTranslation/* useTranslation */.$)("common").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Describe, {
                onClick: function() {
                    return setVisible(true);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ReportLabel, {
                        children: label
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        width: 16,
                        height: 16,
                        src: "/static/help-circle.svg"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DescriptionDialog, {
                width: 303,
                isVisible: visible,
                title: title,
                body: /*#__PURE__*/ (0,jsx_runtime.jsx)(Body, {
                    color: globals/* color.charcoal09 */.$.charcoal09,
                    children: description
                }),
                confirmText: /*#__PURE__*/ (0,jsx_runtime.jsx)(SubTitle, {
                    children: t("close")
                }),
                onConfirm: function() {
                    return setVisible(false);
                }
            })
        ]
    });
};
var ReportBox = function(param) {
    var label = param.label, dialogTitle = param.dialogTitle, value = param.value, description = param.description, additional = param.additional, unit = param.unit;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FillBox, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelTooltipDialog, {
                title: dialogTitle,
                label: label,
                description: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Title, {
                level: 7,
                children: value
            }),
            additional,
            unit && /*#__PURE__*/ (0,jsx_runtime.jsx)(Body, {
                color: globals/* color.charcoal08 */.$.charcoal08,
                children: unit
            })
        ]
    });
};
var AffiliateReport = function(param) {
    var channelConfig = param.channelConfig, user = param.user;
    var ref, ref1, ref2;
    var sRefCode = user === null || user === void 0 ? void 0 : (ref = user.affiliate) === null || ref === void 0 ? void 0 : ref.sRefCode;
    var ref3 = (0,react.useState)(false), isContactModalVisible = ref3[0], setIsContactModalVisible = ref3[1];
    var ref4 = (0,react.useState)(false), isShareLinkModalVisible = ref4[0], setIsShareLinkModalVisible = ref4[1];
    var ref5 = (0,react.useState)({
        earningAmount: 0,
        bonusAmount: 0,
        reviewAmount: 0,
        bonusReviewAmount: 0,
        purchasedCount: 0,
        cumulativeAmount: 0,
        unsuccessfulCount: 0
    }), report = ref5[0], setReport = ref5[1];
    var t = (0,useTranslation/* useTranslation */.$)("affiliate").t;
    var shareLinkUrl = "".concat("https://retail.easysunday.com", "/?sRefCode=").concat(sRefCode);
    var onWriteClipboard = function() {
        navigator.clipboard.writeText(shareLinkUrl);
        (0,Toast/* default */.Z)(t("common:toast.copy"));
    };
    var bankAccountInfo = (0,react.useMemo)(function() {
        try {
            var ref, ref1, ref2, ref3;
            return (user === null || user === void 0 ? void 0 : (ref = user.profile) === null || ref === void 0 ? void 0 : (ref1 = ref.identities) === null || ref1 === void 0 ? void 0 : ref1.bankaccount) ? JSON.parse(user === null || user === void 0 ? void 0 : (ref2 = user.profile) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.identities) === null || ref3 === void 0 ? void 0 : ref3.bankaccount) : undefined;
        } catch (error) {
            (0,logger/* logError */.H)("[affiliate-report] fail to parse bank account", {
                suid: user.suid
            }, error);
            return {};
        }
    }, [
        user
    ]);
    var addressInfo = (0,react.useMemo)(function() {
        try {
            var ref, ref1, ref2, ref3;
            return (user === null || user === void 0 ? void 0 : (ref = user.profile) === null || ref === void 0 ? void 0 : (ref1 = ref.contacts) === null || ref1 === void 0 ? void 0 : ref1.homeaddress) ? JSON.parse(user === null || user === void 0 ? void 0 : (ref2 = user.profile) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.contacts) === null || ref3 === void 0 ? void 0 : ref3.homeaddress) : undefined;
        } catch (error) {
            (0,logger/* logError */.H)("[affiliate-report] fail to parse address info", {
                suid: user.suid
            }, error);
            return {};
        }
    }, [
        user
    ]);
    (0,react.useEffect)(function() {
        var fetchAffiliateReport = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var result;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!sRefCode) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                getAffiliateReport()
                            ];
                        case 1:
                            result = _state.sent();
                            if (result) {
                                setReport(result);
                            }
                            _state.label = 2;
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchAffiliateReport() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchAffiliateReport();
    }, [
        sRefCode
    ]);
    if (!sRefCode) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReportContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CodeInfoContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SubTitle, {
                                        children: t("report.yourCode")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Body, {
                                        children: sRefCode
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ShareLinkContainer, {
                                columnGap: "8px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareLinkTextBox, {
                                        onWriteClipboard: onWriteClipboard,
                                        shareLinkUrl: shareLinkUrl
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                                        onClick: function() {
                                            return setIsShareLinkModalVisible(true);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SubTitle, {
                                            children: t("report.shareLink")
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReportCard, {
                        type: "inner",
                        title: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Headline, {
                            level: 6,
                            children: t("report.cardTitle")
                        }),
                        id: "report",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(col/* default */.Z, {
                                        span: 12,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelTooltipDialog, {
                                                label: t("report.earnAmount"),
                                                title: t("report.earnAmountTooltip.title"),
                                                description: t("report.earnAmountTooltip.description")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Title, {
                                                level: 1,
                                                children: (0,format/* formatNumberToThaiCurrency */.OJ)(report.earningAmount)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(col/* default */.Z, {
                                        span: 12,
                                        style: {
                                            borderLeft: "1px solid ".concat(globals/* color.charcoal03 */.$.charcoal03),
                                            paddingLeft: "16px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelTooltipDialog, {
                                                label: t("report.bonusAmount"),
                                                title: t("report.bonusAmountTooltip.title"),
                                                description: t("report.bonusAmountTooltip.description")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Title, {
                                                level: 1,
                                                children: (0,format/* formatNumberToThaiCurrency */.OJ)(report.bonusAmount)
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PayoutSection_PayoutSection, {
                                bankAccountInfo: bankAccountInfo,
                                addressInfo: addressInfo,
                                personalInfo: {
                                    identityNumber: user === null || user === void 0 ? void 0 : (ref1 = user.profile) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.identities) === null || ref2 === void 0 ? void 0 : ref2.citizenid
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AffiliateReport_style_FlexVerticalContainer, {
                                rowGap: "24px",
                                style: {
                                    marginTop: "24px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                                        gutter: [
                                            8,
                                            8
                                        ],
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                                span: 12,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReportBox, {
                                                    label: t("report.pendingAmount"),
                                                    dialogTitle: t("report.pendingAmountTooltip.title"),
                                                    value: (0,format/* formatNumberToThaiCurrency */.OJ)(report.reviewAmount),
                                                    description: t("report.pendingAmountTooltip.description"),
                                                    additional: !!report.bonusReviewAmount && /*#__PURE__*/ (0,jsx_runtime.jsxs)(AffiliateReport_style_FlexHorizontalContainer, {
                                                        columnGap: "4px",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Title, {
                                                                level: 7,
                                                                children: (0,format/* formatNumberToThaiCurrency */.OJ)(report.bonusReviewAmount)
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Body, {
                                                                color: globals/* color.charcoal08 */.$.charcoal08,
                                                                children: [
                                                                    "(",
                                                                    t("report.bonus"),
                                                                    ")"
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                                span: 12,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReportBox, {
                                                    label: t("report.successReferee"),
                                                    dialogTitle: t("report.successRefereeTooltip.title"),
                                                    value: report.purchasedCount.toLocaleString(),
                                                    description: t("report.successRefereeTooltip.description"),
                                                    unit: t("report.policyUnit")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                                span: 12,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReportBox, {
                                                    label: t("report.cumulative"),
                                                    dialogTitle: t("report.summaryEarnTooltip.title"),
                                                    value: (0,format/* formatNumberToThaiCurrency */.OJ)(report.cumulativeAmount),
                                                    description: t("report.summaryEarnTooltip.description")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                                span: 12,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReportBox, {
                                                    label: t("report.unsuccessful"),
                                                    dialogTitle: t("report.unsuccessfulTooltip.title"),
                                                    value: report.unsuccessfulCount.toLocaleString(),
                                                    description: t("report.unsuccessfulTooltip.description"),
                                                    unit: t("report.policyUnit")
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Body, {
                                        children: [
                                            t("report.note"),
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactButton, {
                                                type: "text",
                                                onClick: function() {
                                                    return setIsContactModalVisible(true);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Body, {
                                                    style: {
                                                        fontWeight: "bold"
                                                    },
                                                    children: t("report.contact")
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactModal/* default */.Z, {
                visible: isContactModalVisible,
                contact: channelConfig.content.contacts,
                onCloseModal: function() {
                    return setIsContactModalVisible(false);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareLinkModal_ShareLinkModal, {
                visible: isShareLinkModalVisible,
                shareLinkUrl: shareLinkUrl,
                onWriteClipboard: onWriteClipboard,
                onClose: function() {
                    return setIsShareLinkModalVisible(false);
                }
            })
        ]
    });
};
/* harmony default export */ var AffiliateReport_AffiliateReport = (AffiliateReport);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/antd/es/tabs/index.js + 20 modules
var tabs = __webpack_require__(14264);
// EXTERNAL MODULE: ./src/components/Collapse/Collapse.tsx
var Collapse = __webpack_require__(8051);
;// CONCATENATED MODULE: ./src/components/AffiliatePage/FAQSection/FAQSection.style.tsx

function FAQSection_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .ant-tabs-nav {\n    margin-bottom: 0px;\n  }\n  .ant-tabs-ink-bar {\n    background-color: ",
        ";\n  }\n  .ant-tabs-tab > div > div {\n    color: ",
        ";\n  }\n  .ant-tabs-tab-active > div > div {\n    color: ",
        ";\n  }\n\n  .ant-tabs-tab {\n    padding: 16px 0;\n  }\n"
    ]);
    FAQSection_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FAQSection_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  > div:first-child\n    > .sunday-component-collapse\n    .sunday-component-collapse-header {\n    border: none;\n  }\n"
    ]);
    FAQSection_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function FAQSection_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-inline-start: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n"
    ]);
    FAQSection_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function FAQSection_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .sunday-component-collapse-header-text {\n    flex: auto !important;\n  }\n"
    ]);
    FAQSection_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function FAQSection_style_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n  max-width: 343px;\n"
    ]);
    FAQSection_style_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function FAQSection_style_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    FAQSection_style_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}





var FAQTabs = (0,styled_components_browser_esm/* default */.ZP)(tabs/* default */.Z).withConfig({
    componentId: "sc-e6fa61ca-0"
})(FAQSection_style_templateObject(), globals/* color.carrotOrange03 */.$.carrotOrange03, globals/* color.charcoal09 */.$.charcoal09, globals/* color.carrotOrange03 */.$.carrotOrange03);
var FAQPanel = (0,styled_components_browser_esm/* default */.ZP)(tabs/* default.TabPane */.Z.TabPane).withConfig({
    componentId: "sc-e6fa61ca-1"
})(FAQSection_style_templateObject1());
var StyledList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-e6fa61ca-2"
})(FAQSection_style_templateObject2());
var FAQSection_style_Collapse = (0,styled_components_browser_esm/* default */.ZP)(Collapse/* Collapse */.U).withConfig({
    componentId: "sc-e6fa61ca-3"
})(FAQSection_style_templateObject3());
var FAQImageContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e6fa61ca-4"
})(FAQSection_style_templateObject4());
var FAQImage = (0,styled_components_browser_esm/* default */.ZP)((image_default())).attrs({
    layout: "responsive",
    width: 343,
    height: 120
}).withConfig({
    componentId: "sc-e6fa61ca-5"
})(FAQSection_style_templateObject5());

;// CONCATENATED MODULE: ./src/components/AffiliatePage/FAQSection/FAQSection.tsx






var FAQSection = function(param) {
    var activeTab = param.activeTab, setActiveTab = param.setActiveTab;
    var ref = (0,useTranslation/* useTranslation */.$)("affiliate"), t = ref.t, i18n = ref.i18n;
    var locale = i18n.language;
    var faq = [
        {
            id: 1,
            tabName: t("faq.tab1.title"),
            children: {
                1: {
                    question: {
                        en: "How can I know if the people I referred have successfully purchased insurance and had their policies approved?",
                        th: "จะรู้ได้อย่างไรว่าคนที่เราแนะนำไปมีการซื้อประกันสำเร็จและได้รับการอนุมัติแล้ว"
                    },
                    answer: {
                        en: 'You can track your referral performance, such as the number of policies purchased, the amount under review, and the amount you will receive,  in "My performance" section. This information is updated daily at 15:00.\nRegarding policy approval status, Sunday cannot inform you (the referrer) about this because the company is not allowed to disclose the personal and health information of policyholders to third parties.',
                        th: 'คุณสามารถตรวจสอบข้อมูลการแนะนำต่างๆ เช่น จำนวนกรมธรรม์ที่ซื้อแล้ว สถานะเงินรอตรวจสอบ และจำนวนเงินที่จะได้รับ ในหัวข้อ "ผลการแนะนำของฉัน" โดยข้อมูลนี้จะอัปเดตเวลา 15:00 น. ของทุกวัน\nสำหรับการอนุมัติกรมธรรม์ ซันเดย์จะไม่สามารถแจ้งเรื่องนี้ให้คุณ (ผู้แนะนำ) ทราบได้ เนื่องจากบริษัทไม่สามารถเปิดเผยข้อมูลส่วนตัวและข้อมูลสุขภาพของผู้เอากรมธรรม์กับบุคคลภายนอก'
                    }
                },
                2: {
                    question: {
                        en: "When will I receive the referral fee after my referees have successfully purchased insurance and had their policies approved?",
                        th: "หลังจากผู้ถูกแนะนำซื้อสำเร็จและกรมธรรม์ได้รับอนุมัติแล้ว จะได้รับค่าแนะนำเมื่อไหร่"
                    },
                    answer: {
                        en: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledList, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "Sunday calculates the referral fee on the 15th of each month and pays them on the 25th."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: 'To qualify, the referees’ policies must be approved and held for at least 30 days. The 30th day of policy holding (the "Eligible Date") must fall on or before the 15th of the month to receive the referral fee on the 25th of that month.'
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "Example 1: Policy approved on January 1st: Eligible Date is January 30th. You will receive the referral fee on February 25th."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "Example 2: Policy approved on January 20th: Eligible Date is February 18th. You will receive the referral fee on March 25th, not February 25th, as it falls after the cutoff date (February 15th)."
                                })
                            ]
                        }),
                        th: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledList, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "ซันเดย์จะตัดยอดทำการจ่ายค่าแนะนำในวันที่ 15 ของทุกเดือน และจะทำการจ่ายค่าแนะนำในวันที่ 25 ของทุกเดือน"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: 'กรมธรรม์ของผู้ถูกแนะนำจะต้องได้รับการอนุมัติและถือครองอย่างน้อย 30 วัน โดยวันที่ 30 ของการถือกรมธรรม์ (ต่อไปนี้จะขอเรียกว่า "Eligible Date") จะต้องอยู่ภายในวันที่ 15 ของเดือนนั้นๆ จึงจะได้รับค่าแนะนำในวันที่ 25 ของเดือนนั้นๆ'
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "ตัวอย่างที่ 1: ผู้ถูกแนะนำซื้อประกันบนเว็บไซต์สำเร็จและได้รับการอนุมัติในวันที่ 1 มกราคม จะถือว่าวันที่ 30 มกราคม เป็นวัน Eligible Date ในกรณีนี้จะได้รับเงินค่าแนะนำในวันที่ 25 กุมภาพันธ์"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "ตัวอย่างที่ 2: ผู้ถูกแนะนำซื้อประกันบนเว็บไซต์สำเร็จและได้รับการอนุมัติในวันที่ 20 มกราคม จะถือว่าวันที่ 18 กุมภาพันธ์ เป็นวัน Eligible Date ในกรณีนี้จะได้รับเงินค่าแนะนำในวันที่ 25 มีนาคม ไม่ใช่วันที่ 25 กุมภาพันธ์ เพราะเลยวันตัดยอด (วันที่ 15 กุมภาพันธ์) มาแล้ว"
                                })
                            ]
                        })
                    }
                },
                3: {
                    question: {
                        en: "In which cases will I not receive the referral fee on the 25th of the month?",
                        th: "กรณีใดบ้างที่ผู้แนะนำจะไม่ได้รับเงินในวันที่ 25 ของเดือน"
                    },
                    answer: {
                        en: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledList, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    children: [
                                        "In case your payout information is incomplete or incorrect, the system will notify you to update it.",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        "Once corrected, your referral fee will be processed in the next payout cycle. Ensure your name on your bank account and ID card match, and your address aligns with your ID card for tax purposes."
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "In case the 25th falls on a non-business day, Sunday will transfer the referral fee on the next business day."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "In case the Eligible Date falls after the 15th of the month, you will receive the referral fee on the 25th of the following month."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "In case the referee cancels the policy or the policy is rejected by the insurance company."
                                })
                            ]
                        }),
                        th: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledList, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "กรณีใส่ข้อมูลการรับเงินไม่ครบ หรือไม่ถูกต้อง ซึ่งระบบจะแจ้งให้คุณอัปเดตข้อมูลให้เรียบร้อยก่อน จึงจะสามารถทำการโอนเงินค่าแนะนำให้ได้ในรอบบัญชีถัดไป โดยข้อมูลการรับเงินที่ถูกต้องจะต้องใช้ชื่อบัญชีธนาคารและบัตรประจำตัวประชาชนที่ตรงกัน อีกทั้งข้อมูลที่อยู่จะต้องตรงกันกับในบัตรประจำตัวประชาชน เนื่องจากต้องถูกระบุในใบหักภาษี ณ ที่จ่าย"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "กรณีวันที่ 25 ตรงกับวันหยุดทำการ ซันเดย์จะทำการโอนจ่ายในวันทำการถัดไป"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "หาก Eligible Date เลยวันที่ 15 ของเดือน คุณจะได้รับเงินค่าแนะนำในวันที่ 25 ของเดือนถัดไป"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "กรณีที่ผู้ถูกแนะนำทำการยกเลิกกรมธรรม์ หรือกรมธรรม์ของผู้ถูกแนะนำไม่ได้รับการอนุมัติ"
                                })
                            ]
                        })
                    }
                },
                4: {
                    question: {
                        en: "In which cases will I not receive the referral fee?",
                        th: "กรณีใดบ้างที่ผู้แนะนำจะไม่ได้รับค่าแนะนำ"
                    },
                    answer: {
                        en: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                "You will not receive a referral fee in any case that doesn't meet the terms and conditions of the Sunday Affiliate Program. Examples include:",
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledList, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "You (the referrer) are under 20 years old."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "You are an insurance agent."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "The referred policy is rejected by the insurance company."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "The referee cancels the policy within 30 days of approval."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "You make a purchase through your own referral link."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "The referred person is not a new customer (e.g., renewing an existing policy)."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "You post inappropriate referral content."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "The purchased product is not part of the eligible products."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "The purchased product is less than THB 10,000 after discounts."
                                        })
                                    ]
                                })
                            ]
                        }),
                        th: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                "ทุกกรณีที่ไม่เข้าข่ายเงื่อนไขและข้อตกลงของ Sunday Affiliate Program ยกตัวอย่าง เช่น",
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledList, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "มีอายุน้อยกว่า 20 ปี"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "เป็นตัวแทนประกันภัย"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "กรมธรรม์ของผู้ถูกแนะนำไม่ได้รับการอนุมัติ"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "ผู้ถูกแนะนำยกเลิกการซื้อใน 30 วัน"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "ทำการซื้อผ่านลิงก์แนะนำของตัวเอง"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "ผู้ถูกแนะนำไม่ใช่ลูกค้ารายใหม่ (ซื้อกรมธรรม์ปีต่อ)"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "โพสต์เนื้อหาการแนะนำที่ไม่เหมาะสม"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "ซื้อผลิตภัณฑ์ที่ไม่ได้เข้าร่วมรายการ"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "ซื้อผลิตภัณฑ์ที่มีมูลค่าน้อยกว่า 10,000 บาทหลังจากหักส่วนลดใดๆ แล้ว"
                                        })
                                    ]
                                })
                            ]
                        })
                    }
                },
                5: {
                    question: {
                        en: "Where can I find the withholding tax certificate?",
                        th: "ดูใบหักภาษี ณ ที่จ่ายได้ที่ไหน"
                    },
                    answer: {
                        en: "For each referral payment, Sunday will withhold taxes as required by the Revenue Department. If you need a tax withholding certificate, please reach out to Sunday Customer Service at hello@easysunday.com or via LINE @easysunday.",
                        th: "ในการโอนจ่ายค่าแนะนำทุกครั้ง ซันเดย์จะหักภาษี ณ ที่จ่ายตามที่กรมสรรพากรกำหนด หากต้องการใบเสร็จการหักภาษี ณ ที่จ่าย สามารถติดต่อ Sunday Customer Service ที่อีเมล hello@easysunday.com หรือ LINE @easysunday"
                    }
                }
            }
        },
        {
            id: 2,
            tabName: t("faq.tab2.title"),
            children: {
                1: {
                    question: {
                        en: "How does Sunday calculate the referral fee based on the clicks from the referrer's link?",
                        th: "ซันเดย์คำนวณการให้ค่าแนะนำจากการคลิกลิงก์ของผู้ถูกแนะนำอย่างไร"
                    },
                    answer: {
                        en: "Your referees must make a purchase within 30 days of clicking your link. Otherwise, cookies will no longer store the referrer information on our website. Therefore, always remind referees to use your link when buying. If a referee clicks multiple referral links, credit will be given to the last link clicked.",
                        th: "ผู้ถูกแนะนำต้องซื้อประกันบนเว็บไซต์ภายใน 30 วันหลังจากคลิกลิงก์ของคุณ หากเกิน 30 วัน ระบบคุกกี้ (Cookie) จะไม่เก็บข้อมูลโค้ดผู้แนะนำไว้บนเว็บไซต์ ฉะนั้นคุณอาจต้องแจ้งให้ผู้ถูกแนะนำใช้ลิงก์หรือโค้ดของคุณทุกครั้ง เมื่อทำการซื้อ ในกรณีที่ผู้ถูกแนะนำคลิกลิงก์ของผู้แนะนำหลายคน ระบบจะให้สิทธิ์แก่ลิงก์สุดท้ายที่ถูกคลิกก่อนชำระเงิน"
                    }
                },
                2: {
                    question: {
                        en: "Can I change the URL in my referral link?",
                        th: 'สามารถเปลี่ยนแปลง URL ส่วนหน้าของลิงก์ผู้แนะนำที่อยู่ในช่อง "ลิงก์ของคุณ" ได้หรือไม่'
                    },
                    answer: {
                        en: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                "You can modify the URL part in your referral link, but ensure the URL you change is from retail.easysunday.com. However, changing the parameter after the question mark (as shown below) will prevent the system from calculating your referral fee.",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQImageContainer, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQImage, {
                                        src: "/static/pages/affiliatePage/FAQ-URLImage-en.png",
                                        alt: "FAQ-URLImage"
                                    })
                                })
                            ]
                        }),
                        th: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                "สามารถเปลี่ยนแปลงส่วนของ URL ได้และระบบจะยังนับค่าแนะนำให้ แต่หากเปลี่ยนแปลงส่วน parameter และโค้ดผู้แนะนำ (ตามภาพด้านล่าง) ระบบจะไม่สามารถนับค่าแนะนำให้ได้ ทั้งนี้ URL ต้องเป็นลิงก์ที่อยู่บนเว็บไซต์ retail.easysunday.com เท่านั้น",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQImageContainer, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQImage, {
                                        src: "/static/pages/affiliatePage/FAQ-URLImage-th.png",
                                        alt: "FAQ-URLImage"
                                    })
                                })
                            ]
                        })
                    }
                },
                3: {
                    question: {
                        en: "Can referees use discount codes together with my referral link or code when purchasing insurance?",
                        th: "ผู้ถูกแนะนำสามารถใช้โค้ดส่วนลดร่วมกับการใช้ลิงก์หรือโค้ดแนะนำของคุณ เพื่อซื้อประกันได้หรือไม่"
                    },
                    answer: {
                        en: "Yes, discount codes can be used with referral links or codes. Sunday regularly offers special promotions each month. You can find current promotions on our website and share them with your referees.",
                        th: "สามารถใช้ร่วมกันได้ โดยคุณสามารถเช็กโปรโมชันพิเศษที่ซันเดย์จัดเป็นประจำในแต่ละเดือนบนเว็บไซต์ เพื่อนำไปบอกต่อได้เลย"
                    }
                },
                4: {
                    question: {
                        en: "If my referees have questions about policies and claims, what should they do?",
                        th: "หากผู้ถูกแนะนำมีคำถามเกี่ยวกับกรมธรรม์และการเคลม ต้องทำอย่างไร"
                    },
                    answer: {
                        en: "As a referrer, you are not authorized to answer questions about policies or claims since you are not a licensed insurance agent. Please advise your referees to review policy details on our website or contact Sunday Customer Service, available 24/7.",
                        th: "คุณ (ผู้แนะนำ) จะไม่สามารถตอบคำถามเกี่ยวกับกรมธรรม์และการเคลมกับผู้ถูกแนะนำได้ เนื่องจากไม่ใช่ตัวแทนประกันที่มีใบอนุญาต แต่คุณสามารถแจ้งให้ผู้ถูกแนะนำอ่านข้อมูลกรมธรรม์บนเว็บไซต์ หรือติดต่อ Sunday Customer Service ได้ตลอด 24 ชั่วโมง"
                    }
                },
                5: {
                    question: {
                        en: "How can I contact Sunday if I have questions about Sunday Affiliate Program?",
                        th: "กรณีมีปัญหาเกี่ยวกับ Sunday Affiliate Program ต้องทำอย่างไร"
                    },
                    answer: {
                        th: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                "สามารถติดต่อซันเดย์ผ่าน 3 ช่องทาง",
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledList, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "โทร 0 2026 3355"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "อีเมล hello@easysunday.com"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "LINE @easysunday"
                                        })
                                    ]
                                })
                            ]
                        }),
                        en: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                "You can contact Sunday through the following channels:",
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledList, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "Tel: +66 2026 3355"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "Email: hello@easysunday.com"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "LINE: @easysunday"
                                        })
                                    ]
                                })
                            ]
                        })
                    }
                }
            }
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionContainer, {
        id: "faq",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Headline, {
                level: 6,
                children: t("faq.title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQTabs, {
                activeKey: activeTab,
                onTabClick: setActiveTab,
                children: faq.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQPanel, {
                        tab: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Title, {
                            level: 7,
                            children: item.tabName
                        }),
                        children: Object.entries(item.children).map(function(param) {
                            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQSection_style_Collapse, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Panel, {
                                    header: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Title, {
                                        level: 7,
                                        children: value.question[locale]
                                    }),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Body, {
                                        level: 7,
                                        children: value.answer[locale]
                                    })
                                }, key)
                            }, key);
                        })
                    }, item.id);
                })
            })
        ]
    });
};
/* harmony default export */ var FAQSection_FAQSection = (FAQSection);

;// CONCATENATED MODULE: ./src/components/AffiliatePage/TutorialStep/TutorialStep.style.tsx

function TutorialStep_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: ",
        ";\n  width: 24px;\n  height: 24px;\n  color: ",
        ";\n  flex-shrink: 0;\n"
    ]);
    TutorialStep_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TutorialStep_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0px;\n  height: fit-content !important;\n  width: fit-content;\n  margin-top: 4px;\n"
    ]);
    TutorialStep_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var StepNumber = (0,styled_components_browser_esm/* default */.ZP)(lib.Title).attrs({
    level: 7
}).withConfig({
    componentId: "sc-6b763cd-0"
})(TutorialStep_style_templateObject(), globals/* color.carrotOrange03 */.$.carrotOrange03, globals/* color.white */.$.white);
var ConsentButton = (0,styled_components_browser_esm/* default */.ZP)(lib.Button).attrs({
    type: "text"
}).withConfig({
    componentId: "sc-6b763cd-1"
})(TutorialStep_style_templateObject1());

;// CONCATENATED MODULE: ./src/components/AffiliatePage/TutorialStep/TutorialStep.tsx








var TutorialStep = function() {
    var t = (0,useTranslation/* useTranslation */.$)("affiliate").t;
    var router = (0,next_router.useRouter)();
    var locale = router.locale;
    var onOpenConsent = function() {
        window.open("https://static.easysunday.com/retail/affiliate/pdf/consent_tc_".concat(locale, "_20240923.pdf"), "_blank");
    };
    var stepData = [
        {
            step: 1,
            title: t("tutorial.step1.title"),
            description: "tutorial.step1.description"
        },
        {
            step: 2,
            title: t("tutorial.step2.title"),
            description: "tutorial.step2.description"
        },
        {
            step: 3,
            title: t("tutorial.step3.title"),
            description: "tutorial.step3.description",
            render: function() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsentButton, {
                    onClick: onOpenConsent,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Title, {
                        level: 7,
                        children: t("tutorial.termsButton")
                    })
                });
            }
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionContainer, {
        id: "tutorial-step",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Headline, {
                level: 6,
                style: {
                    marginBottom: "24px"
                },
                children: t("tutorial.title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                gutter: [
                    16,
                    16
                ],
                children: stepData.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                        lg: 8,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexHorizontalContainer, {
                            columnGap: "8px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StepNumber, {
                                    children: item.step
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexVerticalContainer, {
                                    rowGap: "8px",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Title, {
                                            level: 7,
                                            children: item.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(lib.Body, {
                                            style: {
                                                color: globals/* color.charcoal09 */.$.charcoal09
                                            },
                                            level: 7,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* Trans */.c, {
                                                    t: t,
                                                    i18nKey: item.description,
                                                    components: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            target: "_blank",
                                                            rel: "noreferrer",
                                                            href: "https://static.easysunday.com/retail/affiliate/pdf/product_list_selling_point_th_20240923.pdf",
                                                            children: "Hidden Text"
                                                        }, 0), 
                                                    ],
                                                    children: t(item.description)
                                                }),
                                                item.render && item.render()
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, item.step)
                    }, item.step);
                })
            })
        ]
    });
};
/* harmony default export */ var TutorialStep_TutorialStep = (TutorialStep);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/components/AffiliatePage/GuideBook/GuideBook.styled.tsx

function GuideBook_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n"
    ]);
    GuideBook_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function GuideBook_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  gap: 16px;\n  display: flex;\n  flex-direction: column;\n  padding-left: 24px;\n"
    ]);
    GuideBook_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var GuideBook_styled_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8b732b72-0"
})(GuideBook_styled_templateObject());
var ListContainer = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-8b732b72-1"
})(GuideBook_styled_templateObject1(), globals/* color.tigerOrange03 */.$.tigerOrange03);

;// CONCATENATED MODULE: ./src/components/AffiliatePage/GuideBook/GuideBook.tsx
/* eslint-disable jsx-a11y/anchor-is-valid */ 






var GuideBook = function() {
    var t = (0,useTranslation/* useTranslation */.$)("affiliate").t;
    var locale = (0,next_router.useRouter)().locale;
    var guides = [
        {
            displayName: {
                en: "Download product and promotion artworks",
                th: "ดาวน์โหลดภาพผลิตภัณฑ์และโปรโมชันที่น่าสนใจ"
            },
            url: {
                en: "https://drive.google.com/drive/folders/1R04RRVhosUFG2QG6IKoiaiuXp86kYGPc?usp=sharing",
                th: "https://drive.google.com/drive/folders/1R04RRVhosUFG2QG6IKoiaiuXp86kYGPc?usp=sharing"
            }
        },
        {
            displayName: {
                en: "Manual for referring and sharing links",
                th: "วิธีการเขียนข้อความแนะนำและการแชร์ลิงก์"
            },
            url: {
                en: "https://static.easysunday.com/retail/affiliate/pdf/manual_referring_sharing_th_20240820.pdf",
                th: "https://static.easysunday.com/retail/affiliate/pdf/manual_referring_sharing_th_20240820.pdf"
            }
        },
        {
            displayName: {
                en: "Product lists and their unique selling points",
                th: "ผลิตภัณฑ์ประกันภัยที่ร่วมรายการและจุดเด่น"
            },
            url: {
                en: "https://static.easysunday.com/retail/affiliate/pdf/product_list_selling_point_th_20240923.pdf",
                th: "https://static.easysunday.com/retail/affiliate/pdf/product_list_selling_point_th_20240923.pdf"
            }
        },
        {
            displayName: {
                en: "Manual for bank account linking and payout schedule",
                th: "วิธีการผูกบัญชีและระยะเวลาการรับเงิน"
            },
            url: {
                en: "https://static.easysunday.com/retail/affiliate/pdf/manual_bank_payout_th_20240730.pdf",
                th: "https://static.easysunday.com/retail/affiliate/pdf/manual_bank_payout_th_20240730.pdf"
            }
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(GuideBook_styled_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Headline, {
                level: 6,
                children: t("guideBook.title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListContainer, {
                children: guides.map(function(guide) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: guide.url[locale],
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                target: "#!",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkTitle/* default */.Z, {
                                    level: 7,
                                    children: guide.displayName[locale]
                                })
                            })
                        })
                    });
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/AffiliatePage/VideoSection/VideoSection.styled.tsx

function VideoSection_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n"
    ]);
    VideoSection_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function VideoSection_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 231.55px;\n"
    ]);
    VideoSection_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var VideoSection_styled_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e78a2b55-0"
})(VideoSection_styled_templateObject());
var VideoContainer = (0,styled_components_browser_esm/* default */.ZP)(col/* default */.Z).withConfig({
    componentId: "sc-e78a2b55-1"
})(VideoSection_styled_templateObject1());

;// CONCATENATED MODULE: ./src/components/AffiliatePage/VideoSection/VideoSection.tsx





var VideoSection = function() {
    var t = (0,useTranslation/* useTranslation */.$)("affiliate").t;
    var videoUrls = [
        "https://www.youtube.com/embed/jr7MHKQSGKw?si=g4JEvoV8uSE5sJ4n", 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(VideoSection_styled_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Headline, {
                level: 6,
                children: t("videoSection.title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                gutter: [
                    16,
                    16
                ],
                children: videoUrls.map(function(url) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoContainer, {
                        xs: 24,
                        sm: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                            width: "100%",
                            height: "100%",
                            src: url,
                            title: "YouTube video player",
                            allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
                            allowFullScreen: true
                        })
                    });
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/sunday-component/node_modules/antd/es/form/index.js + 210 modules
var es_form = __webpack_require__(9117);
// EXTERNAL MODULE: ./src/components/Common/Form/DatePickerForm.tsx
var DatePickerForm = __webpack_require__(18154);
// EXTERNAL MODULE: ./src/components/Common/Form/TextBoxForm.tsx
var TextBoxForm = __webpack_require__(71085);
// EXTERNAL MODULE: ./src/constants/userProfile.ts
var userProfile = __webpack_require__(763);
// EXTERNAL MODULE: ./src/utils/regEx.ts
var regEx = __webpack_require__(1982);
// EXTERNAL MODULE: ./src/components/Common/CheckBox.tsx
var CheckBox = __webpack_require__(26377);
// EXTERNAL MODULE: ./src/utils/validationRules.tsx + 1 modules
var validationRules = __webpack_require__(95416);
// EXTERNAL MODULE: ./src/components/Common/Form/ErrorMessageWithIcon.tsx
var ErrorMessageWithIcon = __webpack_require__(85856);
// EXTERNAL MODULE: ./src/components/Common/LinkBody.tsx
var LinkBody = __webpack_require__(9638);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./src/utils/date.ts
var date = __webpack_require__(63049);
;// CONCATENATED MODULE: ./src/components/AffiliatePage/RegisterSection/RegisterSection.styled.tsx

function RegisterSection_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  gap: 24px;\n"
    ]);
    RegisterSection_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function RegisterSection_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  div {\n    font-size: 21px;\n    line-height: 24px;\n  }\n"
    ]);
    RegisterSection_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function RegisterSection_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0 0 16px !important;\n"
    ]);
    RegisterSection_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function RegisterSection_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  top: 0;\n  margin: 0px;\n  padding: 0px;\n  max-width: 100vw;\n  .ant-modal-header {\n    border-radius: 16px 16px 0px 0px;\n  }\n\n  .ant-modal-body {\n    border-radius: ",
        ";\n    padding: 0px;\n    overflow: auto;\n  }\n  .ant-modal-footer {\n    padding: 16px;\n  }\n  .ant-modal-content {\n    border-radius: 16px;\n  }\n  .ant-scrolling-effect {\n    width: 0px;\n  }\n"
    ]);
    RegisterSection_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function RegisterSection_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    .ant-modal,\n    .ant-modal-content {\n      height: 100vh;\n      max-width: 100vw;\n      margin: 0px;\n      top: 0;\n      padding: 0px;\n    }\n    .ant-modal-body {\n      border-radius: 0;\n      height: calc(100vh - 173px);\n      width: 100vw;\n    }\n    .ant-modal-footer {\n      padding: 16px 16px 32px 16px;\n      position: fixed;\n      bottom: 0;\n      width: 100%;\n      background: white;\n    }\n    .ant-modal-content {\n      overflow: auto;\n      border-radius: 0px;\n    }\n  }\n"
    ]);
    RegisterSection_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function RegisterSection_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n"
    ]);
    RegisterSection_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function RegisterSection_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-bottom: 0;\n"
    ]);
    RegisterSection_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function RegisterSection_styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-weight: 300;\n"
    ]);
    RegisterSection_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function RegisterSection_styled_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-weight: 300;\n"
    ]);
    RegisterSection_styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function RegisterSection_styled_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 300;\n"
    ]);
    RegisterSection_styled_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function RegisterSection_styled_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: fit-content;\n"
    ]);
    RegisterSection_styled_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function RegisterSection_styled_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: auto;\n"
    ]);
    RegisterSection_styled_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function RegisterSection_styled_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n"
    ]);
    RegisterSection_styled_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function RegisterSection_styled_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    RegisterSection_styled_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function RegisterSection_styled_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 300;\n  color: ",
        ";\n"
    ]);
    RegisterSection_styled_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 300;\n  color: ",
        ";\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0 -8px;\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-width: 194px;\n  ",
        " {\n    width: 100%;\n  }\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 24px;\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}





var CardDetail = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-817e9842-0"
})(RegisterSection_styled_templateObject());
var UserButton = (0,styled_components_browser_esm/* default */.ZP)(lib.Button).withConfig({
    componentId: "sc-817e9842-1"
})(RegisterSection_styled_templateObject1());
var SignupPageItem = (0,styled_components_browser_esm/* default */.ZP)(lib.FormItem).withConfig({
    componentId: "sc-817e9842-2"
})(RegisterSection_styled_templateObject2());
var SuccessModal = (0,styled_components_browser_esm/* default */.ZP)(modal/* default */.Z).withConfig({
    componentId: "sc-817e9842-3"
})(RegisterSection_styled_templateObject3(), function(props) {
    return props.bodyRadius;
});
var RegisterModal = (0,styled_components_browser_esm/* default */.ZP)(SuccessModal).withConfig({
    componentId: "sc-817e9842-4"
})(RegisterSection_styled_templateObject4(), (0,styled_breakpoints.down)("xs"));
var ModalContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-817e9842-5"
})(RegisterSection_styled_templateObject5());
var RegisterModalContent = (0,styled_components_browser_esm/* default */.ZP)(ModalContent).withConfig({
    componentId: "sc-817e9842-6"
})(RegisterSection_styled_templateObject6());
var SubTitleText = (0,styled_components_browser_esm/* default */.ZP)(lib.Body).attrs({
    level: 7
}).withConfig({
    componentId: "sc-817e9842-7"
})(RegisterSection_styled_templateObject7(), globals/* color.charcoal09 */.$.charcoal09);
var ExtraText = (0,styled_components_browser_esm/* default */.ZP)(lib.Body).attrs({
    level: 7
}).withConfig({
    componentId: "sc-817e9842-8"
})(RegisterSection_styled_templateObject8(), globals/* color.charcoal08 */.$.charcoal08);
var ConsentText = (0,styled_components_browser_esm/* default */.ZP)(lib.Body).attrs({
    level: 7
}).withConfig({
    componentId: "sc-817e9842-9"
})(RegisterSection_styled_templateObject9());
var ImageContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-817e9842-10"
})(RegisterSection_styled_templateObject10());
var BannerImg = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-817e9842-11"
})(RegisterSection_styled_templateObject11());
var CenterTitle = (0,styled_components_browser_esm/* default */.ZP)(lib.Title).attrs({
    level: 5
}).withConfig({
    componentId: "sc-817e9842-12"
})(RegisterSection_styled_templateObject12());
var NextStepContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-817e9842-13"
})(RegisterSection_styled_templateObject13());
var NextStepText = (0,styled_components_browser_esm/* default */.ZP)(lib.Body).attrs({
    level: 7
}).withConfig({
    componentId: "sc-817e9842-14"
})(RegisterSection_styled_templateObject14(), globals/* color.charcoal10 */.$.charcoal10);
var NextStepList = styled_components_browser_esm/* default.ol.withConfig */.ZP.ol.withConfig({
    componentId: "sc-817e9842-15"
})(_templateObject15());
var NextStepItemText = (0,styled_components_browser_esm/* default */.ZP)(lib.Body).attrs({
    level: 7
}).withConfig({
    componentId: "sc-817e9842-16"
})(_templateObject16(), globals/* color.charcoal09 */.$.charcoal09);
var CloseDialogTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-817e9842-17"
})(_templateObject17());
var RegisterButton = (0,styled_components_browser_esm/* default */.ZP)(lib.Button).withConfig({
    componentId: "sc-817e9842-18"
})(_templateObject18(), (0,styled_breakpoints.down)("sm"));
var RegisterLabel = (0,styled_components_browser_esm/* default */.ZP)(lib.Title).attrs({
    level: 7
}).withConfig({
    componentId: "sc-817e9842-19"
})(_templateObject19());
var RegisterSection_styled_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-817e9842-20"
})(_templateObject20());

;// CONCATENATED MODULE: ./src/components/AffiliatePage/RegisterSection/RegisterSection.tsx
/* eslint-disable jsx-a11y/anchor-is-valid */ 






























var RegisterSection = function(param) {
    var user = param.user;
    var ref;
    var ref1 = (0,_sliced_to_array/* default */.Z)(es_form/* default.useForm */.Z.useForm(), 1), form = ref1[0];
    var xs = (0,useBreakpoint/* default */.Z)().xs;
    var router = (0,next_router.useRouter)();
    var locale = router.locale;
    var ref2 = (0,react.useState)(false), isRegisterModalVisible = ref2[0], setIsRegisterModalVisible = ref2[1];
    var ref3 = (0,react.useState)(false), isSuccessModalVisible = ref3[0], setIsSuccessModalVisible = ref3[1];
    var ref4 = (0,react.useState)(false), isCloseModalVisible = ref4[0], setIsCloseModalVisible = ref4[1];
    var ref5 = (0,react.useState)(false), isLoading = ref5[0], setIsLoading = ref5[1];
    var ref6 = (0,react.useState)(), sRefCode = ref6[0], setSRefCode = ref6[1];
    var ref7 = (0,react.useState)(true), isSubmitButtonDisable = ref7[0], setIsSubmitButtonDisable = ref7[1];
    var t = (0,useTranslation/* useTranslation */.$)([
        "user-profile",
        "affiliate",
        "form",
        "common"
    ]).t;
    var validateEmail = function(_, value, submitError) {
        if (value && value.trim() !== "" && !regEx/* EMAIL_PATTERN.test */.QI.test(value)) {
            return submitError(/*#__PURE__*/ (0,jsx_runtime.jsx)(TextBoxForm/* TextBoxErrorText */.J9, {
                children: t("form:validation.pleaseEnterValid", {
                    field: t("editPersonalInfo.email.label")
                })
            }));
        }
        return submitError();
    };
    var onFieldsChange = function(_, allFields) {
        setIsSubmitButtonDisable(allFields.filter(function(param) {
            var errors = param.errors, value = param.value;
            return errors.length || !value;
        }).length > 0);
    };
    var onWriteClipboard = function() {
        var shareLinkUrl = "".concat("https://retail.easysunday.com", "/?sRefCode=").concat(sRefCode);
        navigator.clipboard.writeText(shareLinkUrl);
        (0,Toast/* default */.Z)(t("common:toast.copy"));
    };
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(input) {
            var formattedInput, res, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            3,
                            4
                        ]);
                        setIsLoading(true);
                        formattedInput = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, input), (0,_define_property/* default */.Z)({}, userProfile/* AFFILIATE_FORM_FIELDS.DOB */.h4.DOB, input[userProfile/* AFFILIATE_FORM_FIELDS.DOB */.h4.DOB] ? (0,date/* formatDateText */.Kb)(input[userProfile/* AFFILIATE_FORM_FIELDS.DOB */.h4.DOB]) : undefined));
                        return [
                            4,
                            registerAffiliate(formattedInput)
                        ];
                    case 1:
                        res = _state.sent();
                        setSRefCode(res.sRefCode);
                        setIsRegisterModalVisible(false);
                        setIsSuccessModalVisible(true);
                        return [
                            3,
                            4
                        ];
                    case 2:
                        e = _state.sent();
                        router.reload();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        setIsLoading(false);
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(input) {
            return _ref.apply(this, arguments);
        };
    }();
    if (!user || ((ref = user.affiliate) === null || ref === void 0 ? void 0 : ref.sRefCode)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RegisterSection_styled_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RegisterButton, {
                type: "primary",
                onClick: function() {
                    setIsRegisterModalVisible(true);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RegisterLabel, {
                    children: t("affiliate:register.submit")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmDialog/* default */.Z, {
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseDialogTitle, {
                    children: t("affiliate:register.closeModal.title")
                }),
                description: t("affiliate:register.closeModal.description"),
                isVisible: isCloseModalVisible,
                confirmText: t("affiliate:register.closeModal.continue"),
                rejectText: t("affiliate:register.closeModal.close"),
                rejectButtonProps: {
                    onClick: function() {
                        setIsCloseModalVisible(false);
                        setIsRegisterModalVisible(false);
                    }
                },
                confirmButtonProps: {
                    onClick: function() {
                        setIsCloseModalVisible(false);
                    }
                },
                fullWidthButton: true,
                centered: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SuccessModal, {
                bodyRadius: "16px 16px 0px 0px",
                closable: false,
                footer: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserButton, {
                    onClick: function() {
                        setIsSuccessModalVisible(false);
                        router.reload();
                    },
                    children: t("affiliate:register.success.close")
                }),
                visible: isSuccessModalVisible,
                width: 303,
                maskClosable: false,
                centered: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerImg, {
                        src: "https://static.easysunday.com/retail/affiliate/content/register-modal-banner-02.png",
                        alt: "success-register-banner"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalContent, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CenterTitle, {
                                children: t("affiliate:register.success.title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareLinkTextBox, {
                                shareLinkUrl: "https://retail.easysunday.com/?sRefCode=".concat(sRefCode),
                                onWriteClipboard: onWriteClipboard
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(NextStepContainer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NextStepText, {
                                        children: t("affiliate:register.success.nextStep.title")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NextStepItemText, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NextStepList, {
                                            type: "1",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: t("affiliate:register.success.nextStep.stepOne")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: t("affiliate:register.success.nextStep.stepTwo")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: t("affiliate:register.success.nextStep.stepThree")
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RegisterModal, {
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(CenterTitle, {
                    children: t("affiliate:register.title")
                }),
                footer: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserButton, {
                    disabled: isSubmitButtonDisable,
                    loading: isLoading,
                    onClick: function() {
                        form.submit();
                    },
                    children: t("affiliate:register.submit")
                }),
                visible: isRegisterModalVisible,
                onCancel: function() {
                    setIsCloseModalVisible(true);
                },
                width: !xs ? 444 : "100vw",
                maskClosable: false,
                centered: !xs,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerImg, {
                        src: "https://static.easysunday.com/retail/affiliate/content/register-modal-banner-01.png",
                        alt: "register-banner"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RegisterModalContent, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardDetail, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SubTitleText, {
                                    children: t("affiliate:register.subTitle")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(lib.Form, {
                                    form: form,
                                    onFinish: onSubmit,
                                    onFieldsChange: onFieldsChange,
                                    initialValues: (_obj = {}, (0,_define_property/* default */.Z)(_obj, userProfile/* AFFILIATE_FORM_FIELDS.FIRST_NAME */.h4.FIRST_NAME, user === null || user === void 0 ? void 0 : user.profile.firstname), (0,_define_property/* default */.Z)(_obj, userProfile/* AFFILIATE_FORM_FIELDS.LAST_NAME */.h4.LAST_NAME, user === null || user === void 0 ? void 0 : user.profile.lastname), (0,_define_property/* default */.Z)(_obj, userProfile/* AFFILIATE_FORM_FIELDS.DOB */.h4.DOB, (user === null || user === void 0 ? void 0 : user.profile.dob) ? dayjs_min_default()(user.profile.dob) : undefined), (0,_define_property/* default */.Z)(_obj, "contacts", (0,_define_property/* default */.Z)({}, userProfile/* AFFILIATE_FORM_FIELDS.PRIMARY_EMAIL */.h4.PRIMARY_EMAIL, user === null || user === void 0 ? void 0 : user.profile.contacts.primaryemail)), _obj),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SignupPageItem, {
                                            name: userProfile/* AFFILIATE_FORM_FIELDS.FIRST_NAME */.h4.FIRST_NAME,
                                            rules: [
                                                {
                                                    required: true,
                                                    message: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextBoxForm/* TextBoxErrorText */.J9, {
                                                        children: t("form:validation.required", {
                                                            field: t("editPersonalInfo.firstName.label")
                                                        })
                                                    })
                                                }, 
                                            ],
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextBoxForm/* default */.ZP, {
                                                placeholder: t("editPersonalInfo.firstName.placeholder"),
                                                label: t("editPersonalInfo.firstName.label")
                                            }, userProfile/* AFFILIATE_FORM_FIELDS.FIRST_NAME */.h4.FIRST_NAME)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SignupPageItem, {
                                            name: userProfile/* AFFILIATE_FORM_FIELDS.LAST_NAME */.h4.LAST_NAME,
                                            rules: [
                                                {
                                                    required: true,
                                                    message: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextBoxForm/* TextBoxErrorText */.J9, {
                                                        children: t("form:validation.required", {
                                                            field: t("editPersonalInfo.lastName.label")
                                                        })
                                                    })
                                                }, 
                                            ],
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextBoxForm/* default */.ZP, {
                                                placeholder: t("editPersonalInfo.lastName.placeholder"),
                                                label: t("editPersonalInfo.lastName.label")
                                            }, userProfile/* AFFILIATE_FORM_FIELDS.LAST_NAME */.h4.LAST_NAME)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SignupPageItem, {
                                            extra: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExtraText, {
                                                children: t("affiliate:register.requireAge20")
                                            }),
                                            name: userProfile/* AFFILIATE_FORM_FIELDS.DOB */.h4.DOB,
                                            validateFirst: true,
                                            rules: [
                                                {
                                                    validator: function(_, value) {
                                                        if (!(0,validationRules/* validateRequiredRule */.r1)(value)) {
                                                            return Promise.reject();
                                                        }
                                                        return Promise.resolve();
                                                    },
                                                    message: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextBoxForm/* TextBoxErrorText */.J9, {
                                                        children: t("form:validation.selectedRequired", {
                                                            field: t("editPersonalInfo.dob.label")
                                                        })
                                                    })
                                                }, 
                                            ].concat((0,_to_consumable_array/* default */.Z)((0,validationRules/* validateAge */._f)([
                                                {
                                                    rule: "ageByDay0",
                                                    params: {
                                                        min: 20
                                                    }
                                                }, 
                                            ], t, new Date().toISOString(), TextBoxForm/* TextBoxErrorText */.J9, t("affiliate:register.dob.validationAgeError")))),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DatePickerForm/* default */.ZP, {
                                                style: {
                                                    height: "48px"
                                                },
                                                placeholder: t("editPersonalInfo.dob.placeholder"),
                                                disabledFuture: true,
                                                label: t("editPersonalInfo.dob.label")
                                            }, userProfile/* AFFILIATE_FORM_FIELDS.DOB */.h4.DOB)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SignupPageItem, {
                                            name: [
                                                "contacts",
                                                userProfile/* AFFILIATE_FORM_FIELDS.PRIMARY_EMAIL */.h4.PRIMARY_EMAIL
                                            ],
                                            rules: [
                                                {
                                                    required: true,
                                                    message: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextBoxForm/* TextBoxErrorText */.J9, {
                                                        children: t("form:validation.required", {
                                                            field: t("editPersonalInfo.email.label")
                                                        })
                                                    })
                                                },
                                                {
                                                    min: 0,
                                                    max: 250
                                                },
                                                {
                                                    validator: validateEmail
                                                }, 
                                            ],
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextBoxForm/* default */.ZP, {
                                                placeholder: t("editPersonalInfo.email.placeholder"),
                                                label: t("editPersonalInfo.email.label")
                                            }, userProfile/* AFFILIATE_FORM_FIELDS.EMAIL */.h4.EMAIL)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SignupPageItem, {
                                            name: [
                                                "consents",
                                                userProfile/* USER_CONSENT.SUNDAY_AFFILIATE */.hl.SUNDAY_AFFILIATE
                                            ],
                                            valuePropName: "checked",
                                            rules: [
                                                {
                                                    validator: function() {
                                                        var _ref = (0,_async_to_generator/* default */.Z)(function(_, value) {
                                                            return (0,tslib_es6.__generator)(this, function(_state) {
                                                                if (!(0,validationRules/* validateRequiredExcludeFalseRule */.xY)(value)) return [
                                                                    2,
                                                                    Promise.reject()
                                                                ];
                                                                return [
                                                                    2,
                                                                    Promise.resolve()
                                                                ];
                                                            });
                                                        });
                                                        return function(_, value) {
                                                            return _ref.apply(this, arguments);
                                                        };
                                                    }(),
                                                    message: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorMessageWithIcon/* default */.Z, {
                                                        errorMessage: t("affiliate:register.sundayAffiliateConsent.validationError")
                                                    })
                                                }, 
                                            ],
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckBox/* default */.ZP, {
                                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                                                    justify: "start",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConsentText, {
                                                        children: [
                                                            t("affiliate:register.sundayAffiliateConsent.preLabel"),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: "https://static.easysunday.com/retail/affiliate/pdf/consent_tc_".concat(locale, "_20240923.pdf"),
                                                                passHref: true,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    target: "#!",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkBody/* default */.Z, {
                                                                        level: 7,
                                                                        children: t("affiliate:register.sundayAffiliateConsent.label")
                                                                    })
                                                                })
                                                            }),
                                                            t("affiliate:register.sundayAffiliateConsent.postLabel")
                                                        ]
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/Auth/AuthModal.tsx + 3 modules
var AuthModal = __webpack_require__(14826);
;// CONCATENATED MODULE: ./src/components/AffiliatePage/UserProfileSection/UserProfileSection.styled.tsx

function UserProfileSection_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 24px;\n"
    ]);
    UserProfileSection_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function UserProfileSection_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0 -8px;\n"
    ]);
    UserProfileSection_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function UserProfileSection_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-width: 194px;\n  ",
        " {\n    width: 100%;\n  }\n"
    ]);
    UserProfileSection_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function UserProfileSection_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    UserProfileSection_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var UserProfileSection_styled_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e84a2cc4-0"
})(UserProfileSection_styled_templateObject());
var LoginDialogTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e84a2cc4-1"
})(UserProfileSection_styled_templateObject1());
var LoginButton = (0,styled_components_browser_esm/* default */.ZP)(lib.Button).withConfig({
    componentId: "sc-e84a2cc4-2"
})(UserProfileSection_styled_templateObject2(), (0,styled_breakpoints.down)("sm"));
var LoginLabel = (0,styled_components_browser_esm/* default */.ZP)(lib.Title).attrs({
    level: 7
}).withConfig({
    componentId: "sc-e84a2cc4-3"
})(UserProfileSection_styled_templateObject3());

;// CONCATENATED MODULE: ./src/components/AffiliatePage/UserProfileSection/UserProfileSection.tsx






var UserProfileSection = function() {
    var t = (0,useTranslation/* useTranslation */.$)([
        "affiliate"
    ]).t;
    var ref = (0,react.useState)(false), isLoginModalVisible = ref[0], setIsLoginModalVisible = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RegisterSection_styled_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginButton, {
                type: "primary",
                onClick: function() {
                    setIsLoginModalVisible(true);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginLabel, {
                    children: t("affiliate:user.continue")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal/* default */.Z, {
                visible: isLoginModalVisible,
                onClose: setIsLoginModalVisible
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/AffiliatePage/AffiliatePage.tsx













var AffiliatePage = function(param) {
    var channelConfig = param.channelConfig, user = param.user;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(""), hash = ref[0], setHash = ref[1];
    var ref1 = (0,react.useState)("1"), activeFaqTab = ref1[0], setActiveFaqTab = ref1[1];
    (0,react.useEffect)(function() {
        var handleUrlChange = function() {
            var newHash = window.location.hash.replace("#", "");
            setHash(newHash);
        };
        // Handle initial load
        handleUrlChange();
        // Listen for hash changes
        window.addEventListener("hashchange", handleUrlChange);
        // Listen for Next.js route changes
        router.events.on("hashChangeComplete", handleUrlChange);
        return function() {
            window.removeEventListener("hashchange", handleUrlChange);
            router.events.off("hashChangeComplete", handleUrlChange);
        };
    }, [
        router
    ]);
    (0,react.useEffect)(function() {
        if (hash) {
            if (hash.startsWith("faq")) {
                var activeTab = hash.slice(-1);
                setActiveFaqTab(activeTab);
                scrollToElement("faq");
            } else {
                scrollToElement(hash);
            }
        }
    }, [
        hash
    ]);
    var scrollToElement = function(id) {
        setTimeout(function() {
            var element = document.getElementById(id);
            if (element) {
                element.scrollIntoView({
                    behavior: "smooth",
                    block: "start"
                });
            }
        }, 1000);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexVerticalContainer, {
            style: {
                padding: "24px 0px"
            },
            rowGap: "24px",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AffiliatePage_AffiliateDescription, {}),
                !user && /*#__PURE__*/ (0,jsx_runtime.jsx)(UserProfileSection, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(RegisterSection, {
                    user: user
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AffiliateReport_AffiliateReport, {
                    channelConfig: channelConfig,
                    user: user
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerSlider, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TutorialStep_TutorialStep, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoSection, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(GuideBook, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQSection_FAQSection, {
                    activeTab: activeFaqTab,
                    setActiveTab: setActiveFaqTab
                })
            ]
        })
    });
};
/* harmony default export */ var AffiliatePage_AffiliatePage = (AffiliatePage);

// EXTERNAL MODULE: ./src/components/Auth/withUserOrGuest.tsx
var withUserOrGuest = __webpack_require__(94665);
// EXTERNAL MODULE: ./src/components/Layout/withLayout.tsx + 6 modules
var withLayout = __webpack_require__(20587);
// EXTERNAL MODULE: ./src/components/Layout/withUserProfileLayout.tsx + 6 modules
var withUserProfileLayout = __webpack_require__(68814);
;// CONCATENATED MODULE: ./src/pages/[channelPath]/affiliate/index.tsx




var __N_SSP = true;
/* harmony default export */ var affiliate = ((0,withUserOrGuest/* default */.Z)((0,withLayout/* withLayout */.X)((0,withUserProfileLayout/* withUserProfileLayout */.g)(AffiliatePage_AffiliatePage))));


/***/ }),

/***/ 60082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ color; }
/* harmony export */ });
/* eslint-disable import/prefer-default-export */ var color = {
    blueLandingPageBG: "#0857C3",
    carrotOrange: "#FA4616",
    carrotOrange01: "#FFB29E",
    carrotOrange03: "#FA4616",
    carrotOrange04: "#FFF4EB",
    carrotOrange05: "#FEECE8",
    // coolGrey
    coolGreyCG: "#D9D9D6",
    coolGreyCG1: "#f7f7f7",
    coolGreyCG2: "#F0F0EF",
    coolGreyCG3: "#E8E8E6",
    coolGreyCG6: "#828280",
    coolGreyCG8: "#2B2B2B",
    coolGreyCG9: "#F5F6F7",
    darkGrey: "#4A4A4A",
    // warmGrey
    warmGreyWG2: "#EDEBE8",
    // blue
    frenchBlueFb: "#307FE2",
    frenchBlue04: "#004EAB",
    white: "#fff",
    black: "#000000",
    // black
    black01: "#1D1D1D",
    // yellow
    mustardYellowMy: "#FFAD00",
    warningYellow01: "#FFF5E5",
    warningYellow03: "#FF9900",
    // black charcoal
    charcoal11: "#D9DBDE",
    charcoal10: "#2A2C2E",
    charcoal09: "#54565A",
    charcoal08: "#76777A",
    charcoal07: "#98989A",
    charcoal05: "#C8C8C8",
    charcoal04: "#D9D9D6",
    charcoal03: "#E8E8E6",
    charcoal01: "#F7F7F7",
    errorRed04: "#DA3B45",
    errorRed03: "#BF0000",
    errorRed02: "#D24D4D",
    errorRed01: "#BF000019",
    // orange
    tigerOrange02: "#FF9A36",
    tigerOrange03: "#FF7500",
    // pebble grey
    pebbleGrey: "#707372",
    // success green
    successGreeen01: "#E8F2ED",
    successGreeen03: "#1C7C4E",
    successGreeen04: "#146037",
    // brown
    brownTertiary: "#6F5F5E",
    // beige
    beige100: "#F1EFE3",
    // navy
    navy: "#00294D",
    // green
    pineGreen04: "#02685b",
    successGreen01: "#E8F2ED"
};


/***/ }),

/***/ 1982:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FM": function() { return /* binding */ ID_RT_PATTERN; },
/* harmony export */   "G8": function() { return /* binding */ YYYY_MM_DD_DATE_PATTERN; },
/* harmony export */   "J5": function() { return /* binding */ ID_RW_PATTERN; },
/* harmony export */   "OZ": function() { return /* binding */ ID_MOBILE_NO_PATTERN; },
/* harmony export */   "QI": function() { return /* binding */ EMAIL_PATTERN; },
/* harmony export */   "Rc": function() { return /* binding */ ONLY_TH_EN_PATTERN; },
/* harmony export */   "SY": function() { return /* binding */ ID_CID_PATTERN; },
/* harmony export */   "a_": function() { return /* binding */ EN_NUM_SYMBOL; },
/* harmony export */   "bx": function() { return /* binding */ TH_MOBILE_NO_PATTERN; },
/* harmony export */   "cS": function() { return /* binding */ ACCEPT_ALL_PATTERN; },
/* harmony export */   "eL": function() { return /* binding */ DECIMAL_PATTERN; },
/* harmony export */   "lJ": function() { return /* binding */ TH_CID_PATTERN; },
/* harmony export */   "mz": function() { return /* binding */ ONE_TO_HUNDRED_PATTERN; },
/* harmony export */   "rB": function() { return /* binding */ ONLY_EN_NUM_UNDERSCORE_DASH_CHAR_PATTERN; }
/* harmony export */ });
/* unused harmony exports BANK_ACCOUNT_NO_PATTERN, SPLIT_PATH */
var ACCEPT_ALL_PATTERN = /[\s\S]*/;
var TH_MOBILE_NO_PATTERN = /0([689]\d{8}|[23457]\d{7})$/;
var ID_MOBILE_NO_PATTERN = /^(\(\+62|62|0)(\d{2,3})?\)?[ .-]?\d{2,4}[ .-]?\d{2,5}$/;
var DECIMAL_PATTERN = /^\d+(?:\.\d+)?$/;
var TH_CID_PATTERN = /^[1-9]\d{4}\d{5}\d{2}\d$/;
var ID_CID_PATTERN = /^\d{2}[01237]\d{3}[01234567]\d[01]\d{7}$/;
var ONE_TO_HUNDRED_PATTERN = /^[1-9]\d?$|^100$/;
var BANK_ACCOUNT_NO_PATTERN = /^[A-Za-z0-9]+$/;
var EMAIL_PATTERN = // eslint-disable-next-line no-useless-escape
/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
var ONLY_TH_EN_PATTERN = /^[a-zA-Z\u0E00-\u0E7F\s]*$/;
var EN_NUM_SYMBOL = /^[a-zA-Z0-9-_]*$/;
var ONLY_EN_NUM_UNDERSCORE_DASH_CHAR_PATTERN = /[^a-zA-Z0-9\-_]/g;
var ID_RW_PATTERN = /^\d{3}$/;
var ID_RT_PATTERN = /^\d{3}$/;
var SPLIT_PATH = /^\/([^/]+)/;
var YYYY_MM_DD_DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;


/***/ }),

/***/ 95416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "RP": function() { return /* binding */ handleDisabledDate; },
  "p_": function() { return /* binding */ transformToAntValidations; },
  "_f": function() { return /* binding */ validateAge; },
  "pO": function() { return /* binding */ validateAgeBetween; },
  "JJ": function() { return /* binding */ validateBmi; },
  "oL": function() { return /* binding */ validateInListRule; },
  "c2": function() { return /* binding */ validateLicensePlate; },
  "Dd": function() { return /* binding */ validateRangeFromNowRule; },
  "xY": function() { return /* binding */ validateRequiredExcludeFalseRule; },
  "r1": function() { return /* binding */ validateRequiredRule; },
  "KK": function() { return /* binding */ validateValueByActiveInputCode; }
});

// UNUSED EXPORTS: validateFullYearRangeFromTo

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/constants/format.ts
var format = __webpack_require__(71512);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./src/constants/input.ts
var input = __webpack_require__(54444);
// EXTERNAL MODULE: ./src/utils/regEx.ts
var regEx = __webpack_require__(1982);
;// CONCATENATED MODULE: ./src/utils/age.ts


var calcAgeByYear0 = function(now, dob) {
    if (typeof dob !== "string" || !dob.match(regEx/* YYYY_MM_DD_DATE_PATTERN */.G8)) {
        return -1;
    }
    var nowDayJs = dayjs_min_default()(now).startOf("day");
    var dobDayJs = dayjs_min_default()(dob).startOf("day");
    var currentYear = nowDayJs.year();
    var birthYear = dobDayJs.year();
    return Math.max(currentYear - birthYear, 0);
};
var calcAgeByDay0 = function(now, dob) {
    if (typeof dob !== "string" || !dob.match(regEx/* YYYY_MM_DD_DATE_PATTERN */.G8)) {
        return -1;
    }
    var nowDayJs = dayjs_min_default()(now).startOf("day");
    var dobDayJs = dayjs_min_default()(dob).startOf("day");
    return nowDayJs.diff(dobDayJs, "year");
};

// EXTERNAL MODULE: ./src/utils/date.ts
var date = __webpack_require__(63049);
;// CONCATENATED MODULE: ./src/utils/validationRules.tsx
/* eslint-disable import/prefer-default-export */ 










/**
 * verify that the variable has a value except false.
 * @param value value for validation.
 * @returns required validation result.
 */ var validateRequiredExcludeFalseRule = function(value) {
    if (!value && value !== 0) return false;
    return true;
};
/**
 * verify that the variable has a value.
 * @param value value for validation.
 * @returns required validation result.
 */ var validateRequiredRule = function(value) {
    if (!value && value !== 0 && value !== false) {
        return false;
    }
    // Dayjs date case
    if (value && (0,dayjs_min.isDayjs)(value) && !(value === null || value === void 0 ? void 0 : value.isValid())) {
        return false;
    }
    return true;
};
/**
 * verify that the variable has in date range from now.
 * @param from number of date before current date.
 * @param to number of date after current date.
 * @param value selected date for validation.
 * @returns in range date from now validation result.
 */ var validateRangeFromNowRule = function(value) {
    var from = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, to = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var startDay = dayjs_min_default()().add(from - 1, "days").endOf("day");
    var lastDay = dayjs_min_default()().add(to, "days").endOf("day");
    var valueDayjs = dayjs_min_default()(value, format/* DATE_INPUT_TEXT_FORMAT */.AV);
    if ((from === 0 || from) && valueDayjs < startDay || (to === 0 || to) && valueDayjs > lastDay) {
        return false;
    }
    return true;
};
var handleDisabledDate = function(validations) {
    return function(current) {
        var rangeFromNowRule = validations.find(function(rule) {
            return rule.rule === input/* RULE_CODE.RANGE_FROM_NOW */.n.RANGE_FROM_NOW;
        });
        if (rangeFromNowRule) {
            var _params = rangeFromNowRule.params, from = _params.from, to = _params.to;
            return !validateRangeFromNowRule(current, from, to);
        }
        return false;
    };
};
/**
 * Validates the range calculated from a date to ensure it falls within a given range of years.
 * @param {Dayjs} date - The date as a Dayjs object.
 * @param {number} startYear - The start year of the range to validate against.
 * @param {number} endYear - The end year of the range to validate against.
 * @returns {boolean} - Returns true if the date is valid within the specified range, false otherwise.
 */ var validateFullYearRangeFromTo = function(date, startYear, endYear) {
    var currentDate = dayjs();
    var diff = currentDate.diff(date, "years");
    return diff >= startYear && diff <= endYear;
};
/**
 * Validates the range calculated from a date to ensure it falls within a given range of years.
 * @param {Dayjs} date - The date as a Dayjs object.
 * @param {number} startYear - The start year of the range to validate against.
 * @param {number} endYear - The end year of the range to validate against.
 * @returns {boolean} - Returns true if the date is valid within the specified range, false otherwise.
 */ var validateAgeBetween = function(date, startYear, endYear) {
    var currentDate = dayjs_min_default()();
    var diff = currentDate.year() - date.year();
    return diff >= startYear && diff <= endYear;
};
/**
 * verify that the variable has in list.
 * @param list list of values.
 * @param value value for in list rule validation.
 * @returns in list validator validation result.
 */ var validateInListRule = function(list, value) {
    if (!list.includes(value)) {
        return false;
    }
    return true;
};
/**
 * verify that the variable is correct followed the rule.
 * @param activeInputCodes list of input codes.
 * @param values value for validation.
 * @returns in list of validation result.
 */ var validateValueByActiveInputCode = function(activeInputCodes, values) {
    return activeInputCodes.map(function(activeInputCode) {
        var rulesValidation = activeInputCode.validations.map(function(rule) {
            var isRuleValidationError = false;
            switch(rule.rule){
                case input/* RULE_CODE.REQUIRED */.n.REQUIRED:
                    isRuleValidationError = !validateRequiredRule(values === null || values === void 0 ? void 0 : values[activeInputCode.inputCode]);
                    break;
                case input/* RULE_CODE.RANGE_FROM_NOW */.n.RANGE_FROM_NOW:
                    isRuleValidationError = !validateRangeFromNowRule(values === null || values === void 0 ? void 0 : values[activeInputCode.inputCode], rule.params.from, rule.params.to);
                    break;
                case input/* RULE_CODE.IN */.n.IN:
                    isRuleValidationError = !validateInListRule(rule.params.values, values === null || values === void 0 ? void 0 : values[activeInputCode.inputCode]);
                    break;
                case input/* RULE_CODE.LICENSE_PLATE */.n.LICENSE_PLATE:
                    isRuleValidationError = !validateLicensePlate(values === null || values === void 0 ? void 0 : values[activeInputCode.inputCode]);
                    break;
            }
            return {
                code: rule.rule,
                isError: isRuleValidationError
            };
        });
        var isInputValidationError = rulesValidation.filter(function(rule) {
            return rule.isError;
        }).length > 0;
        return {
            code: activeInputCode.inputCode,
            isError: isInputValidationError,
            rulesValidation: rulesValidation
        };
    });
};
var genErrorMessage = function(message, ErrorMessageComponent) {
    if (ErrorMessageComponent) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorMessageComponent, {
            children: message
        });
    }
    return message;
};
/**
 * transform appForm validations to ant validations.
 * @param validations appForm validations.
 * @param t i18 translator.
 * @param label field label.
 * @returns ant validation.
 */ var transformToAntValidations = function(validations, t, label) {
    var isPreferWhitespace = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, ErrorMessageComponent = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, isChoice = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false;
    return [
        (0,_object_spread/* default */.Z)({
            required: !!(validations === null || validations === void 0 ? void 0 : validations.find(function(validation) {
                return validation.rule === input/* RULE_CODE.REQUIRED */.n.REQUIRED;
            })),
            message: genErrorMessage(t(isChoice ? "form:validation.selectedRequired" : "form:validation.required", {
                field: label
            }), ErrorMessageComponent)
        }, isPreferWhitespace ? {
            whitespace: !!(validations === null || validations === void 0 ? void 0 : validations.find(function(validation) {
                return validation.rule === input/* RULE_CODE.REQUIRED */.n.REQUIRED;
            }))
        } : null),
        {
            validator: function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function(_) {
                    var value, characterLengthValidation, idCardValidation, ref, ref1, ref2, ref3, ref4, ref5, max, min, ref6, idCard, digits, sum, lastDigit, inputLastDigit;
                    var _arguments = arguments;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        value = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "";
                        characterLengthValidation = validations === null || validations === void 0 ? void 0 : validations.find(function(validation) {
                            return validation.rule === input/* RULE_CODE.CHARACTER_LENGTH */.n.CHARACTER_LENGTH;
                        });
                        idCardValidation = validations === null || validations === void 0 ? void 0 : validations.find(function(validation) {
                            return validation.rule === input/* RULE_CODE.TH_ID_CARD */.n.TH_ID_CARD;
                        });
                        if (characterLengthValidation) {
                            ;
                            max = characterLengthValidation === null || characterLengthValidation === void 0 ? void 0 : (ref = characterLengthValidation.params) === null || ref === void 0 ? void 0 : ref.max;
                            min = characterLengthValidation === null || characterLengthValidation === void 0 ? void 0 : (ref1 = characterLengthValidation.params) === null || ref1 === void 0 ? void 0 : ref1.min;
                            if (max && (value === null || value === void 0 ? void 0 : (ref2 = value.trim) === null || ref2 === void 0 ? void 0 : ref2.call(value).length) > (characterLengthValidation === null || characterLengthValidation === void 0 ? void 0 : (ref3 = characterLengthValidation.params) === null || ref3 === void 0 ? void 0 : ref3.max) || min && (value === null || value === void 0 ? void 0 : (ref4 = value.trim) === null || ref4 === void 0 ? void 0 : ref4.call(value).length) < (characterLengthValidation === null || characterLengthValidation === void 0 ? void 0 : (ref5 = characterLengthValidation.params) === null || ref5 === void 0 ? void 0 : ref5.min)) {
                                // validate only min length
                                if (min && !max) {
                                    return [
                                        2,
                                        Promise.reject(genErrorMessage(t("form:validation.characterLengthMin", {
                                            min: min
                                        }), ErrorMessageComponent))
                                    ];
                                }
                                // validate only max length
                                if (!min && max) {
                                    return [
                                        2,
                                        Promise.reject(genErrorMessage(t("form:validation.characterLengthMax", {
                                            max: max
                                        }), ErrorMessageComponent))
                                    ];
                                }
                                if (min === max) {
                                    return [
                                        2,
                                        Promise.reject(genErrorMessage(t("form:validation.characterLengthEqualMinMax", {
                                            min: min
                                        }), ErrorMessageComponent))
                                    ];
                                }
                                // validate min and max length
                                return [
                                    2,
                                    Promise.reject(genErrorMessage(t("form:validation.characterLengthMinMax", {
                                        min: min,
                                        max: max
                                    }), ErrorMessageComponent))
                                ];
                            }
                        }
                        // blame him if it wrong
                        // https://gist.github.com/peatiscoding/a16840caed0ba1b29e6b2fe171565ea0#file-assertthaiid-ts
                        if (idCardValidation) {
                            ;
                            idCard = (ref6 = value === null || value === void 0 ? void 0 : value.trim()) === null || ref6 === void 0 ? void 0 : ref6.match(/(\d{12})(\d)/);
                            if (!idCard) {
                                return [
                                    2,
                                    Promise.reject(genErrorMessage(t("form:validation.idCardValidation"), ErrorMessageComponent))
                                ];
                            }
                            digits = idCard[1].split("");
                            sum = digits.reduce(function(total, digit, i) {
                                return total + (13 - i) * +digit;
                            }, 0);
                            lastDigit = "".concat((11 - sum % 11) % 10);
                            inputLastDigit = idCard[2];
                            if (lastDigit !== inputLastDigit) {
                                return [
                                    2,
                                    Promise.reject(genErrorMessage(t("form:validation.idCardValidation"), ErrorMessageComponent))
                                ];
                            }
                        }
                        return [
                            2,
                            Promise.resolve()
                        ];
                    });
                });
                return function(_) {
                    return _ref.apply(this, arguments);
                };
            }()
        }, 
    ];
};
var validateBmi = function(validations, t, sectionCode, inputCode, form) {
    var ErrorMessageComponent = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null;
    return [
        {
            validator: function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function(_) {
                    var value, bmiValidation, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, min, max, weightInputCode, heightInputCode, weightInputValue, heightInputValue, isWeightValid, isHeightValid, weight, height, calculatedBMI, errorMessage, fieldName, fieldErrors;
                    var _arguments = arguments;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        value = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : 0;
                        bmiValidation = validations === null || validations === void 0 ? void 0 : validations.find(function(validation) {
                            return validation.rule === input/* RULE_CODE.BMI */.n.BMI;
                        });
                        if (bmiValidation) {
                            ;
                            min = (bmiValidation === null || bmiValidation === void 0 ? void 0 : (ref = bmiValidation.params) === null || ref === void 0 ? void 0 : ref.min) || 0;
                            max = (bmiValidation === null || bmiValidation === void 0 ? void 0 : (ref1 = bmiValidation.params) === null || ref1 === void 0 ? void 0 : ref1.max) || 0;
                            weightInputCode = (ref4 = bmiValidation === null || bmiValidation === void 0 ? void 0 : (ref2 = bmiValidation.params) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.mapInputCode) === null || ref3 === void 0 ? void 0 : ref3.find(function(code) {
                                return code.param === "weight";
                            })) === null || ref4 === void 0 ? void 0 : ref4.param;
                            heightInputCode = (ref7 = bmiValidation === null || bmiValidation === void 0 ? void 0 : (ref5 = bmiValidation.params) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.mapInputCode) === null || ref6 === void 0 ? void 0 : ref6.find(function(code) {
                                return code.param === "height";
                            })) === null || ref7 === void 0 ? void 0 : ref7.param;
                            weightInputValue = form.getFieldValue([
                                sectionCode,
                                weightInputCode
                            ]) || "";
                            heightInputValue = form.getFieldValue([
                                sectionCode,
                                heightInputCode
                            ]) || "";
                            isWeightValid = weightInputValue.match(regEx/* DECIMAL_PATTERN */.eL);
                            isHeightValid = heightInputValue.match(regEx/* DECIMAL_PATTERN */.eL);
                            if (isWeightValid && isHeightValid) {
                                weight = weightInputValue || 0;
                                height = heightInputValue || 0;
                                calculatedBMI = weight / Math.pow(height / 100, 2);
                                errorMessage = genErrorMessage(t("form:validation.invalidBMI"), ErrorMessageComponent);
                                fieldName = inputCode !== weightInputCode ? weightInputCode : heightInputCode;
                                fieldErrors = form.getFieldError([
                                    sectionCode,
                                    fieldName
                                ]).filter(function(error) {
                                    if (typeof error === "object" && typeof errorMessage === "object") {
                                        return error.props.children !== errorMessage.props.children;
                                    }
                                    return error !== errorMessage;
                                });
                                if (weight <= 0) {
                                    if (height) {
                                        form.setFields([
                                            {
                                                name: [
                                                    sectionCode,
                                                    heightInputCode
                                                ],
                                                errors: []
                                            }
                                        ]);
                                    }
                                    return [
                                        2,
                                        Promise.resolve()
                                    ];
                                }
                                if (height <= 0) {
                                    if (weight) {
                                        form.setFields([
                                            {
                                                name: [
                                                    sectionCode,
                                                    weightInputCode
                                                ],
                                                errors: []
                                            }
                                        ]);
                                    }
                                    return [
                                        2,
                                        Promise.resolve()
                                    ];
                                }
                                if (isFinite(calculatedBMI) && (calculatedBMI > max && max || calculatedBMI < min && min || calculatedBMI <= 0)) {
                                    // update pair params bmi errors
                                    form.setFields([
                                        {
                                            name: [
                                                sectionCode,
                                                fieldName
                                            ],
                                            errors: [
                                                errorMessage
                                            ]
                                        }
                                    ]);
                                    return [
                                        2,
                                        Promise.reject(errorMessage)
                                    ];
                                }
                                if (weight <= 0 || height <= 0 || isFinite(calculatedBMI) && (calculatedBMI > max && max || calculatedBMI < min && min || calculatedBMI <= 0)) {
                                    // update pair params bmi errors
                                    form.setFields([
                                        {
                                            name: [
                                                sectionCode,
                                                fieldName
                                            ],
                                            errors: [
                                                errorMessage
                                            ]
                                        }
                                    ]);
                                    return [
                                        2,
                                        Promise.reject(errorMessage)
                                    ];
                                }
                                // remove bmi validate errors
                                form.setFields([
                                    {
                                        name: [
                                            sectionCode,
                                            fieldName
                                        ],
                                        errors: (0,_to_consumable_array/* default */.Z)(fieldErrors)
                                    }
                                ]);
                            }
                        }
                        return [
                            2,
                            Promise.resolve()
                        ];
                    });
                });
                return function(_) {
                    return _ref.apply(this, arguments);
                };
            }()
        }, 
    ];
};
/**
 * Check format of license plate
 * the format is ก-ฮ or a-z or A-D at least 1 character and end with 3 arabic numeral
 * example:
 * 1AB4444 is pass,
 * 9 is fail,
 * กV3333 is pass,
 * DV333A is fail,
 * @param value String that you want to check
 * @returns If match, it will return true
 */ var validateLicensePlate = function(value) {
    var result = /^(?=.*[0-9])(?=.*[\u0E00-\u0E7Fa-zA-Z])(.*[0-9])$/.test(value);
    return result;
};
var validateAge = function(validations, t, refDate) {
    var ErrorMessageComponent = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, errorMessage = arguments.length > 4 ? arguments[4] : void 0;
    return [
        {
            validator: function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function(_, value) {
                    var dob, ageByYear0Validation, ageByDay0Validation, ref, ref1, ageByYear0, min, max, validErrorMessage, ref2, ref3, age, min1, max1, validErrorMessage1;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        if (value) {
                            dob = (0,date/* formatDateText */.Kb)(value);
                            ageByYear0Validation = validations === null || validations === void 0 ? void 0 : validations.find(function(validation) {
                                return validation.rule === input/* RULE_CODE.AGE_BY_YEAR_0 */.n.AGE_BY_YEAR_0;
                            });
                            ageByDay0Validation = validations === null || validations === void 0 ? void 0 : validations.find(function(validation) {
                                return validation.rule === input/* RULE_CODE.AGE_BY_DAY_0 */.n.AGE_BY_DAY_0;
                            });
                            if (ageByYear0Validation) {
                                ;
                                ageByYear0 = calcAgeByYear0(refDate, dob);
                                min = (ageByYear0Validation === null || ageByYear0Validation === void 0 ? void 0 : (ref = ageByYear0Validation.params) === null || ref === void 0 ? void 0 : ref.min) || 0;
                                max = (ageByYear0Validation === null || ageByYear0Validation === void 0 ? void 0 : (ref1 = ageByYear0Validation.params) === null || ref1 === void 0 ? void 0 : ref1.max) || Infinity;
                                if (ageByYear0 < min || ageByYear0 > max) {
                                    validErrorMessage = errorMessage || genErrorMessage(t("form:validation.invalidAge"), ErrorMessageComponent);
                                    return [
                                        2,
                                        Promise.reject(validErrorMessage)
                                    ];
                                }
                            }
                            if (ageByDay0Validation) {
                                ;
                                age = calcAgeByDay0(refDate, dob);
                                min1 = (ageByDay0Validation === null || ageByDay0Validation === void 0 ? void 0 : (ref2 = ageByDay0Validation.params) === null || ref2 === void 0 ? void 0 : ref2.min) || 0;
                                max1 = (ageByDay0Validation === null || ageByDay0Validation === void 0 ? void 0 : (ref3 = ageByDay0Validation.params) === null || ref3 === void 0 ? void 0 : ref3.max) || Infinity;
                                if (age < min1 || age > max1) {
                                    validErrorMessage1 = errorMessage || genErrorMessage(t("form:validation.invalidAge"), ErrorMessageComponent);
                                    return [
                                        2,
                                        Promise.reject(validErrorMessage1)
                                    ];
                                }
                            }
                        }
                        return [
                            2,
                            Promise.resolve()
                        ];
                    });
                });
                return function(_, value) {
                    return _ref.apply(this, arguments);
                };
            }()
        }, 
    ];
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,8898,8307,8234,4456,1747,9782,7572,9953,7752,1509,3917,3640,6322,768,8837,5865,3247,5518,1549,6519,3436,8792,1469,1173,6422,9374,5904,7751,9351,531,9474,3570,1255,9774,2888,179], function() { return __webpack_exec__(98005); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);